import React, { Component, lazy, Suspense } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin, Modal, message, Button, Input } from 'antd';
import intl from 'react-intl-universal';
import cuid from 'cuid';
import _throttle from 'lodash/throttle';
import _get from 'lodash/get';
import autoBindReact from 'auto-bind/react';
import { cookies } from 'Api/index';

import { showAiPanel } from 'Components/viewer/domOperate/aiPanel';
// import { getFileBufferByUrl, convertApis, clientApi, lmsApi, DATA_TYPE } from 'Api/index';
import { convertApis, clientApi, lmsApi, DATA_TYPE } from 'Api/index';
import BottomAd from 'Components/BottomAd/BottomAd';
import FwDocsIframe from '@/components/fwDocsIframe/fwDocsIframe'; //TODO FOXIT 内嵌云文档
import FwDocs from '@/components/fwDocs/fwDocs'; //TODO FOXIT 云文档
import FwRegisterSaveSuccess from '@/components/fwRegisterSaveSuccess/fwRegisterSaveSuccess'; //TODO FOXIT 保存登记表成功弹框
// import FwLogin from 'Components/fwLogin/fwLogin'; //TODO FOXIT sso登录弹框
import FwConvertModal from '@/components/fwConvertModal/fwConvertModal'; //TODO FOXIT 转换弹框
// import FwOpenMemberModal from '@/components/fwOpenMemberModal/fwOpenMemberModal'//TODO FOXIT 开通会员弹框
import FwConvertImgType from '@/components/fwConvertImgType/fwConvertImgType'; //TODO FOXIT PDF转图片类型选择弹框
import HomePage from '@/components/fwComponents/homePage'; //!主要内容
import ShareErrorMask from '@/components/fwComponents/shareErrorMask';
import CloudShare from '@/components/fwComponents/cloudShare';
import AdvertDialog from '@/components/fwComponents/advertDialog'; // 广告
// import HomeComponent from 'Components/Home/Index'

import CollaborationViewerDom from 'Components/viewer/ui/ViewerTemplate/ViewerDom/CollaborationViewerDom';
import { LinkResourceForCanvas, MissFileTip } from 'Pages/index';
import FloatBall from 'Components/FloatBall/FloatBall';
import { onDragAiPanel } from 'Components/viewer/domOperate/aiPanel';
import './viewer.scss';
import { default as customUIFns, bindViewerButtons } from './ui/index';
import { store } from 'Store/store.index';
import { BOTTOM_AD_SHOWED /* HAS_USED_FOXIT_SIGN */ } from '../../constants/local.constant';
import { PLUGIN_URLS } from '../../constants/account.constant';
import {
  BROWSER_REMOVE_FOR_OFFICE_ADD_IN,
  GET_IS_EDU_SUCCESS,
  USER_SIGN_IN_SUCCESS,
  USER_UPDATE_SUBSCRIPTION,
  FW_USER_LOGIN_IN_SUCCESS,
} from 'Store/constants';
import { GOOGLE_DRIVE, ONE_DRIVE, BOX, DROP_BOX, iManage } from 'Api/drives.constants';
import { convertController, fileController, preferenceFullScreenController } from './Controllers/index';
import * as APP_CONSTANTS from 'Constants/app.constant';
import { isSignInDrive, signIn, signOut } from 'Api/drives.api';
import { EsignTools } from '@components/viewer/esignTools/index.js';
// import withFocusLoop from '../Aria/FocusLoop';
import { collaborationApi, baseUrlApis } from 'Api/index';
import {
  createDeferred,
  isCanvas,
  isNeedReLoginDrive,
  decryptAES,
  isFromFoxitWebsite,
  isFromOfficeAddIn,
  setLocalStorageUserMapValue,
  getLocalStorageUserMapValue,
} from 'Utils/utils';

import {
  MY_ACCOUNT,
  SUBSCRIBE,
  PERMISSION_BY_DASHBOARD_LIMIT,
  PERMISSION_BY_DASHBOARD_LIMIT_SUBSCRIPTION,
} from 'Components/viewer/ui/constants/user.more.constants';
import { CONVERT_MAP } from 'Components/viewer/ui/constants/convert.constants';
import { VerifySignature, FormFieldsFound, ProtectedViewState, PdfADocument, NoCountry, hasUsData } from '../dialogs/MessageCenter/Type';

import {
  ExportImagesDialog,
  MessageDialog,
  ToDoMessageDialog,
  PreferencesDialog,
  ExportFormDataDialog,
  AboutFoxitDialog,
  TermsChangeMessageDialog,
  CompareDialog,
  MessageCenter,
  PageTransitionsDialog,
  PluginInstallDlg,
  CompareResult,
  DigitalIDsDialog,
} from '../dialogs/index';
import { DialogContainer, DLG_TARGETS } from './EditorDialogsContainer';
import { FLOAT_PAGE_NUMBER } from './ui/constants/common.constants';
import { ADD_COMMENT, EDIT_PDF, SHARE_DOC, ORGANIZE_PDF, OPEN_FILE, ESIGN_CHINA_PDF } from './ui/constants/other.constants';
import {
  OPEN_FILE_LOCAL,
  OPEN_FILE_FROM_URL,
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,
  OPEN_FILE_FROM_GET_START_GUID,
  OPEN_FILE_FROM_RECENT,
  OPEN_FILE_FROM_DOCUMENTS,
  OPEN_FILE_FROM_IMANAGE,
} from './ui/constants/openfile.constants';
import {
  SAVE_TO_LOCAL,
  SAVE_TO_DOWNLOAD,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_AS_FILE,
  SAVE_TO_FILE_CLASS_TOOLBAR,
  SAVE_TO_GOOGLE_DRIVE_CLASS_32,
  SAVE_TO_LOCAL_CLASS_TOOLBAR,
  SAVE_TO_ONE_DRIVE_CLASS_32,
  SAVE_TO_BOX_CLASS_32,
  SAVE_TO_DROPBOX_CLASS_32,
  SAVE_FILE_BTN_HIDDEN_SLOT,
  SAVE_TO_IMANAGE,
  SAVE_TO_IMANAGE_CLASS_32,
  SAVE_TO_FOXIT_STORAGE,
  SAVE_TO_FOXIT_STORAGE_CLASS_32,
} from './ui/constants/savefile.constants';
import { PE_PLUGIN_ADD_TEXT } from './ui/constants/plugin.constants';
import {
  FEEDBACK,
  FOXIT_SOFTWARE,
  EDU_EXCLUSIVE,
  HELP_CENTER,
  FOXIT_PLUG_INS,
  UPDATE_LOGS,
  DOWNLOAD_CLIENT,
  ESIGN_CN_FEEDBACK,
} from './ui/constants/help.constants';
import {
  /* AGREEMENT_STATUS, */
  REQUEST_SIGNATURE,
  MANAGE_SIGNATURE,
  APPLY_ALL_SIGNATURE,
  DOCUMENT_STATUS,
  CLOSE_SIGN,
  FILL_SIGN_BUTTON_HOME,
  ADD_TEXT,
  FILL_SIGN_ADD_TICK,
  FILL_SIGN_ADD_CROSS,
  FILL_SIGN_ADD_LINE,
  FILL_SIGN_ADD_DOT,
  FILL_SIGN_ADD_RECTANGLE,
  SET_PREDEFINED_TEXT,
  SWITCH_ACCOUNTS,
} from './ui/constants/fill_sign.constants';
import { PROTECT_CERTIFICATE_PROTECT } from './ui/constants/protect.constants';
import {
  CONVERT_FILES_TO_PDF,
  // CREATE_BLANK_PDF,
  CONVERT_NEW_PORTFOLIO,
  CONVERT_COMBINE_FILES,
  // CONVERT_FROM_TEMPLATE,
  OCR_QUICK_RECOGNITION,
  CONVERT_PREFLIGHT,
} from './ui/constants/convert.constants';
import {
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_IMG,
  EXPORT_ALL_IMG,
  OCR_PDF_TO_PDF,
  // CONVERT_TO_PDF
} from './ui/constants/fw.convert.constants'; //TODO FOXIT 转换
import { HELP_CUSTOMER_SERVICE, HELP_ABOUT, HELP_OPEN_MEMBER, HELP_EXCHANGE_MEMBER } from './ui/constants/fw.help.constants'; //TODO FOXIT 转换
import {
  FORM_RESET_FIELD,
  FORM_ADD_TOOLTIP,
  FORM_COMBINE_FORMS_TO_SHEET,
  FORM_HIGHLIGHT_FIELDS,
  FORM_KEEP_TOOL_SELECTED,
  FORM_RECOGNITION_FORM,
  FORM_CREATE_TEXT_FIELD,
  FORM_CREATE_SIGN_FIELD,
  FORM_CREATE_RADIO_BTN_FIELD,
  FORM_CREATE_PUSH_BTN_FIELD,
  FORM_CREATE_CHECK_BOX_FIELD,
  FORM_CREATE_COMBO_BOX_FIELD,
  FORM_CREATE_LIST_BOX_FIELD,
  FORM_CREATE_IMAGE_FIELD,
  FORM_CREATE_DATE_FIELD,
} from './ui/constants/form.constants';
import {
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
  ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
  ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
  ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
  ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
  ORGANIZE_TAB_PAGE_REVERSE,
  HOME_TAB_PAGE_ROTATE_LEFT,
  HOME_TAB_PAGE_ROTATE_RIGHT,
  HOME_TAB_PAGE_ROTATE,
} from './ui/constants/organize.constants';
import {
  DOCUMENT_LOADED,
  DOCUMENT_LOAD_FAILED,
  DOCUMENT_SAVED,
  //DOCUMENT_DURATION,
  //DOCUMENT_SAVE_FAILED,
} from 'Components/viewer/ui/constants/event.constants';

import { USER_FROM_WEBSITE_LINK, USER_FROM_DIRECT_LINK } from 'Components/viewer/ui/constants/event.constants.share';

import {
  SIDEBAR_PUBLISH_REPLY,
  SIDEBAR_ADD_REPLY,
  SIDEBAR_MOVE_PAGE,
  SIDEBAR_SEARCH_TEXT,
  SIDEBAR_SET_WHOLE_WORD,
  SIDEBAR_SET_CASE_SENSITIVE,
  SIDEBAR_VIEW_SEARCH,
  SIDEBAR_THUMBNAIL_PAGE_TRANSITIONS,
} from './ui/constants/sidebar.constants';
import { HOME_SINGLE_PAGE, HOME_CONTINUOUS, HOME_CHANGE_MODE, HOME_PRINT } from './ui/constants/home.constants';
import {
  //FILE_TAB_GROUP_FILE_OPTIMIZER,
  VIEW_TAB_COMPARE,
  CREATE_NEW_ACTION,
  RUN_ACTION,
  MANAGE_ACTIONS,
} from './ui/constants/file.constants';
import { EDIT_TEXT, EDIT_TEXT_FONT, EDIT_TEXT_SIZE, EDIT_ADD_ARTICLE, FW_DOWNLOAD_FILE_BUTTON } from './ui/constants/edit.constants';
import { HAND_TOOL } from './ui/constants/common.constants';
import {
  DRAG_FILE_TO_OPEN,
  DOC_PROP_IS_PASSWORD_PROTECTED,
  //DOC_PROP_PDF_STANDARD,
  DOC_PROP_IS_TAGGED,
  DOC_PROP_DOCUMENT_SIZE,
} from 'Components/viewer/ui/constants/other.constants';
import { READ_MODE_DOWNLOAD_FILE, READ_MODE_PRINT } from 'Components/viewer/ui/constants/view.constants';
import {
  COMMON_BUTTONS,
  FILE_SELECTOR_INNER,
  COMMON_BUTTONS_MOBILE,
  //SIDEBAR_COMMENT_LIST,
  SIDEBAR_COMMENT_CARD_LIST,
  //SIDEBAR_COMMENTS_ACTION_LIST,
  PRIVATE_STORAGE_BTNS,
  addAutoNameBuiltIn,
  isBuiltIn,
  //isForFree,
  isForConvert,
  // isFileSelector,
  BUTTONS_BY_PERMISSION,
  isAnnotTooltip,
} from './ui/constants/index';
import { isMobile, isMacSsoNoIos, isFirefox } from 'Utils/device';
import { COLLABORATION_MODE, COLLABORATION_HEADER, LICENSE_PROTECT } from '@/constants/index';
import {
  COMMENT_ADD_STAMP,
  COMMENT_ADD_CUSTOM_STAMP,
  COMMENT_ADD_PENCIL_TOOL,
  COMMENT_ADD_TYPEWRITER,
  COMMENT_EXPORT_WORD_BUTTON,
} from './ui/constants/comment.constants';
import { PE_PLUGIN_ALL_BTNS } from './ui/constants/plugin.constants';
import {
  USER_ENTRY_SIGN_IN,
  USER_ENTRY_SIGN_UP,
  USER_SWITCH_LANGUAGE,
  USER_SWITCH_LANGUAGE_,
  USER_GOTO_ADMIN_CONSOLE,
  USER_GOTO_EXIT,
  USER_TERMS,
  USER_POLICY,
  USER_ACCOUNT,
  OPEN_FILE_FROM_URL_MOBILE,
} from './ui/constants/mobile.constants';
import { ROTATE_RIGHT, ROTATE_LEFT } from './ui/constants/float_bar.constants';
import { initializeViewerComponents, doUpdateFileSelectorController } from './ui/ViewerComponents/index';
import { permissionManager } from './ui/PermissionManager/PermissionManager';

import { collaborationMqttService } from 'Store/services/index';
import {
  loadScript,
  getBaseUrl,
  getQueryVariable,
  getFileNameByUrl,
  isCNDomain,
  isPdfOnlineDomain,
  isCommonFeatureDomain,
  isJPDomain,
  colorToAARRGGBB,
  trimEnd,
  getDOMTokenListValue,
  windowActionFn,
  storageSetItem,
  storageGetItem,
  storageRemoveItem,
  isMore20201231,
  getPrivacyPolicyUrl,
  getTermsOfServiceUrl,
  getContainerHeight,
  getDocumentViewMode,
  getElementByIconClass,
  createPerformanceNode,
  cutomPageRender,
  getCompareResultStrings,
  getDefaultCompareOptions,
  getFileNameWithoutExtension,
  getFromDriveNameForSharePoint,
} from 'Utils/utils';
import utils from '@foxit/utils';
import { isIE, isSafari } from 'Utils/browser-info';
import { getUserInfo } from 'Api/fwApi/login';
import { FOXITWEBSDK_URLS } from 'Api/constants';
import {
  eSignChinaService,
  pdfViewerService,
  sharePointService,
  localToGlobal,
  browserService,
  thirdPartyService,
  convertService,
} from '@/store/services/index';
import Dropzone from 'react-dropzone';
import Welcome from 'Components/Welcome/Welcome';
import NPSSurvey from 'Components/Survey/NPSSurvey/NPSSurvey';
import { AiPluginController } from './AIPlugin/index';
import { getKeymap } from './shortcuts/keymap';
import menuContainer from './menuContainer.ts';
import { checkStatusAndPrintPerformanceData } from '@/utils/performance-measurement';
import { ATTACH_FILE_SIZE_LIMIT, TEAMS_UPLOAD_FILE_SIZE_LIMIT } from '@/limit.constant';
import { passwordProtectSaveSecurityPolicy } from '../dialogs/SecurityPolicies/utils';
import FwSaveModal from '@/components/fwComponents/fwSaveModal';
// TODO FOXIT 云编辑添加方法或弹窗
import SubscriptionMember from '@/components/fwComponents/subscriptionMember';
import AbnormalAccountDialog from '@/components/fwComponents/abnormalAccountDialog';
import NoPdfDialog from '@/components/fwComponents/NoPdfDialog';
import LoginLoseDialog from '@/components/fwComponents/loginLose';
const FwMobileFooter = lazy(() => import('@/components/fwMobileComponents/fwMobileFooter'));
const FwMobileHomeBox = lazy(() => import('@/components/fwMobileComponents/fwMobileHomeBox'));
const FwMobileHead = lazy(() => import('@/components/fwMobileComponents/fwMobileHead'));
const FwMobilePageDialog = lazy(() => import('@/components/fwMobileComponents/fwMobilePageDialog'));
const FwMobileDocs = lazy(() => import('@/components/fwMobileComponents/fwMobilePopupFile/fwMobileDocs'));
if (isMobile) {
  import('@/components/fwMobileComponents/fwMobileStyle/fwMobile.scss');
}
//  else {
//   import("./viewer.icons.scss")
// }
// EsginChinaGallery
const EsginChinaGalleryTool = lazy(() => import('Components/EsignChina/gallery-tool'));
import { TAB_NAME_MAP, FieldType } from '../SignatureListContainer/constants';
import { toJS } from 'mobx';

import SaveBtn from 'components/viewer/ui/save/saveButton.js';
import FileTab from './RibbonTabAdapter/FileTab.tsx';
import ConvertTab from './RibbonTabAdapter/ConvertTab.tsx';
import OrganizeTab from './RibbonTabAdapter/OrganizeTab.tsx';
import ProtectTab from './RibbonTabAdapter/ProtectTab.tsx';
import EditTab from './RibbonTabAdapter/EditTab.tsx';

import PaperCheckContainer from '@/components/PaperCheck/PaperCheckContainer';

// import PasteFieldConfirmDialog from '../dialogs/PasteFieldConfirmDialog';
const SignatureListContainer = lazy(() => import('Components/SignatureListContainer/SignatureListContainer'));
import wrapDialog from '@/routes/wrapperDialog';
import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';
import doDownloadClient from '../utils/downloadDesktop';
import { hideFullScreen } from '@/modules/utils';
import { getValidateCookieAccessToken, getCloudCookie, getReaderCookie } from '@/api/fwApi/webapi';
import { GoogleDriveFlow } from './thirdPartyFlow/GoogleDriveFlow';
import { SharepointAndOneDriveFlow } from './thirdPartyFlow/SharepointAndOnedriveFlow';
// import "./UIExtensionInit.scss"
import dialogBuilder from './DialogBuilder';
import { WEBPLUGIN_LOAD_BEHAVIOR_APPINITFINISH, WEBPLUGIN_LOAD_BEHAVIOR_FILEOPEN } from 'Constants/app.constant';

const RecoginizeText = lazy(() => import('Components/dialogs/RecoginizeText/RecoginizeText'));

const TermBegin = lazy(() => import('@/components/Activities/TermBegin/TermBegin'));
const RecordDialog = lazy(() => import('Components/dialogs/Record/RecordDialog'));
const FoxitPlugIns = lazy(() => import('Components/FoxitPlugInsDlg/FoxitPlugInsDlg'));

const ColorPicker = lazy(() => import('Components/ColorPicker/ColorPicker'));
const PasteFieldConfirmDialog = lazy(() => import('Components/dialogs/PasteFieldConfirmDialog'));
const PluginCommonDialog = lazy(() => import('Components/dialogs/PluginCommonDialog/Plugin.dialog'));
// const StorageDuplicateFileDialog=lazy(()=>import('Components/Storage/StorageDuplicateFileDialog'))

const UIXAddons = {};

const defaultSignCompareConfig = {
  progress: 0,
  status: 'comparing',
  docId: '',
  hide: null,
};

const isCollabURL = () => {
  const reviewSessionID = getQueryVariable('reviewSessionID');
  const fileLink = getQueryVariable('docUrl');
  const fileName = getQueryVariable('fileName');
  return reviewSessionID && fileLink && fileName;
};

const getRefDlgCfg = (dlg, ref) => {
  return {
    messageDlgCfg: {
      target: dlg,
      config: { ref },
    },
  };
};

// const Home = withFocusLoop(HomeComponent);

function loadWorker(licenseSN, licenseKey, l, isLite = false) {
  if (isLite) fileController.fullFeature = 0;
  let opt = {
    workerPath: FOXITWEBSDK_URLS.workerPath,
    enginePath: './jr-engine/gsdk',
    fontPath: FOXITWEBSDK_URLS.fontPath, //  '../external/brotli',
    licenseSN: licenseSN,
    licenseKey: licenseKey,
    l: l,
    version: window.__hashVersion__,
    fontServer: '../external/fonts',
  };
  if (process.env.NODE_ENV == 'development') {
    opt.brotli = { core: false };
  }
  let readyWorker = null;
  if (window.preloadJrWorker) {
    readyWorker = window.preloadJrWorker(opt);
    window.readyWorker = readyWorker;
  } else {
    let jrWorker = setInterval(() => {
      if (window.preloadJrWorker) {
        readyWorker = window.preloadJrWorker(opt);
        window.readyWorker = readyWorker;
        clearInterval(jrWorker);
      }
    }, 1000);
  }
}

function loadViewer(callback, licenseSN, licenseKey, l) {
  let beginTime = new Date().getTime();
  console.log('loadViewer begin:' + beginTime);
  //return; // only home page
  window.__start_sdk_time__ = Date.now();
  import(/* webpackChunkName: "viewer.icons.scss" */ './viewer.icons.scss')
    .then((/*data*/) => {
      //callback && callback(data);
    })
    .catch((err) => {
      console.error('TCL: loadViewer ./viewer.icons.scss -> err', err);
    });
  loadWorker(licenseSN, licenseKey, l, isCollabURL());

  function loadByOrder() {
    console.log('loadByOrder begin');
    console.log(FOXITWEBSDK_URLS.UIExtension);
    loadScript(FOXITWEBSDK_URLS.UIExtension)
      .then(() => {
        const Log = window.UIExtension.PDFViewCtrl.Log;
        Log.setLogLevel(Log.LEVELS.LEVEL_ERROR);
        let addonsValue = getQueryVariable('addons');
        if (addonsValue !== null) {
          callback(window.UIExtension);
          return;
        }
        console.log('loadByOrder begin addons');
        console.log(FOXITWEBSDK_URLS.addons);
        loadScript(FOXITWEBSDK_URLS.addons)
          .then(() => {
            console.log(window.UIExtension);
            callback(window.UIExtension);
            let endTime = new Date().getTime();
            console.log('loadViewer end use Time' + (endTime - beginTime));
          })
          .catch((err) => {
            console.error('TCL: loadViewer -> err', err);
          });
      })
      .catch((err) => {
        console.error('TCL: loadViewer -> err', err);
      });
  }
  function loadConcurrently() {
    const task = [loadScript(FOXITWEBSDK_URLS.UIExtension)];
    let addonsValue = getQueryVariable('addons');
    if (!addonsValue) {
      task.push(loadScript(FOXITWEBSDK_URLS.addons));
    }

    Promise.all(task)
      .then(() => {
        const Log = window.UIExtension.PDFViewCtrl.Log;
        Log.setLogLevel(Log.LEVELS.LEVEL_ERROR);
        callback(window.UIExtension);
      })
      .catch((err) => {
        console.error('TCL: loadViewer -> err', err);
      });
  }
  if (true) {
    loadByOrder();
  } else {
    // 如果SDK8.4完成addons打包优化，可以启用这个流程
    loadConcurrently();
  }
}

function composeUI(callback, isOnPremiseDeployMode) {
  let fragmentsSet = [];
  let templates = void 0;

  if (customUIFns) {
    for (let i = 0; i < customUIFns.length; i++) {
      let result = customUIFns[i](callback, isOnPremiseDeployMode);
      const { fragments } = result;
      if (result && result.template) {
        templates = result;
      }
      fragmentsSet.push(...fragments);
    }
  }
  let callbacks = bindViewerButtons(callback, (error) => {
    console.error('TCL: callbacks -> error', error);
  });
  fragmentsSet.push(...callbacks);

  return { fragments: fragmentsSet, fullTemplate: templates.template, toolbar: templates.toolbar, collabTemplate: templates.collab };
}

function useIdleCallback(fn) {
  let handle = (window.requestIdleCallback || setTimeout)(() => {
    fn();
    if (window.requestIdleCallback) cancelIdleCallback(handle);
  });
}

const doAction = (id, fileName, time, event, lastEvent, isEmit) => {
  const vTest = getQueryVariable('test');
  if (vTest === 'performance') {
    createPerformanceNode(id, fileName, time);
  }
  if (!event) {
    event = id;
  }
  if (isEmit) {
    window.__vtest_performance && window.__vtest_performance(event);
    store.appStore.emitEvent(event);
  }
  store.appStore.sendPerformanceInfo({ id, fileName, time, event, lastEvent, isEmit });
};

@inject(
  'appStore',
  'driveStore',
  'homePageStore',
  'privateDriveStore',
  'taskStore',
  'userStore',
  'collaborationStore',
  'loginNewStore',
  'userNewStore',
  'saveFileNewStore',
  'addCoverPageStore',
)
@observer
class EditorContainer extends Component {
  constructor(props) {
    super(props);
    if (process.env.NODE_ENV === 'development') {
      window._eci = this;
    }
    autoBindReact(this);

    if (process.env.NODE_ENV == 'development') {
      window._eci = this;
    }

    defaultSignCompareConfig.hide = this.onCloseModalDlg;

    this.CombineFilesTitle = intl.formatMessage({ id: 'CombineFiles.Modal.Title' });
    this.compareDialogRef = React.createRef();
    this.createNewActionDialogRef = React.createRef();
    this.runActionDialogRef = React.createRef();
    this.manageActionsDialogRef = React.createRef();
    this.pageTransitionsDialogRef = React.createRef();
    this.recordDialogRef = React.createRef();
    this.pasteFieldConfirmDialogRef = React.createRef();
    this.ESignChinaGalleryToolRef = React.createRef();
    this.state = {
      l: LICENSE_PROTECT,
      pdfui: null,
      openFileTwo: false,
      loadingSDK: APP_CONSTANTS.LOADING_SDK_STATUS.NONE, // none begin end
      fileName: null,
      isOpenFileForShare: false,
      isShowGlobalSpin: false,
      isShowBottomAd: true,
      isFloatBarPinned: false,
      isShowHtml2PDFDlg: false,
      isShowGetStartGuid: false,
      docPageCount: 0,
      currentPageIndex: 0,
      isShowWatermarkDlg: false,
      // isShowOpenFilePanel: false,
      isShowDrivesListDlg: false,
      // isShowWelcome: false,
      isShowDropFileHere: false,
      drivesListDlgType: '',
      brokenFileList: [],
      openFileActiveTabKey: '0',
      saveFileActiveTabKey: 0,
      pageViewerHistory: [1],
      currentPageViewerIndex: null,
      isPageViewerBtn: false,
      goPreviousViewTimer: null,
      goNextViewTimer: null,
      showDlgTarget: '', // ORGANIZE_TAB_FLATTEN
      // Combine Files
      // Drives
      showDrives: false,
      driveOperateType: '',
      driveName: '',
      drivesCustomInfo: null,
      convertInfo: {
        url: '',
        fileName: '',
        taskType: -1,
        saveTo: '',
      },
      messageDlgCfg: {
        msg: { id: '' },
        onOk: null,
        onClose: null,
      },
      layer2Msg: {
        msg: { id: '' },
        onOk: null,
        onClose: null,
      },
      messageDlgFileProperties: {
        info: { id: '' },
        onClose: null,
      },
      viewerBodyHeight: `${window.innerHeight - getContainerHeight()}px`,
      robationMessageDlgCfg: {
        msg: { id: '' },
        onOk: null,
        onClose: null,
      },
      notifyMessageDlgCfg: {
        msg: { id: '' },
        onOk: null,
        onClose: null,
      },
      isPopNotifyMessageDlg: false,
      portfolioNodeDataForReduceFileSize: null,
      convertError: false,
      convertErrorByAppendWebLinks: false,
      messageCenterConfig: {
        close: this.closeMessageCenterDlg,
        messages: [],
        doNotShowAgainChecked: false,
      },
      isClearMessageCenter: false,
      isShowMessageCenter: false,
      pdfaEditable: false,
      openURL: '', // !打开远程文档
      pageScroll: false, // 移动端滚动时间
      showMobileFooter: true,
      pageCurrentIndex: '',
      pageAllIndex: 0,
      goMobilePageIndex: '',
      openCPDFTocllaboration: false,
      showURLInputDialogLoading: false,
      isShowCustomerServiceDlg: false,
      loadViewerEnd: false,
      isShowCompareResult: false,
      compareResultConfig: {
        progress: 0,
        status: 'comparing',
        docId: '',
        hide: this.hideCompareResultDialog,
      },
      showEsignChinaGalleryTool: false,
      isShowSignatureListContainer: false,
      signatureListContainerDomInWebSdk: null,
      showColorPicker: false,
      //esign
      showSignType: false,
      getSubscribeStateFailed: false,
      //canvas
      hasLoginForCanvasPlatform: false,
    };

    this.viewerRef = React.createRef();
    this.fileTabRef = React.createRef();
    this.convertTabRef = React.createRef();
    this.protectTabRef = React.createRef();
    this.signatureListContainerRef = React.createRef();
    window.onShowToSaveBeforeOpen = this.onShowToSaveBeforeOpen;

    this.pdfuiInitialized = createDeferred();
    store.appStore.setShowToSaveBeforeOpen(this.onShowToSaveBeforeOpen);
    store.appStore.setOnShowToDoDlg(this.onShowToDoDlg);
    store.appStore.setOnShowWarningMessage(this.onShowWarningMessage);
    store.appStore.setIsDisableButton(this.isDisableButton);
    store.appStore.setCommonForSaveDrives(this.commonForSaveDrives);
    store.appStore.setDoShowEditorLoading(this.doShowEditorLoading);
    store.appStore.setDoHideEditorLoading(this.doHideEditorLoading);
    store.appStore.setCloseMessageCenterDlg(this.closeMessageCenterDlg);
    store.foxitSignStore.setShowSwitchAccountsDlg(this.showSwitchAccountsDlg);
    store.homePageStore.setPdfUiInit(this.doInitializePDFViewerUI);
    localToGlobal.setSwitchWorker(this.switchWorker);
    store.appStore.setAddMessage(this.addMessage);
    store.collaborationStore.setShowDownLoadPanel(() => {
      this.onFinishSaveSuccess();
      this.onCloseSaveFilePanel();
    });
    localToGlobal.setOnCloseSaveFilePanel(this.onCloseSaveFilePanel);

    this.fn_Throttle_ScrollPageNumber = this.onThrottle_ScrollPageNumber();
    window.onShowWarningMessage = this.onShowWarningMessage;
    this.viewerActionMap = {};
    this.targetTab = '';
  }
  waitForUserSubscribeInfo = async () => {
    const subscribeInfo = await store.userStore.hasSubscribePermission();

    if (subscribeInfo === 0) {
      this.setState({
        getSubscribeStateFailed: true,
      });
      store.appStore.setGlobalMessage({ type: 'error', content: intl.get('subscription.error.GetSubscriptionInfoFailed') });
    }

    // check for share file
    this.checkPermissionForShareFile();
  };
  async componentDidMount() {
    const fromFoxitWebsite = isFromFoxitWebsite();
    if (fromFoxitWebsite) {
      store.userStore.doSendGAEventByUser({ eventKey: USER_FROM_WEBSITE_LINK, label: 'user_subscribe' });
    } else {
      store.userStore.doSendGAEventByUser({ eventKey: USER_FROM_DIRECT_LINK, label: 'user_subscribe' });
    }

    // 当链接带有分享参数/cloudShare时，我们需要处理 协同逻辑
    if (window.location.href.includes('/cloudShare/') && !this.state.openCPDFTocllaboration) {
      this.joinShareCollaboration();
      this.setState({
        openCPDFTocllaboration: true,
      });
    }
    // 这个方法统一处理登录逻辑；
    this.foxitLogin();
    // 添加页面显示是判断
    this.changePageStatus(() => {
      this.getUserInfo();
      // store.userNewStore.userInfo();
    });
    // 判断登录后删除登录的标识
    if (!isMobile) {
      this.firstEvent();
    }
    window.sessionStorage.removeItem('firstPageLogin');

    const fileParams = getQueryVariable('state');
    const { isFromShareLink, isFromServiceModeOfClient } = store.appStore;

    if (isCanvas()) {
      store.appStore.updateShowHomeStart(false);

      const lmsFn = async () => {
        const showCanvasLinkResDialog = getQueryVariable('isCanvasPlatformLinkResource') === 'y';
        if (showCanvasLinkResDialog) {
          this.setState({
            messageDlgCfg: {
              target: LinkResourceForCanvas,
              config: {
                haslogin: this.state.hasLoginForCanvasPlatform,
              },
            },
          });
        }

        const lmsKey = getQueryVariable('key');
        const token = store.userStore.token;
        const curFileSettingRes = await lmsApi.getDataFromPlatform({ token, key: lmsKey });
        if (curFileSettingRes.message.toLowerCase() === 'success' && curFileSettingRes.data.postData) {
          console.log('lms_cur_file_info->', curFileSettingRes.data.postData);
          localStorage.setItem('lms_cur_file_info', JSON.stringify(curFileSettingRes.data.postData));
        }

        let lmsSelFile = '';
        if (window.location.href.includes('lmsSelFile')) {
          lmsSelFile = getQueryVariable('lmsSelFile');
        } else if (_get(curFileSettingRes, 'data.postData.lmsSelFile')) {
          lmsSelFile = _get(curFileSettingRes, 'data.postData.lmsSelFile');
        }
        if (lmsSelFile) {
          store.appStore.showLoadingWithMsg({ show: true, msg: 'Loading.file' });
          // canvas 将加密字符串中的+替换成了空格
          lmsSelFile = lmsSelFile.replaceAll(' ', '+');
          const fileInfo = JSON.parse(await decryptAES(lmsSelFile, 'abcdefg123456789', ''));
          const { driveName, item, refreshCode } = fileInfo;

          console.log('refresh code in fileinfo url old      ->', refreshCode);
          console.log('refresh code in fileinfo url replace+ ->', refreshCode.replaceAll(' ', '+'));
          await store.driveStore.initTokenByRefreshToken({ driveName, refreshToken: refreshCode.replaceAll(' ', '+') });

          let fileData = null;
          try {
            console.log('is need relogin when open', isNeedReLoginDrive());
            if (isNeedReLoginDrive()) {
              localStorage.setItem('only-sign-in-drive', '1');
              this.setState({
                messageDlgCfg: {
                  target: LinkResourceForCanvas,
                  config: {
                    haslogin: true,
                  },
                },
              });
            } else {
              localStorage.setItem('only-sign-in-drive', '0');
            }

            const timer = setInterval(async () => {
              if (!window.pdfui && this.state.loadingSDK !== APP_CONSTANTS.LOADING_SDK_STATUS.END) return;
              if (isNeedReLoginDrive()) return;
              clearInterval(timer);
              console.log('init pdfUI sdk success');
              fileData = await convertService.doGetCloudDriveFileBuffer({ file: { driveName, item } }, DATA_TYPE.FileBuffer, cuid(), item.modifiedTime);
              console.log('get file data success from drive-->', fileData);
              await window.pdfui.openPDFByFile(fileData.file, { fileName: fileData.fileName });
              console.log('open file success');
              window.localStorage.setItem('lms_cur_file_info', JSON.stringify({ driveName, ...curFileSettingRes.data.postData, ...item }));

              // remove unused ui
              const unuseComps = ['stamp-ribbon-dropdown', 'create-stamp-button-list'];
              if (window.pdfui) {
                for (const compName of unuseComps) {
                  const comp = await pdfui.getComponentByName(compName);
                  comp && comp.hide();
                }
              }
            }, 1000);
          } catch (e) {
            window.localStorage.setItem('lms_cur_file_info', JSON.stringify({ driveName, ...curFileSettingRes.data.postData, ...item }));
            store.appStore.showLoadingWithMsg({ show: false });
            this.setState({
              messageDlgCfg: {
                target: MissFileTip,
              },
            });
          }
        }
      };

      // online 需要重新登录下  store.userStore.initProcessNeedLogin('/');
      const lmsTimer = setInterval(() => {
        if (_get(store.appStore.phantomOnlineGlobalConfig, 'cwsApiUrl') && store.userStore.token) {
          clearInterval(lmsTimer);
          this.setState(
            {
              hasLoginForCanvasPlatform: true,
            },
            () => {
              lmsFn();
            },
          );
        }
      }, 1000);
    }

    if (isFromShareLink || (isFromServiceModeOfClient && !isSafari)) {
      store.appStore.updateShowHomeStart(false);
      isFromShareLink && store.appStore.updateIsShowCollaborationViewerDom(true);
    }
    if (fileParams) {
      this.doShowEditorLoading();
    }

    store.appStore.initVerifySignatureRule();
    store.appStore.initShowDocFormInfo();
    store.appStore.initPdfSignConfig();

    store.appStore.addAppEventListener(APP_CONSTANTS.GO_TO_HOME_PAGE, this.onGoToHomePage);
    store.appStore.addAppEventListener(APP_CONSTANTS.AI_SHOW_PLUGIN_PANEL, this.onShowAiPanel);
    store.appStore.addAppEventListener(APP_CONSTANTS.EVENT_USER_INITIALIZE_END, this.onFinishCheckUser);
    store.appStore.addAppEventListener(USER_UPDATE_SUBSCRIPTION, () => {
      this.hideComponentsByDashboard();
      this.hasUserNotify();
    });
    store.appStore.addAppEventListener(APP_CONSTANTS.TEXT_MARKUP_MORE_COLOR, () => {
      this.setState({
        showColorPicker: true,
      });
    });
    store.appStore.addAppEventListener('openFileWithAI', () => {
      this.onShowOpenFileDlg(OPEN_FILE);
    });

    store.appStore.addAppEventListener('has-sign-in-success', () => {
      this.setState({
        hasLoginForCanvasPlatform: true,
      });
    });
    store.appStore.addAppEventListener('close-lms-file-dlg', () => {
      this.onCloseModalDlg();
    });

    this.setState({
      loadingSDK: APP_CONSTANTS.LOADING_SDK_STATUS.BEGIN,
    });
    window.addEventListener('resize', this.onWindowResize);
    if (!window.pdfui) {
      try {
        const { licenseKey, licenseSN, l } = this.state;
        const showGlobalSpin = this.isShowGlobalSpinForInitWebSDK();

        if (showGlobalSpin) {
          this.setState({
            isShowGlobalSpin: true,
          });
        }
        // TODO FOXIT 云编辑PC端的脚本文件后置执行，先加载home页。
        // TODO FOXIT 其余端或协同云文档的进入时，默认直接加载。
        // const url = getQueryVariable('url')
        // const cloudShare = window.location.href.includes("/cloudShare/") && !this.state.openCPDFTocllaboration
        // const reviewSessionID = getQueryVariable('reviewSessionID')
        // const fileLink = getQueryVariable('docUrl')
        // if(isMobile || url || cloudShare || reviewSessionID || fileLink) {
        loadViewer(
          (UIExtension) => {
            window._UIExtension = UIExtension;
            this.setState({
              loadViewerEnd: true,
            });
            window._UIExtension = UIExtension;

            let $ = window.UIExtension.jQuery;
            const $uixStyles = $(`<link rel='StyleSheet' href='${FOXITWEBSDK_URLS.UIExtension.replace('full.js', 'css')}'></link>`);

            $(document.body).append(
              `<link rel='StyleSheet' href='${isMobile ? FOXITWEBSDK_URLS.addonsMobileStylePC : FOXITWEBSDK_URLS.addonsStylePC}'></link>`,
            );

            $uixStyles.on('load', () => {
              this.doInitializePDFViewerUI(UIExtension);

              this.pdfuiInitialized.resolve(window.pdfui);
            });

            $uixStyles.appendTo(document.body);
          },
          licenseSN,
          licenseKey,
          l,
        );
        // }
      } catch (error) {
        console.error('TCL: EditorContainer -> componentDidMount -> error', error);
        this.pdfuiInitialized.reject(null);
      }
      return;
    }
    //
    const fn = () => {
      window.pdfui.destroy();
      store.appStore.doUpdateDocModified(false);
      window.UIExtension = window._UIExtension;
      store.viewer.changeFileState(false);
      this.doInitializePDFViewerUI(window.UIExtension);
    };
    let node_pdfui = document.getElementById('pdf-ui');
    if (!node_pdfui) {
      fn();
      return;
    }
    window.pdfui
      .getRootComponent()
      .then((root) => {
        node_pdfui.appendChild(root.element);
        const { pdfui, hasOpenFile, docPageCount, currentPageIndex } = window.viewerStateCache;
        this.setState({ pdfui, docPageCount, currentPageIndex, loadingSDK: APP_CONSTANTS.LOADING_SDK_STATUS.END });
        store.viewer.changeFileState(hasOpenFile);
      })
      .catch(() => {
        fn();
      });
  }

  changePageStatus(funcShow = null) {
    let hidden, state, visibilityChange;
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
      state = 'visibilityState';
    } else if (typeof document.mozHidden !== 'undefined') {
      hidden = 'mozHidden';
      visibilityChange = 'mozvisibilitychange';
      state = 'mozVisibilityState';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
      state = 'msVisibilityState';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
      state = 'webkitVisibilityState';
    }

    document.addEventListener(
      visibilityChange,
      () => {
        if (document[state] === 'visible') {
          // 页面显示 调用的方法
          console.log(hidden);
          typeof funcShow === 'function' && funcShow();
        } else {
          // 页面隐藏 调用的方法
          typeof funcHide === 'function' && funcHide();
        }
      },
      false,
    );
  }

  firstEvent() {
    // 这个方法用于处理骨架屏页面登录后的数据回显。
    window.addEventListener(
      'message',
      (e) => {
        // let originName = 'https://sso.foxitreader.cn';
        let originName = isMacSsoNoIos || isSafari ? 'https://sso.foxitcloud.cn' : 'https://sso.foxitreader.cn';
        if (e.origin === originName && !e.data) {
          var head = document.head || document.getElementsByTagName('head')[0];
          var script = document.createElement('script');
          script.setAttribute('src', `${originName}/getCookies?v=${new Date().getTime()}`);
          head.appendChild(script);
          store.userNewStore.getUserNew();
          store.loginNewStore.closeIframeSso();
          window.sessionStorage.removeItem('firstPageLogin');
          //动态请求getCookie获取fid
        }
      },
      false,
    );
  }
  componentWillUnmount() {
    if (window.pdfui) {
      const { pdfui, docPageCount, currentPageIndex } = this.state;
      let hasOpenFile = store.viewer.hasOpenFile;
      window.pdfui.getRootComponent().then((root) => {
        root.remove();
        window.viewerStateCache = { pdfui, hasOpenFile, docPageCount, currentPageIndex };
      });
    }
    this.setState = () => {
      return;
    };
    window.removeEventListener('resize', this.onWindowResize);
    store.appStore.removeAppEventListener(APP_CONSTANTS.GO_TO_HOME_PAGE, this.onGoToHomePage);
    store.appStore.removeAppEventListener(APP_CONSTANTS.AI_SHOW_PLUGIN_PANEL, this.onShowAiPanel);
    store.appStore.removeAppEventListener(APP_CONSTANTS.EVENT_USER_INITIALIZE_END, this.onFinishCheckUser);

    // 销毁拦截判断是否离开当前页面
    // window.removeEventListener('beforeunload', this.beforeunload);
  }

  // 加入分享（二期）
  joinShareCollaboration = async () => {
    console.log('joinShareCollaboration');
    // 当通过 /cloudShare 页面进入到获取当前code对应的文档信息
    // const code = getQueryVariable('code')
    let thisHref = window.location.href;
    const code = thisHref.split('code=')[1].split('&')[0];
    let openShareResult = await store.shareCollaborationStore.openShareCollaboration(code);
    console.log(openShareResult);
    store.appStore.updateShowHomeStart(false);
    store.shareCollaborationStore.setCloudShareStart(true);
    // store.appStore.setCollaborationHeader()
    if (openShareResult.code === 0) {
      // 这里，获取文档信息成功后做几层处理：
      // 0、不显示 <newHome>,替换为使用 <cloudShare>
      // store.appStore.updateShowHomeStart(false)
      // store.shareCollaborationStore.setCloudShareStart(true)
      let shareInfo = openShareResult.data;
      let thisDate = new Date();
      // 1、文档是否协同或是否过期，否则显示取消分享页面
      // 当前时间大于过期时间，分享失效。
      if (shareInfo.expireTime && thisDate.getTime() > new Date(shareInfo.expireTime).getTime()) {
        console.log('showNoShare 1');
        store.shareCollaborationStore.setCloudShareType('showNoShare');
        return;
      }
      // 2、存储当前文档信息，特别是docId，docId将用于换取reviewShareId,调用接口
      store.shareCollaborationStore.setShareInfo(shareInfo);
      store.shareStore.setShareDocsInfo(shareInfo);
      store.shareCollaborationStore.setShareUserType('joinShareUser'); // 标识当前用户是加入协作成员
      store.shareStore.setShareDocId(shareInfo.docId);
      let docReviewRessionIdResulet = await collaborationApi.getDocReviewRessionId(shareInfo.docId);
      console.log(docReviewRessionIdResulet);
      if (docReviewRessionIdResulet && docReviewRessionIdResulet.ret === 0) {
        if (docReviewRessionIdResulet.data) {
          store.collaborationStore.setReviewSessionID(docReviewRessionIdResulet.data); // 保存reviewSessionID
        } else {
          console.log('showNoShare 2');
          store.shareCollaborationStore.setCloudShareType('showNoShare'); // docId查询不到reviewSessionID，同样提示分享失效
        }
      }
      if (store.shareCollaborationStore.cloudShareType === 'showNoShare') {
        return;
      }
      // 3、判断当前用户是否登录，未登录用户，页面提示文档名称，及登录的窗口
      // 4、已登录用户，判断用户权限：特点成员访问，获取协作者列表，判断当前用户Id是否存在于列表中，否，则<cloudShare>显示无权限， 有则打开文档
      // 5、已登录用户，判断用户权限：非特点用户，打开文档，
      // 6、打开文档钱判断是否有密码，有密码，唤起密码验证弹窗，否则进入下一步
      // 7、显示loading，加入协同，进入文档后根据权限提示只读或标注文档；
      if (!store.loginNewStore.isLogin || !store.userNewStore.userData.userId) {
        console.log('showLogin 1');
        store.shareCollaborationStore.setCloudShareType('showLogin');
        if (!store.shareCollaborationStore.isLoginInterval) {
          store.shareCollaborationStore.setIsLoginInterval(true);
          let isLogin = setInterval(() => {
            if (store.loginNewStore.isLogin && store.userNewStore.userData.userId) {
              // 登录成功
              clearInterval(isLogin);
              store.shareCollaborationStore.setIsLoginInterval(false);
              store.shareCollaborationStore.joinShare();
            }
          }, 500);
        }
        return;
      } else {
        store.collaborationStore.updateIsShowCollaborationSignIn(true);
        let { userData } = store.userNewStore;
        let hasAuth = false;
        let isCreator = false;
        // 获取当前已加入的用户列表
        let userListResult = await store.shareCollaborationStore.getDocCoordinationShareUserList();
        if (userListResult && userListResult.code === 0) {
          let userList = userListResult.data;
          store.shareCollaborationStore.setShareUserList(userList);
          userList.forEach((item) => {
            if (item.userId == userData.userId) {
              hasAuth = true;
              if (item.creatorFlag == 1) {
                isCreator = true;
                store.shareCollaborationStore.setShareUserType('createShareUser');
              }
            }
          });
        }
        if (shareInfo && shareInfo.aclScope == 1) {
          // 部分人员，获取列表，是否有当前用户
          if (hasAuth) {
            // 有权限，
            if (shareInfo.drawCode === 'true' || isCreator) {
              // 无需校验密码
              // 加入协同并打开文档
              store.shareCollaborationStore.downloadURLAndOpenFile();
              this.setState({
                openCPDFTocllaboration: true,
              });
            } else {
              store.shareCollaborationStore.setCloudShareType('showCheckDrawCode'); // 显示密码弹窗
            }
          } else {
            // 无权限
            store.shareCollaborationStore.setCloudShareType('showNoAuth');
          }
        } else if (shareInfo && shareInfo.aclScope == 0) {
          // 所有人均可加入
          if (hasAuth) {
            // 有权限
            if (shareInfo.drawCode === 'true' || isCreator) {
              // 无需校验密码、或当前为分享人打开
              // 加入协同并打开文档
              store.shareCollaborationStore.downloadURLAndOpenFile();
              this.setState({
                openCPDFTocllaboration: true,
              });
              // 这里有权限不需要再次添加协作者。
            } else {
              store.shareCollaborationStore.setCloudShareType('showCheckDrawCode'); // 显示密码弹窗
            }
          } else {
            // 无权限
            if (shareInfo.drawCode === 'true') {
              // 无需校验密码
              // 加入协同并打开文档
              store.shareCollaborationStore.downloadURLAndOpenFile();
              this.setState({
                openCPDFTocllaboration: true,
              });
              // 将用户加入
              let result = await store.shareCollaborationStore.addCollaboratorUser(userData, true);
              if (result && result.code === 0) {
                setTimeout(() => {
                  collaborationMqttService.publish('addCollaboratorUser'); // 触发mqtt通信
                }, 5000);
                // collaborationMqttService.publish("addCollaboratorUser") // 触发mqtt通信
                // store.shareCollaborationStore.getDocCoordinationShareUserListAndSaveList()
              }
            } else {
              store.shareCollaborationStore.setCloudShareType('showCheckDrawCode'); // 显示密码弹窗
            }
          }
        }
      }
    } else {
      store.shareCollaborationStore.setCloudShareType('showNoShare');
      // 若获取文档信息失败，显示无权限窗口
    }
  };
  isShowGlobalSpinForInitWebSDK = () => {
    const fileLink = getQueryVariable('docUrl');

    if (fileLink) {
      return true;
    }
  };
  doShowEditorLoading() {
    this.setState({
      isShowGlobalSpin: true,
    });
  }
  doHideEditorLoading() {
    this.setState({
      isShowGlobalSpin: false,
    });
  }

  onWindowResize() {
    if (window.pdfui !== void 0) {
      if (this.redrawTask) return;

      this.redrawTask = setTimeout(() => {
        window.pdfui
          .redraw(true, 1)
          .catch(function () {})
          .then(() => (this.redrawTask = 0));
      }, 100);
    }
    this.setState({
      viewerBodyHeight: `${window.innerHeight - getContainerHeight()}px`,
    });
  }
  onShowAiPanel = () => {
    const { pdfui } = this.state;
    if (!pdfui) {
      return;
    }
    showAiPanel();
  };

  calcFloatPageNumberRight = async () => {
    const component = await pdfui.getComponentByName(FLOAT_PAGE_NUMBER);
    const rightPanelComp = await pdfui.getComponentByName('sidebar-right');
    if (component && rightPanelComp) {
      component.element.style.right = `${rightPanelComp.element.offsetWidth + 4}px`;
    }
  };

  onThrottle_ScrollPageNumber() {
    let t1 = 0;
    let t2 = 0;
    let timer = null;
    const isScrollEnd = (component) => {
      t2 = component.element.scrollTop;
      if (t2 == t1) {
        component.hide();
      }
    };
    const listenEnd = (component) => {
      clearTimeout(timer);
      timer = setTimeout(isScrollEnd, 2000, component);
      t1 = component.element.scrollTop;
    };

    return _throttle(
      async () => {
        let component = await pdfui.getComponentByName(FLOAT_PAGE_NUMBER);
        if (!component) {
          return;
        }
        // fix: ONLINERD-5038
        if (component.controller.autoScrolling) {
          component.hide();
        } else {
          component.show();
          this.calcFloatPageNumberRight();
        }
        let textNode = component.element.querySelector('span');

        this.requestDocInfo(({ docPageCount, currentPageIndex }) => {
          if (!textNode) {
            return;
          }
          if (typeof currentPageIndex === 'number' && !Number.isNaN(currentPageIndex)) {
            textNode.innerHTML = `${currentPageIndex + 1}/${docPageCount}`;
          }
          listenEnd(component);
        }, 'pdfVersion,isSecured');
      },
      1000,
      {
        leading: true,
        trailing: true,
      },
    );
  }
  async onListenScrollPageNumber() {
    let node = document.querySelector('.fv__ui-pdfviewer');
    if (!node) {
      return;
    }
    node.addEventListener('scroll', this.fn_Throttle_ScrollPageNumber);
  }
  async onRemoveScrollPageNumber() {
    let node = document.querySelector('.fv__ui-pdfviewer');
    if (!node) {
      return;
    }
    node.removeEventListener('scroll', this.fn_Throttle_ScrollPageNumber);
    let component = await pdfui.getComponentByName(FLOAT_PAGE_NUMBER);
    if (!component) {
      return;
    }
    component.hide();
  }
  onReduceFileSize = (portfolioNodeData, showParams) => {
    this.fileTabRef.current.wrappedInstance.onReduceFileSize(portfolioNodeData, showParams);
  };
  onOptimizeScanned(showParams) {
    this.fileTabRef.current.wrappedInstance.onOptimizeScanned(showParams);
  }
  onShowWarningMessage(
    callback,
    {
      message,
      containerClass,
      contentComponent,
      iconType = 'warning',
      messageParams,
      title,
      ok,
      cancel,
      closable,
      checkbox,
      customClose,
      timerFn,
      isI18n,
      noCancel,
      extraButtonMid,
      onExtraButtonMid,
      noConfirm,
      zIndex,
      subLink,
    },
    noClose,
  ) {
    const messageDlgCfg = Object.assign({}, this.state.messageDlgCfg, {
      target: MessageDialog,
      config: {
        visible: true,
        msg: {
          id: message,
          containerClass,
          contentComponent,
          messageParams,
          title,
          ok,
          cancel,
          closable,
          checkbox,
          customClose,
          iconType,
          timerFn,
          isI18n,
          noCancel,
          extraButtonMid,
          noConfirm,
          zIndex,
          subLink,
        },
        onOk: (state) => {
          console.log('ok');
          callback && callback(true, state);
          this.onCloseModalDlg(1);
          return true;
        },
        onClose: !noClose
          ? (state) => {
              // 处理保存，当非Vip用户修改文件后点击打开文件，却没有重新打开后保存出现问题
              if (store.appStore.docModified && store.userNewStore.userData.identity !== 'vip') {
                store.common.setDocModifiedNoSave(true);
              }
              store.appStore.doUpdateDocModified(false);
              callback && callback(false, state);
              this.onCloseModalDlg(1);
              return false;
            }
          : void 0,
        onCancel: !noCancel
          ? (state) => {
              console.log('onCancel');
              callback && callback(false, state);
              this.onCloseModalDlg(1);
              return false;
            }
          : void 0,
        onCustomClose: () => {
          if (this.pdfDoc && this.pdfDoc.otherOptions && this.pdfDoc.otherOptions.isOpenNewFileAfterClose) {
            callback && callback(false);
          }
          this.onCloseModalDlg(1);
          return false;
        },
        onExtraButtonMid: () => {
          onExtraButtonMid && onExtraButtonMid();
        },
      },
    });

    this.setState({
      layer2Msg: messageDlgCfg,
    });
  }
  showMessage({ id, defaultMessage }) {
    let val2 = intl.formatMessage({
      id,
      defaultMessage,
    });

    message.success(val2);
  }
  doShowSignInDialog(name) {
    // let id = isForConvert(name)? "Permission.SignIn.Convert":"Permission.SignIn";
    if (name === 'open-local-file') {
      //TODO FOIXT 替换sso登录弹框
      store.loginNewStore.login();
    } else {
      store.loginNewStore.login();
      // store.appStore.doUpdateSignInNotice({id});
    }
  }
  // begin --> ONLINERD-1147 2021/01/01 高级功能必须订阅
  isEnablePremium() {
    const { isOnPremiseDeployMode } = store.appStore;
    const { isActive, isTrial } = store.accountStore;
    const { isEdu } = store.userStore;
    if (!isOnPremiseDeployMode && !isMore20201231()) {
      return true;
    }
    if (!isOnPremiseDeployMode && (isActive || isTrial) && !isEdu) {
      return true;
    }
    if (isEdu && isActive) {
      return true;
    }
    return false;
  }
  isEnableByEnterprise() {
    const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = store.userStore;
    if (isEnterpriseUser && hasEditPermissionAndEnterpriseUser) {
      return true;
    }
    return false;
  }
  isEnableByDashboard() {
    const { isDashboardTrial } = store.accountStore;
    if (isDashboardTrial) {
      return true;
    }
    return false;
  }
  isUnablePremium() {
    const { isOnPremiseDeployMode } = store.appStore;
    const { isExpired, isTrialExpired, isNoFirstTrail } = store.accountStore;
    if (!isOnPremiseDeployMode && !isMore20201231()) {
      return false;
    }
    if (!isCNDomain() && !isJPDomain()) {
      if (!isOnPremiseDeployMode && (isExpired || isTrialExpired || isNoFirstTrail)) {
        return true;
      }
    } else {
      if (!isOnPremiseDeployMode && (isExpired || isTrialExpired)) {
        return true;
      }
    }
    return false;
  }
  showNotActive = (isOnPremiseDeployMode) => {
    if (isOnPremiseDeployMode) {
      this.onShowWarningMessage(
        (isOk) => {
          isOk && this.onLoginOut(true);
        },
        { message: 'account.notActiveDisableAll', title: 'account.notActiveDisableAllTitle', ok: 'user.signOut', cancel: 'Cancel' },
        false,
      );
      return;
    }
    if (isPdfOnlineDomain() || isCommonFeatureDomain()) {
      window.pdfui.eventEmitter.emit('need-pay-event');
    } else {
      this.onShowWarningMessage((/*isOk*/) => {}, { message: 'account.notActive', title: 'PhantomPDF.Online.TitleWithOnline' }, true);
    }
  };
  showSubscirbeForExpired = (isExpired) => {
    if (isCNDomain() || isJPDomain()) {
      let messageKey = 'account.expiredTip';
      if (!isExpired) {
        messageKey = isCNDomain() ? 'account.trialExpiredTip_CN' : 'account.trialExpiredTip';
      }
      this.onShowWarningMessage(
        (isOk) => {
          isOk && store.userStore.setSubscribeVisible(true);
        },
        { message: messageKey, title: 'PhantomPDF.Online.TitleWithOnline', ok: 'subscription.plan.Subscribe', noCancel: true },
      );
    } else {
      // 插件过来的订阅逻辑
      const addInType = thirdPartyService.isFromThirdParty();

      if (addInType) {
        thirdPartyService.checkPermissionAndReflect({ addInType });

        return;
      }

      // EC内部订阅逻辑
      const { isEdu } = store.userStore;

      if (isEdu) {
        // let messageKey = "account.expiredTip";
        // if (!isExpired) {
        //   messageKey = "account.trialExpiredTip";
        // }
        // this.onShowWarningMessage((isOk)=>{ isOk && store.userStore.setSubscribeVisible(true); }, {message:messageKey, title:"PhantomPDF.Online.TitleWithOnline", ok: "subscription.plan.Subscribe", noCancel: true} );
        this.pdfui.eventEmitter.emit('need-pay-event', true);
      } else {
        const { isActive, isTrial } = store.accountStore;
        if (!isActive && !isTrial) {
          this.pdfui.eventEmitter.emit('need-pay-event', true);
        }
      }
    }
  };
  // end --> ONLINERD-1147
  /**
   * 1. if not sign in, user can use some free features. (not in onPremise)
   * 2. if in on-premise, every one must go to login in.
   * 3. not free, go to 'sign in/sign up'
   * 4. no edit permission, show dialog
   * 新增alertable参数，用于控制是否需要弹窗提示
   * 使用场景：某些表单在非付费状态下 表现为禁用，而不需要弹窗
   */
  isDisableButton(btnName, alertable = true, tabName, gaEventKey) {
    const { isFromSharePoint, action } = store.appStore.sharePointInfo;

    // 通过SharePoint打开的文档，comment功能可以随意使用
    if (
      (tabName === 'comment-tab' || tabName === 'sidebar' || btnName.indexOf('comment-sharp-color') > -1) &&
      ((isFromSharePoint === true && action === 'open') || thirdPartyService.isFromThirdParty() === 'GoogleDrive')
    ) {
      return false;
    }

    //HOME_SNAPSHOT
    if (!window.__online__ && permissionManager.isOnlineFeature(btnName)) {
      alertable && store.appStore.doNotifyErrors('offline');
      return true;
    }

    const hasSignIn = store.loginNewStore.isLogin;

    const { isOnPremiseDeployMode } = store.appStore;
    if (!isOnPremiseDeployMode && !permissionManager.isForceLoginFeature(btnName)) {
      return false;
    }
    if (!hasSignIn && !isJPDomain()) {
      //#ONLINERD-3139 日本环境免费功能无需登录
      alertable && this.doShowSignInDialog({ btnName });
      return true;
    }

    // if(process.env.NODE_ENV == 'development'){
    //   return false;
    // }

    // 协作中comment功能都能使用
    if (store.appStore.isCollaborationMode() && !isOnPremiseDeployMode && !permissionManager.isPremiumFeature(btnName)) {
      if (!hasSignIn && isForConvert(btnName)) {
        alertable && this.doShowSignInDialog({ btnName });
        return true;
      }
      return false;
    }

    const isPremiumFeatureCheck = () => {
      const normal = permissionManager.isPremiumFeature(btnName);
      if (!isCNDomain() && !isJPDomain()) {
        return normal;
      }
      // 美区是免费的功能 ，中国日本区不一定
      if (!normal) {
        return permissionManager.isCNJPPremiumFeature(btnName);
      } else if (isCNDomain()) {
        return permissionManager.isCNJPPremiumFeature(btnName);
      }
      return normal;
    };

    if (!isOnPremiseDeployMode && !isPremiumFeatureCheck() && !isPdfOnlineDomain() && !isCommonFeatureDomain()) {
      //ONLINERD-2125 Disable all features if there is no valid license
      if (!hasSignIn && isForConvert(btnName)) {
        //#ONLINERD-3139 日本环境免费转换功能需登录
        alertable && this.doShowSignInDialog({ btnName });
        return true;
      }
      return false;
    }
    //

    if (!hasSignIn) {
      //#ONLINERD-3139 日本环境免费功能无需登录
      alertable && this.doShowSignInDialog({ btnName });
      return true;
    }

    if (this.isEnablePremium()) {
      return false;
    }

    const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = store.userStore;
    if (isEnterpriseUser) {
      if (!hasEditPermissionAndEnterpriseUser) {
        // enterprise users
        if (isCNDomain() || isJPDomain()) {
          if (!isPremiumFeatureCheck()) {
            return false;
          }
        }
        alertable && this.showNotActive(isOnPremiseDeployMode);
        return true;
      }
      return false;
    }
    const { isExpired } = store.accountStore;
    let detail = store.accountStore.getPermissionByDashboard(btnName);
    const { permisson, isAllowed, forbit /* , times, remainingTime, count */ } = detail;
    if (isAllowed) {
      return false;
    } else if (permisson && !isAllowed) {
      if (forbit) {
        alertable && this.showSubscirbeForExpired(isExpired);
        return true;
      }
      alertable && this.onShowTimesLimitMsg(btnName);
      return true;
    }

    const { isDashboardTrial } = store.accountStore;
    if (isCNDomain()) {
      if (isDashboardTrial) {
        return false;
      }
    }
    if (this.isUnablePremium()) {
      if (isCNDomain() || isJPDomain()) {
        alertable && this.showSubscirbeForExpired(isExpired);
        return true;
      } else {
        // const {isEdu} = store.userStore;
        // if(isEdu && isDashboardTrial){
        //   return false;
        // }
        const keyList = ['organize_pdf'];
        const esignTab = [
          ADD_TEXT,
          FILL_SIGN_ADD_TICK,
          FILL_SIGN_ADD_CROSS,
          FILL_SIGN_ADD_LINE,
          FILL_SIGN_ADD_DOT,
          FILL_SIGN_ADD_RECTANGLE,
          SET_PREDEFINED_TEXT,
        ];
        const isClickEsign = () => {
          if (esignTab.includes(btnName) && window.pdfui.activeMainPageTab.name === TAB_NAME_MAP.FoxitESign) {
            return true;
          }
          return false;
        };
        if (!permissionManager.isPremiumFeature(btnName)) {
          if ((btnName === OPEN_FILE_FROM_GET_START_GUID && keyList.includes(gaEventKey)) || isClickEsign()) {
            alertable && this.showSubscirbeForExpired(isExpired);
            return true;
          }
          return false;
        } else {
          alertable && this.showSubscirbeForExpired(isExpired);
          return true;
        }
      }
    }

    const { getSubscribeStateFailed } = this.state;

    if (getSubscribeStateFailed) {
      store.appStore.setGlobalMessage({ type: 'error', content: intl.get('subscription.error.GetSubscriptionInfoFailed') });

      return true;
    }

    return false;
  }
  onShowTimesLimitMsg = (btnName) => {
    store.userStore.doSendGAEventByUser({ eventKey: PERMISSION_BY_DASHBOARD_LIMIT, label: 'user_event', extraInformation: { btnName } });
    let timerFn = () => {
      let detail = store.accountStore.getPermissionByDashboard(btnName);
      const { isAllowed, times, remainingTime, count } = detail;
      const { FoxitEU } = store.appStore;
      let messageKey = 'Error.TimesLimit';
      let messageParams = { RemainingTime: remainingTime, count, times, FoxitEU };
      return { messageKey, messageParams, isKillTimer: isAllowed };
    };
    const { messageKey, messageParams } = timerFn();
    this.onShowWarningMessage(
      (isOk) => {
        if (isOk) {
          if (isCNDomain() || isJPDomain()) {
            store.userStore.setSubscribeVisible(true);
          } else {
            this.pdfui.eventEmitter.emit('need-pay-event');
          }
          store.userStore.doSendGAEventByUser({ eventKey: PERMISSION_BY_DASHBOARD_LIMIT_SUBSCRIPTION, label: 'user_event', extraInformation: { btnName } });
        }
      },
      {
        message: messageKey,
        messageParams,
        title: 'PhantomPDF.Online.TitleWithOnline',
        timerFn,
        ok: 'SubscribeNow',
        cancel: 'ThanksGotIt',
        extraButtonMid: 'DownloadDesktop',
        onExtraButtonMid: () => {
          store.collaborationStore.onGoForDownload();
        },
      },
    );
  };
  onCloseBottomAd = () => {
    storageSetItem(localStorage, BOTTOM_AD_SHOWED, new Date().toLocaleDateString());

    this.setState({
      isShowBottomAd: false,
    });
  };
  onIsShowBottomAd = () => {
    if (isMobile) {
      return false;
    }
    const { isWindowsOS, isMacOS } = store.appStore;
    if (!(isWindowsOS || isMacOS)) {
      return false;
    }
    const isUSDomain = isPdfOnlineDomain();
    if (!isUSDomain) {
      return false;
    }
    const { isShowBottomAd } = this.state;
    if (!store.viewer.hasOpenFile || !isShowBottomAd) {
      return false;
    }
    const { isSubscribe } = store.accountStore;
    if (isSubscribe) {
      return false;
    }
    const { isEnterpriseUser, isEdu } = store.userStore;
    if (isEnterpriseUser || !isEdu) {
      return false;
    }

    const bottomAdShowed = storageGetItem(localStorage, BOTTOM_AD_SHOWED);
    const currentDate = new Date().toLocaleDateString();
    if ((bottomAdShowed && currentDate > bottomAdShowed) || !bottomAdShowed) {
      return true;
    } else {
      return false;
    }
  };

  onOpenFileForUrl({ url, fileName }) {
    fileController.doOpenFileByUrl(url, fileName, () => {
      this.onCloseOpenFilePanel();
    });
  }
  // onOpenFileForLocalComputer({file, fileName}) {
  //   console.log('测试： 转换1 打开文件时候判断文件');
  //   store.docStore.setDocDriveName('')
  //   const fn = () => {
  //     const isShowShareDlg = () => {
  //       const { isOpenFileForShare } = this.state
  //       if (isOpenFileForShare) {
  //         store.collaborationStore.changeShareDialogState(true)
  //         this.setState({
  //           isOpenFileForShare: false
  //         })
  //       }
  //     }
  //     if (file.type === 'application/pdf') {
  //       // 打开文件时
  //       window.pdfui
  //         .openPDFByFile(file, { fileName })
  //         .then(() => {
  //           // this.onHideHomeStart()
  //           isShowShareDlg()
  //         })
  //         .catch((/*e*/) => {});
  //     } else {
  //       convertController.doConvertToPDF(
  //         file,
  //         (result) => {
  //           if (result && result!='stop' && result.ret == 0 && result.url) {
  //             const { url, fileName } = result;
  //             fileController.doOpenFileByUrl(url, fileName, (/*err*/) => {}, false, () => {
  //               isShowShareDlg()
  //             });

  //             return;
  //           }
  //         },
  //         (/*e*/) => {
  //           this.doCloseSidebar();
  //           //this.onErrorFromViewer(e, OPEN_FILE_LOCAL);
  //         },
  //         true
  //       );
  //     }

  //     this.onCloseOpenFilePanel();
  //   }

  //   if(!window.pdfui){
  //     store.viewer._getPDFUI().then(() => {
  //       fn()
  //     })
  //     return;
  //   }

  //   fn()
  // }
  onShowMulFiles2PDFDlg(extra = {}) {
    this.convertTabRef.current.wrappedInstance.onShowMulFiles2PDFDlg(extra);
  }
  onShowCombineFilesDlg(extra = {}) {
    this.convertTabRef.current.wrappedInstance.onShowCombineFilesDlg(extra);
  }
  onShowUpdateLogs() {
    if (!window.__online__) {
      store.appStore.doNotifyErrors('offline');
      return;
    }
    this.setState({
      messageDlgCfg: {
        target: DLG_TARGETS.UpdateLogsDlg,
        //toCache: true,
        config: {
          onClose: () => {
            this.setState({
              messageDlgCfg: {
                target: '',
              },
              //isShowHtml2PDFDlg:false
            });
          },
        },
      },
    });
  }

  getOpenFileName = () => {
    const fileTabRef = this.fileTabRef.current.wrappedInstance;
    return fileTabRef ? fileTabRef.state.openFileInfo.fileName : '';
  };

  onShowSaveAsDlg = (btnName, selectRect, graphicsObject) => {
    return this.fileTabRef.current.wrappedInstance.onShowSaveAsDlg(btnName, selectRect, graphicsObject);
  };
  /**
   * [onShowConvertDlg FOXIT 转换弹框显示]
   *
   * @return  {[type]}  [return description]
   */
  onShowConvertDlg(fwConvertType) {
    store.convert.getConvertType(fwConvertType);
    const config = {
      headers: {
        client: 'editCloud',
      },
      params: {
        token: utils.util.getQueryString('token'),
      },
    };
    getUserInfo(config).then((res) => {
      if (res.ret === 0) {
        store.userNewStore.setUserInfo(res.data);
        if (res.data.identity === 'vip') {
          if (fwConvertType === 'convert-pdf-to-img') {
            store.convert.getIsShowFwConvertImgType(true);
          } else {
            store.convert.getIsShowFwConvertModal(true);
          }
        } else {
          store.common.getIsShowOpenMember(true);
        }
      }
    });
  }
  showMsg = (msg) => {
    this.setState({
      messageDlgCfg: {
        target: MessageDialog,
        config: {
          msg: msg,
          onOk: this.onCloseModalDlg,
          onClose: null,
        },
      },
    });
  };
  showMsgLayer = (msg) => {
    this.setState({
      messageDlgCfg: {
        target: MessageDialog,
        config: {
          msg: msg,
          onOk: () => {
            this.onCloseModalDlg(null);
          },
          onClose: null,
        },
      },
    });
  };
  //comment导出到word
  onShowImportCommentDlg(metaData) {
    this.setState({
      messageDlgCfg: {
        target: DLG_TARGETS.ImportComment,
        toCache: true,
        config: {
          currentFile: metaData.FileName,
          onCancel: () => {
            this.setState({
              messageDlgCfg: {
                target: '',
              },
            });
          },
          ImportWordByComment: this.ImportWordByComment,
        },
      },
    });
  }
  ImportWordByComment() {
    this.setState({
      messageDlgCfg: {
        target: DLG_TARGETS.CommentStatisticsResult,
        toCache: true,
        config: {
          cancel: () => {
            this.setState({
              messageDlgCfg: {
                target: '',
              },
            });
          },
        },
      },
    });
  }
  onShowExportImageDlg() {
    const { docPageCount, currentPageIndex } = this.state;
    this.setState({
      messageDlgCfg: {
        target: ExportImagesDialog,
        config: {
          docPageCount,
          currentPageIndex,
          visible: true,
          onOk: this.onCloseModalDlg,
          onClose: this.onCloseModalDlg,
        },
      },
    });
    this.requestDocInfo();
  }

  onShowResetFormWarningDlg = () => {
    const fn = () => {
      fileController.resetForm();
    };

    store.userStore.checkShowDlgControl('resetFormWarning');
    const { resetFormWarning } = store.userStore.userTip;
    if (resetFormWarning === 'hide') {
      fn();
      return;
    }
    this.onShowWarningMessage(
      (isOk, state) => {
        isOk && fn();
        if (!isOk) return;
        if (state && state.checked !== void 0) {
          // checkd: true => do not show
          store.userStore.setShowDlgControl('resetFormWarning', !state.checked);
        }
      },
      {
        iconType: 'inquiry',
        message: 'ResetForm.info',
        title: 'PhantomPDF.Online.TitleWithOnline',
        ok: 'Yes',
        cancel: 'No',
        checkbox: { title: 'ResetForm.DoNotAskAgain', checked: false },
        closable: true,
      },
    );
  };

  onShowExportMultiFormsDlg = () => {
    this.setState({
      messageDlgCfg: {
        target: ExportFormDataDialog,
        config: {
          visible: true,
          onClose: this.onCloseModalDlg,
        },
      },
    });
  };

  onShowAboutFoxitDlg = () => {
    this.setState({
      messageDlgCfg: {
        target: AboutFoxitDialog,
        config: {
          onClose: this.onCloseModalDlg,
          onHref: this.doOpenAboutFoxitPage,
          visible: true,
        },
      },
    });
  };

  onCloseModalDlg = (layer = 0) => {
    if (layer) {
      // const $ = window.UIExtension.jQuery;
      // if($(".content-body span").text() !== "请输入有效的电子邮箱地址！") {
      //   this.setState({
      //     messageDlgCfg:{}
      //   })
      // }
      return this.setState({ layer2Msg: {} });
    }
    this.setState({
      messageDlgCfg: {},
    });
  };

  onShowToDoDlg({ url, fileName }) {
    let convertInfo = this.state.convertInfo;
    convertInfo.url = url;
    convertInfo.fileName = fileName;
    this.setState({
      convertInfo: convertInfo,
      messageDlgCfg: {
        target: ToDoMessageDialog,
        config: {
          visible: true,
          msg: { id: 'Convert.ToDo', doAndNext: 'Convert.ToDoAndNext', next: 'Convert.ToNext', title: 'Convert.success.title', iconType: 'warning' },
          onNext: this.onToDoNext,
          onToDoAndNext: this.onToDoAndNext,
          onCancel: this.onCloseModalDlg,
          onCloseDialog: this.convertTabRef.current.wrappedInstance.onCloseCombineFilesDlg, // Reserved for "Combine Files"
        },
      },
    });
  }
  resetTodo() {
    this.setState({
      messageDlgCfg: {},
      convertInfo: {
        url: '',
        fileName: '',
        taskType: -1,
        saveTo: '',
      },
    });
  }
  onToDoAndNext() {
    // to do and continue
    const { url, fileName } = this.state.convertInfo;
    this.resetTodo();

    // set modifed with false
    //let env = getDownloadEnv();
    fileController.saveToLocal(() => {
      store.appStore.doUpdateDocModified(false, true);
      fileController.doOpenFileByUrl(url, fileName, (err) => {
        console.error('TCL: onToDoAndNext -> err', err);
      });
    }, null);
  }
  onToDoNext() {
    const { url, fileName } = this.state.convertInfo;
    this.resetTodo();
    // set modifed with false
    store.appStore.doUpdateDocModified(false);
    fileController.doOpenFileByUrl(url, fileName, (err) => {
      console.error('TCL: onToDoAndNext -> err', err);
    });
  }

  onLoginIn() {
    // store.userStore.loginIn();
    // /* 替换login的方法
    store.loginNewStore.login();
  }
  onSignUp() {
    store.loginNewStore.login();
    // store.userStore.signUp(false);
  }
  onLoginOut(noSendGA) {
    store.loginNewStore.signOut(noSendGA);
    // store.userStore.loginOut(noSendGA, reLogin);
  }
  onGoToAdminConsole() {
    const { isAdmin } = store.userStore;
    let pheeAdminUrl;
    if (isAdmin) {
      pheeAdminUrl = store.appStore.pheeAdminUrl;
    }
    if (!pheeAdminUrl) {
      return;
    }
    windowActionFn(window, 'open', [pheeAdminUrl, '_blank']);
  }
  onShowCompareDlg(btnName) {
    if (this.isDisableButton(btnName)) return;
    this.setState(getRefDlgCfg(CompareDialog, this.compareDialogRef));

    this.delayDialog('compareDialogRef', 'showCompareDialog');

    store.accountStore.updateTrialPermission(btnName);
  }
  async requestDocInfo(callback, ignores = '') {
    if (!window.pdfui) {
      return;
    }
    fileController.getDocInfo(({ docPageCount, currentPageIndex, pageSizes }) => {
      this.setState({
        docPageCount,
        currentPageIndex,
        pageSizes,
      });
      callback &&
        callback({
          docPageCount,
          currentPageIndex,
          pageSizes,
        });
    }, ignores);
  }

  changeEditorBtnState = () => {
    const isProtectedView = localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true : false;
    const snapshotDom = document.querySelector('div[icon-class="fv__icon-toolbar-snapshot"]');
    const saveDom = document.querySelector('div[name="download-file-button"]');
    const saveDomZh = document.querySelector('div[name="save-as-file"]');
    const optimizerDom = document.querySelector('div[icon-class="fv__icon-toolbar-pdf-optimizer"]');
    const editToolBarDom = document.querySelector('div[name="edit-toolbar-group-list"]');
    const organizeToolBarDom = document.querySelector('div[name="organize-toolbar-group-list"]');
    const commentToolBarDom = document.querySelector('div[name="comment-toolbar-group-list"]');
    const formToolBarDom = document.querySelector('div[name="form-toolbar-group-list"]');
    const protectToolBarDom = document.querySelector('div[name="protect-toolbar-group-list"]');
    const searchToolDom = document.querySelector('div[name="redaction-search"]');
    const arr = [snapshotDom, saveDom, saveDomZh, optimizerDom, editToolBarDom, organizeToolBarDom, commentToolBarDom, formToolBarDom].filter((item) => item);

    arr.forEach((dom) => {
      if (isProtectedView) {
        dom && dom.classList.add('disable-for-toolbar');
        protectToolBarDom && protectToolBarDom.classList.add('disable-add');
        searchToolDom && searchToolDom.classList.add('disable-remove');
      } else {
        dom && dom.classList.remove('disable-for-toolbar');
        protectToolBarDom && protectToolBarDom.classList.remove('disable-add');
        searchToolDom && searchToolDom.classList.remove('disable-remove');
      }
    });
  };

  enableAllFeatureHandle = () => {
    localStorage.setItem('SECURITY_PROTECTED_VIEW', 'off');
    store.appStore.setSecurityMode('off');
    window.pdfui.eventEmitter.emit('isProtectedView', false);
    const snapshotDom = document.querySelector('div[icon-class="fv__icon-toolbar-snapshot"]');
    const saveDom = document.querySelector('div[name="download-file-button"]');
    const saveDomZh = document.querySelector('div[name="save-as-file"]');
    const optimizerDom = document.querySelector('div[icon-class="fv__icon-toolbar-pdf-optimizer"]');
    const editToolBarDom = document.querySelector('div[name="edit-toolbar-group-list"]');
    const organizeToolBarDom = document.querySelector('div[name="organize-toolbar-group-list"]');
    const commentToolBarDom = document.querySelector('div[name="comment-toolbar-group-list"]');
    const formToolBarDom = document.querySelector('div[name="form-toolbar-group-list"]');
    const protectToolBarDom = document.querySelector('div[name="protect-toolbar-group-list"]');
    const searchToolDom = document.querySelector('div[name="redaction-search"]');
    const arr = [snapshotDom, saveDom, saveDomZh, optimizerDom, editToolBarDom, organizeToolBarDom, commentToolBarDom, formToolBarDom].filter((item) => item);
    arr.forEach((dom) => {
      dom.classList.remove('disable-for-toolbar');
      protectToolBarDom && protectToolBarDom.classList.remove('disable-add');
      searchToolDom && searchToolDom.classList.remove('disable-remove');
    });
    this.closeMessageCenterDlg();
  };
  resetPreFileOpenStatus = () => {
    const OpenFileMapString = localStorage.getItem('OpenFileMap');
    if (!OpenFileMapString) return;
    const OpenFileMap = JSON.parse(OpenFileMapString);
    Object.keys(OpenFileMap).forEach((k) => {
      OpenFileMap[k].trustToClose = false;
      OpenFileMap[k].trustOneSet = false;
    });
    localStorage.setItem('OpenFileMap', JSON.stringify(OpenFileMap));
  };
  showProtectedViewTips = () => {
    const isProtectedView = localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true : false;
    if (isProtectedView) {
      const messageCenterConfig = this.state.messageCenterConfig;
      const formFieldsFoundMessageConfig = {
        messageType: ProtectedViewState,
        title: 'Preferences.Content.Security.Title',
        info: 'Preferences.Content.Security.Tip',
      };
      formFieldsFoundMessageConfig.extendContent = () => (
        <div className="btn-container">
          <Button type="link" onClick={this.enableAllFeatureHandle}>
            {intl.get('Preferences.Content.Security.TipBtn')}
          </Button>
        </div>
      );

      const formMessageIndex = messageCenterConfig.messages.findIndex((item) => item.messageType === ProtectedViewState);
      if (formMessageIndex < 0) {
        messageCenterConfig.messages.push(formFieldsFoundMessageConfig);
      } else {
        messageCenterConfig.messages.splice(formMessageIndex, 1, formFieldsFoundMessageConfig);
      }

      return {
        isClearMessageCenter: false,
        isShowMessageCenter: true,
        messageCenterConfig,
      };
    }
  };

  isFilterGaEvent = (btnName) => {
    const list = [
      USER_ENTRY_SIGN_IN,
      USER_ENTRY_SIGN_UP,
      HOME_PRINT,
      SAVE_TO_LOCAL, // from online, will send in 'store.appStore.doUpdateDocModified(false, true);'
    ];
    return list.indexOf(btnName) !== -1;
  };
  doCollectEvent = ({ btnName, tabName, gaEventKey, isFilterGaEvent }) => {
    if (tabName) {
      tabName = tabName.replaceAll('-', '_');
    }
    let isFromBuiltIn = isCNDomain() && isBuiltIn(SAVE_TO_DOWNLOAD);
    if (!isFilterGaEvent && !this.isFilterGaEvent(btnName)) {
      let eventKey = gaEventKey ? gaEventKey : btnName;
      if (btnName === SAVE_TO_DOWNLOAD && isFromBuiltIn) {
        eventKey = SAVE_TO_LOCAL;
      }
      store.userStore.doSendGAEvent({ eventKey: eventKey, label: tabName });
    }
    let NPSButtons = [HOME_PRINT, PE_PLUGIN_ADD_TEXT, EDIT_TEXT, COMMENT_ADD_PENCIL_TOOL, COMMENT_ADD_TYPEWRITER, READ_MODE_DOWNLOAD_FILE, READ_MODE_PRINT];
    if (isFromBuiltIn) {
      NPSButtons.push(SAVE_TO_DOWNLOAD);
    }
    // TODO FOXIT 云编辑不使用nps
    // if(NPSButtons.includes(btnName)){
    //   store.appStore.emitEvent(APP_CONSTANTS.COLLECT_NPS_SURVEY);
    // }
  };

  async onClickViewerBtn({ btnName, result, before, willDoFn, tabName, gaEventKey, isFilterGaEvent }) {
    console.log('onClickViewerBtn');
    console.log(btnName);
    store.appStore.updateCurrentClickBtnName(btnName);

    // ga, ...
    if ([MANAGE_SIGNATURE, APPLY_ALL_SIGNATURE].includes(btnName)) {
      if (this.pdfui && this.pdfui.activeMainPageTab && this.pdfui.activeMainPageTab.name === TAB_NAME_MAP.FoxitESign) {
        this.doCollectEvent({ btnName, tabName, gaEventKey, isFilterGaEvent });
      }
    } else {
      this.doCollectEvent({ btnName, tabName, gaEventKey, isFilterGaEvent });
    }
    /*
     1. check whether the button is disable;
     2. check whether the button is built-in;
     3. check file size when convert file
     4. default.
    */
    if (
      /*btnName!==OPEN_FILE_LOCAL && */ btnName !== CONVERT_FILES_TO_PDF &&
      btnName !== FEEDBACK &&
      this.isDisableButton(btnName, true, tabName, gaEventKey)
    ) {
      // is disable, such as: token expired; some buttons are not allowed
      return;
    }
    if (isBuiltIn(btnName) && before && willDoFn) {
      // 此处可配置websdk中需要做dashboard处理的 component name
      if ([EDIT_ADD_ARTICLE].indexOf(btnName) > -1) {
        store.accountStore.updateTrialPermission(btnName);
      }
      // is built-in, will run as default.
      willDoFn();
      return;
    }
    if (isAnnotTooltip(btnName)) {
      fileController.onClickAnnotTooltip({ btnName });
      return;
    }
    // TODO FOXIT 注释福软的转换功能
    this.doHandleViewerAction({ btnName, result, before, willDoFn });
  }
  onFinishSaveSuccess() {
    store.appStore.doUpdateDocModified(false, true);
    // ga
    store.userStore.doSendGAEvent({ eventKey: DOCUMENT_SAVED, label: 'doc_event' });
  }
  // commonForDrives = (activeKey) => {
  //   let fn = async ()=>{
  //     if(!isMobile){
  //       store.viewer._getPDFUI().then(async() => {
  //         const button = await pdfui.getComponentByName(openOriginMap[activeKey])

  //         button && button.parent && button.parent.select(button)
  //       })
  //     }

  //     this.setState({
  //       driveName: activeKey,
  //       driveOperateType: 'open',
  //       showDrives: isMobile?true:false,
  //     });
  //     if (isMobile) {
  //       store.appStore.hideOpenFileDlg()
  //     } else {
  //       store.appStore.showOpenFileDlg(false, activeKey)
  //     }

  //     if (activeKey !== 'LOCAL_COMPUTER') {
  //       store.driveStore.setDriveName(activeKey)
  //     }
  //   }
  //   this.onShowToSaveBeforeOpen((isToSave)=>{
  //     !isToSave && fn();
  //   })
  // }
  commonForDrives = (activeKey) => {
    return this.fileTabRef.current.wrappedInstance.commonForDrives(activeKey);
  };
  commonForDrivesInMobile = ({ driveName, driveOperateType }) => {
    return this.fileTabRef.current.wrappedInstance.commonForDrivesInMobile({ driveName, driveOperateType });
  };
  commonForSaveDrives = (activeKey, customInfo) => {
    return this.fileTabRef.current.wrappedInstance.commonForSaveDrives(activeKey, customInfo);
  };
  saveToLocalComputer = (param, fileName) => {
    return this.fileTabRef.current.wrappedInstance.saveToLocalComputer(param, fileName);
  };
  onHideHomeStart = () => {
    console.log('updateShowHomeStart false');
    store.appStore.updateShowHomeStart(false);
    // store.appStore.setCommonMode()
  };
  onHandlePDFByResponse(result, openFileSuccess) {
    if (result && result != 'stop' && result.ret == 0 && result.url) {
      if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
        const { url, fileName } = result;
        fileController.doOpenFileByUrl(
          url,
          fileName,
          (/* err */) => {},
          null,
          () => {
            openFileSuccess && openFileSuccess();
          },
        );
        return;
      }
      this.onShowToDoDlg(result);
    }
  }
  onShowDrivesList = ({ type }) => {
    const fn = () => {
      this.setState({
        isShowDrivesListDlg: true,
        drivesListDlgType: type,
      });
    };
    if (type === 'save') {
      fn();
      return;
    }
    this.onShowToSaveBeforeOpen((isToSave) => {
      !isToSave && fn();
    });
  };
  doHelpCenterNav = () => {
    if (!window.__online__) {
      store.appStore.doNotifyErrors('offline');
      return;
    }
    if (isCNDomain()) {
      windowActionFn(window, 'open', ['https://help.foxitsoftware.cn/']);
    } else {
      let url =
        'https://globe-map.foxitservice.com/go.php?title=help&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=phantomonline&language=';
      url += store.appStore.lng.full;
      windowActionFn(window, 'open', [url]);
    }
  };
  rotateCurrentPage = (direction) => {
    this.requestDocInfo(async ({ currentPageIndex }) => {
      const hoverPage = window.sessionStorage.getItem('fw__hoverThumbItemContextmenuHover');
      currentPageIndex = hoverPage || hoverPage === 0 ? hoverPage : currentPageIndex;
      const pdfDoc = await window.pdfui.getCurrentPDFDoc();
      const pdfPage = await pdfDoc.getPageByIndex(currentPageIndex);
      const pageRotation = pdfPage.getRotation();
      let newRotation = 0;

      if (direction === ROTATE_LEFT) {
        if (pageRotation === 0) {
          newRotation = 3;
        } else {
          newRotation = pageRotation - 1;
        }
      } else {
        if (pageRotation !== 3) {
          newRotation = pageRotation + 1;
        } else {
          newRotation = 0;
        }
      }
      pdfPage.setRotation(newRotation);
      const rotatePageModule = window.pdfui.addonInstanceMap.UndoRedoAddon.addon.rotatePageModule;
      rotatePageModule && rotatePageModule.pushUndoStack('rotate', { [currentPageIndex]: { from: pageRotation, to: newRotation } });
    });
  };
  doOpenAboutFoxitPage = () => {
    if (!window.__online__) {
      store.appStore.doNotifyErrors('offline');
      return;
    }
    if (isCNDomain()) {
      windowActionFn(window, 'open', ['https://www.foxitsoftware.cn/company/']);
    } else {
      //let url = 'https://www.foxitsoftware.com/company/about.php';
      let url =
        'https://globe-map.foxitservice.com/go.php?title=company-about&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=phantomonline&language=';
      url += store.appStore.lng.full;
      windowActionFn(window, 'open', [url]);
    }
  };
  doOpenEduExclusivePage = () => {
    if (!window.__online__) {
      store.appStore.doNotifyErrors('offline');
      return;
    }
    windowActionFn(window, 'open', ['https://www.foxitsoftware.cn/solutions/edu/?from=foxitonline']);
  };
  onShowCurrentDlg = (tabName) => {
    const { hasTask } = store.taskStore;
    if (hasTask) return;
    const params = {
      btnName: tabName,
      tabName: 'getting_started',
    };
    this.onClickViewerBtn(params);
  };
  createNewPortfolios = (fileList) => {
    const { hasTask } = store.taskStore;
    if (hasTask) return;
    const params = {
      btnName: CONVERT_NEW_PORTFOLIO,
      result: fileList,
      tabName: 'getting_started',
    };
    this.onClickViewerBtn(params);
  };
  onShowOpenFileDlg = (gaEventKey) => {
    const params = {
      btnName: OPEN_FILE_FROM_GET_START_GUID,
      tabName: 'getting_started',
      gaEventKey: gaEventKey,
    };

    this.onClickViewerBtn(params);
  };
  doShowOpenFileDlgFromGetStartGuid(type) {
    store.userStore.doSendGAEvent({ eventKey: OPEN_FILE, label: 'getting_started' });

    if (this.isDisableButton(OPEN_FILE_LOCAL)) {
      return;
    }
    // 如果是外部网盘插件,就直接打开网盘插件,
    // driverId:"ext_driver_292fb0-16b960",必须是以ext_driver开头,是网盘插件.
    // 否则走后续的switch流程,传过来的必须是字符串校验
    if (typeof type == 'string' && type.substring(0, 10) == 'ext_driver') {
      this.commonForDrives(type);
      return;
    }

    switch (type) {
      case 'OneDrive':
        this.commonForDrives(ONE_DRIVE);
        break;
      case 'Box':
        this.commonForDrives(BOX);
        break;
      case 'Dropbox':
        this.commonForDrives(DROP_BOX);
        break;
      case 'GoogleDrive':
        this.commonForDrives(GOOGLE_DRIVE);
        break;
      case iManage:
        this.commonForDrives(iManage);
        break;
      default:
        this.commonForDrives('LOCAL_COMPUTER');
    }
  }
  doSharePDFFromGetStartGuid = async () => {
    store.userStore.doSendGAEvent({ eventKey: SHARE_DOC, label: 'getting_started' });

    if (this.isDisableButton(SHARE_DOC)) {
      return;
    }

    // if (store.appStore.isIncludeFoxitStorage && store.storageAppStore.isDisableStorage) {
    //   return window.pdfui.alert({ message: intl.get('FoxitStorage.DisableStorage.SharedAlert'), level: 'prompt' });
    // }

    this.commonForDrives('LOCAL_COMPUTER');
    this.setState({
      isOpenFileForShare: true,
    });
  };
  doOrganizePDFFromGetStartGuid = async () => {
    const { hasTask } = store.taskStore;
    if (hasTask) return;
    const params = {
      btnName: OPEN_FILE_LOCAL,
      tabName: 'getting_started',
      gaEventKey: ORGANIZE_PDF,
    };
    store.viewer.setEditorTabName('organize-tab');
    if (!isCNDomain()) {
      this.onShowOpenFileDlg(ORGANIZE_PDF);
    } else {
      this.onClickViewerBtn(params);
    }
  };
  doCleanTargetTab = () => {
    store.viewer.setEditorTabName('');
  };
  doSwitchTab() {
    const { editorTabName } = store.viewer;
    if (!editorTabName) {
      return;
    }
    store.viewer.setEditorTabName('');
    let handle = setTimeout(async () => {
      clearTimeout(handle);
      const tab = await window.pdfui.getComponentByName(editorTabName);
      tab && tab.active();
    }, 0);
  }
  doEditPDFFromGetStartGuid = async () => {
    const { hasTask } = store.taskStore;
    if (hasTask) return;

    const params = {
      btnName: OPEN_FILE_LOCAL,
      tabName: 'getting_started',
      gaEventKey: EDIT_PDF,
    };

    store.viewer.setEditorTabName('edit-tab');
    if (!isCNDomain()) {
      this.onShowOpenFileDlg(EDIT_PDF);
    } else {
      this.onClickViewerBtn(params);
    }
  };
  doESignChinaPDFFromGetStartGuid = async () => {
    const { hasTask } = store.taskStore;
    if (hasTask) return;

    const params = {
      btnName: OPEN_FILE_LOCAL,
      tabName: 'getting_started',
      gaEventKey: ESIGN_CHINA_PDF,
    };

    store.viewer.setEditorTabName('esignCN-tab');
    this.targetTab = 'esignCN-tab';
    if (!isCNDomain()) {
      this.onShowOpenFileDlg(ESIGN_CHINA_PDF);
    } else {
      this.onClickViewerBtn(params);
    }
  };
  goEsignFromEsignTable = async (files) => {
    this.onDropFileOnViewer(files);
    store.viewer.setEditorTabName('esignCN-tab');
  };
  doAddCommentFromGetStartGuid = async () => {
    const { hasTask } = store.taskStore;
    if (hasTask) return;

    const params = {
      btnName: OPEN_FILE_LOCAL,
      tabName: 'getting_started',
      gaEventKey: ADD_COMMENT,
    };
    store.viewer.setEditorTabName('comment-tab');
    if (!isCNDomain()) {
      this.onShowOpenFileDlg(ADD_COMMENT);
    } else {
      this.onClickViewerBtn(params);
    }
  };
  doOpenFileFromGetStartGuid = async (file) => {
    if (isMobile) {
      this.onDropFileOnViewerToH5AndroidWechatOrQQ(file);
      return;
    }
    let clickFunc = () => {
      const { hasTask } = store.taskStore;
      if (hasTask) return;

      const params = {
        btnName: OPEN_FILE_LOCAL,
        tabName: 'getting_started',
      };
      this.onClickViewerBtn(params);
    };
    if (!window.pdfui || !this.pdfui) {
      this.doInitializePDFViewerUI(window._UIExtension, clickFunc);
    } else {
      console.log('begin clickFunc');
      clickFunc();
    }
  };
  /**
   * //TODO FOXIT 云文档
   */
  doOpenDocs = () => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      //TODO FOIXT 替换sso登录弹框
      store.loginNewStore.login();
      return true;
    }
    if ((isMacSsoNoIos || isSafari) && !store.docStore.macToDocPage) {
      // store.docsStore.showMacDocs = true;
      store.saveFileNewStore.setIsShowFwDocsIframe(true);
    } else {
      store.saveFileNewStore.setIsShowFwDocsIframe(true);
    }
  };
  /**
   * //TODO FOXIT 云文档
   */
  doCloseDocs = () => {
    store.saveFileNewStore.setIsShowFwDocsIframe(false);
  };
  onRequestFoxitSign = async () => {
    const { getSignatureFieldFromPDFDoc } = UIExtension.PDFViewCtrl.SignatureUtil;
    const digitalSign = getSignatureFieldFromPDFDoc(store.viewer.pdfViewer.getCurrentPDFDoc()) || [];
    const hasSignedDigitalSign = digitalSign.length && digitalSign.some((item) => item.info.isSigned);

    if (hasSignedDigitalSign) {
      const ok = 'SignatureListContainer.optionsDialog.Ok';
      const message = 'SignatureListContainer.optionsDialog.signedNoRequestSign';
      this.onShowWarningMessage(() => {}, { message, noCancel: true, ok, closeable: false, customClose: false, iconType: 'alert' });
      return;
    }

    let hasSignedESign = false;
    if (!hasSignedDigitalSign) {
      const eSignList = pdfui.pdfViewer.getOnlineSignList();
      if (eSignList && eSignList.length > 0) {
        hasSignedESign = eSignList.some((item) => item.signType === TAB_NAME_MAP.FoxitESign);
      }
    }

    if (hasSignedESign) {
      const ok = 'SignatureListContainer.optionsDialog.Ok';
      const message = 'SignatureListContainer.optionsDialog.requestSignHasUnApplyEsign';
      this.onShowWarningMessage(() => {}, { message, noCancel: true, ok, closeable: false, customClose: false, iconType: 'alert' });
      return;
    }

    const { docModified } = await pdfui.getCurrentPDFDoc();
    if (docModified && store.appStore.docModified) {
      // if (store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage) {
      //   store.storageAppStore.beforeCloseDocument().then(() => {
      //     !hasSignedESign && store.foxitSignStore.doRequestFoxitSign();
      //   });
      //   return ;
      // }
      const ok = 'SignatureListContainer.optionsDialog.Ok';
      const message = 'SignatureListContainer.optionsDialog.requestSignNeedSave';
      this.onShowWarningMessage(() => {}, { message, noCancel: true, ok, closeable: false, customClose: false, iconType: 'alert' });
      return;
    }

    !hasSignedESign && store.foxitSignStore.doRequestFoxitSign();
  };
  onShowDocumentStatus = () => {
    store.foxitSignStore.doShowDocumentStatus();
  };
  onShowManageSignatureDialog = () => {
    if (this.signatureListContainerRef.current) {
      this.signatureListContainerRef.current.showManageSignaturesDialog();
    }
  };

  onApplyAllESignSignature = (showSaveAs = true, callback) => {
    let { pdfViewer } = store.viewer;
    // 判断当前添加的 签名域 里面 如果有 initial则 必须要有它对应的 fullName
    const allSign = pdfViewer.getOnlineSignList();
    if (!allSign || allSign.length === 0) {
      return;
    }

    for (let index = 0; index < allSign.length; index++) {
      const { groupId, fieldType } = allSign[index];
      if (fieldType === FieldType.Initial) {
        // 判断本次添加的签名 （还未签名）是否有对应的 fullName
        const fullNameSignature = allSign.find((s) => s.groupId === groupId && s.fieldType === FieldType.Signature);
        if (!fullNameSignature) {
          pdfViewer.eventEmitter.emit('needSomeTipToShow', 'noFullNameSign');
          window.sessionStorage.setItem('applyEventFromCloseSave', 'no');
          return;
        }
      }
    }
    window.sessionStorage.setItem('applyEventFromCloseSave', 'yes');
    store.foxitSignStore.doApplyAllSignatureWithDigitalSign(showSaveAs, callback);
  };

  isESignTabActive = () => {
    return pdfui && pdfui.activeMainPageTab && pdfui.activeMainPageTab.name === TAB_NAME_MAP.FoxitESign;
  };

  onApplyAllSignature = () => {
    if (this.isESignTabActive()) {
      this.onApplyAllESignSignature();
    } else {
      const pdfViewer = store.viewer.pdfViewer;
      pdfViewer.getStateHandlerManager().switchTo('onlinePdfSign');
      pdfViewer.getCurrentPDFDoc().addFillSignSignaturesToDoc(pdfViewer);
    }
  };
  onShowFillSignTab = async () => {
    const fillSignTab = await pdfui.getComponentByName(TAB_NAME_MAP.FillSign);
    fillSignTab.show();
    fillSignTab.active();
    store.viewer.setEditorTabName(TAB_NAME_MAP.FillSign);
  };
  onCloseFillSignTab = async () => {
    const fillSignTab = await pdfui.getComponentByName(TAB_NAME_MAP.FillSign);
    fillSignTab.hide();
    store.viewer.setEditorTabName('home-tab');
    this.doSwitchTab();
  };
  setActiveMainPageTab = async () => {
    try {
      let { pdfui } = store.viewer;
      let rootComp = await pdfui.getRootComponent();
      if (rootComp) {
        const tabComponent = rootComp.querySelector('@gtab[isActive=true]');
        if (tabComponent) {
          pdfui.activeMainPageTab = tabComponent;
        }
      }
    } catch (error) {}
  };
  onChangeFoxitSignTabVisible = async (isDisableFoxitEsignService) => {
    let isCN_Domain = isCNDomain();
    if (isCN_Domain) {
      return;
    }
    const wrapFoxitESignTab = await pdfui.getComponentByName('wrap-foxitESign-tab');
    if (!wrapFoxitESignTab) return;
    if (isDisableFoxitEsignService) {
      wrapFoxitESignTab.hide();
      let { activeMainPageTab } = pdfui;
      const foxitEsignTab = wrapFoxitESignTab.getComponentByName(TAB_NAME_MAP.FoxitESign);
      if (activeMainPageTab === foxitEsignTab) {
        store.viewer.setEditorTabName('home-tab');
        this.doSwitchTab();
      }
    } else {
      wrapFoxitESignTab && wrapFoxitESignTab.show();
    }
  };
  showSwitchAccountsDlg = (callback) => {
    this.setState({
      messageDlgCfg: {
        target: DLG_TARGETS.ESignSwitchAccountsDialog,
        config: {
          onCancel: () => this.setState({ messageDlgCfg: {} }),
          onSwitchAccount: store.foxitSignStore.updateCurrentESignAccountId.bind(store.foxitSignStore),
          callback,
        },
      },
    });
  };
  cleanInkSignManagerList = async () => {
    const viewer = await pdfui.getPDFViewer();
    const inkSignManager = viewer.getInkSignManager();
    const list = inkSignManager.getList();
    list.forEach((i, index) => {
      inkSignManager.delete(index);
    });
  };
  addToInkSignManagerList = async (list) => {
    if (!list.length) return;
    const viewer = await pdfui.getPDFViewer();
    const inkSignManager = viewer.getInkSignManager();
    list.forEach((item) => {
      const sign = inkSignManager.addInkSign();
      sign.setDataURL(item.dataURL);
      const index = inkSignManager.push(sign);
      inkSignManager.setCurrentInkSign(index);
    });
  };
  setupViewerActionCallback = (name, action) => {
    this.viewerActionMap[name] = action;
  };
  async changeSaveFileBtnIcon() {
    const saveBtnIconMap = {
      [SAVE_AS_FILE]: SAVE_TO_FILE_CLASS_TOOLBAR,
      [SAVE_TO_GOOGLE_DRIVE]: SAVE_TO_GOOGLE_DRIVE_CLASS_32,
      [SAVE_TO_LOCAL]: SAVE_TO_LOCAL_CLASS_TOOLBAR,
      [SAVE_TO_ONE_DRIVE]: SAVE_TO_ONE_DRIVE_CLASS_32,
      [SAVE_TO_BOX]: SAVE_TO_BOX_CLASS_32,
      [SAVE_TO_DROPBOX]: SAVE_TO_DROPBOX_CLASS_32,
      [SAVE_TO_IMANAGE]: SAVE_TO_IMANAGE_CLASS_32,
      [SAVE_TO_FOXIT_STORAGE]: SAVE_TO_FOXIT_STORAGE_CLASS_32,
    };
    const saveType = window.localStorage.getItem('last_save_type') || SAVE_TO_LOCAL;
    const icon = saveBtnIconMap[saveType] || SAVE_TO_LOCAL_CLASS;
    const comp = await pdfui.getComponentByName('download-file-button');
    comp && comp.setIconCls(icon);
  }
  // ! convertImageToPDFDoc 图片转pdf文件
  // TODO FOXIT 这里修改为调用后台装换接口，获取文档。后展示文件
  convertImageToPDFDoc(file) {
    let fn = () => {
      let fileName = file.name ? file.name : 'untitle.pdf';
      store.convert.openFileBeforeConvert(file, fileName);
    };
    if (store.appStore.docModified) {
      this.onShowToSaveBeforeOpen((isToSave) => {
        !isToSave && store.appStore.doUpdateDocModified(false);
        // is true, do not open new file
        !isToSave && fn();
      });
    } else {
      fn();
    }
  }
  doHandleViewerAction({ btnName, result, willDoFn }) {
    console.log(btnName);
    console.log(result);
    console.log(willDoFn);
    const saveBtnList = [
      SAVE_FILE_BTN_HIDDEN_SLOT,
      SAVE_TO_LOCAL,
      SAVE_AS_FILE,
      SAVE_TO_GOOGLE_DRIVE,
      SAVE_TO_IMANAGE,
      SAVE_TO_ONE_DRIVE,
      SAVE_TO_BOX,
      SAVE_TO_DROPBOX,
      SAVE_TO_IMANAGE,
      SAVE_TO_FOXIT_STORAGE,
    ];
    let newBtnName = btnName;
    if (saveBtnList.includes(btnName)) {
      if (btnName === SAVE_FILE_BTN_HIDDEN_SLOT) {
        newBtnName = window.localStorage.getItem('last_save_type') || SAVE_TO_LOCAL;
      }
      window.localStorage.setItem('last_save_type', newBtnName);
      this.changeSaveFileBtnIcon();
    }
    //See directory RibbonTabAdapter, part of tab actions will be moved to there.
    if (newBtnName !== CONVERT_FILES_TO_PDF && this.viewerActionMap[newBtnName]) {
      const fn = this.viewerActionMap[newBtnName];
      fn({ btnName: newBtnName, result, willDoFn });
      return;
    }
    //let env = null;
    switch (newBtnName) {
      case FW_DOWNLOAD_FILE_BUTTON: {
        // ! 文件下载功能更新
        store.saveFileNewStore.saveFile('downFile');
        break;
      }
      case COMMENT_EXPORT_WORD_BUTTON: {
        fileController.getDocMetaDataByFormat((metaData) => {
          //判断是否为tagged pdf
          if (!metaData.isTagged) {
            let msg = intl.get('Error.Notagged');
            pdfui.alert({
              message: msg,
              isHTML: true,
            });
          } else {
            let msg = intl.get('commentExportWordTip');
            pdfui
              .$confirm({
                message: msg,
                id: 'comment-export-word',
                again: true,
                autoHide: false,
                againText: 'common-dialogs.notAgain',
                isHTML: true,
              })
              .then(() => {
                this.onShowImportCommentDlg(metaData);
                return true;
              });
          }
        });
        break;
      }
      case REQUEST_SIGNATURE: {
        this.onRequestFoxitSign();
        break;
      }
      case MANAGE_SIGNATURE: {
        this.onShowManageSignatureDialog();
        break;
      }
      case APPLY_ALL_SIGNATURE: {
        Promise.resolve().then(() => this.onApplyAllSignature());
        break;
      }
      case DOCUMENT_STATUS: {
        this.onShowDocumentStatus();
        break;
      }
      case CLOSE_SIGN: {
        this.onCloseFillSignTab();
        break;
      }
      case SWITCH_ACCOUNTS: {
        this.showSwitchAccountsDlg();
        break;
      }
      case FILL_SIGN_BUTTON_HOME: {
        this.onShowFillSignTab();
        break;
      }
      case FOXIT_PLUG_INS: {
        this.onShowFoxitPlugInsDlg();
        break;
      }
      case ROTATE_LEFT:
      case HOME_TAB_PAGE_ROTATE_LEFT:
      case HOME_TAB_PAGE_ROTATE:
      case ORGANIZE_TAB_PAGE_ROTATE_LEFT: {
        this.rotateCurrentPage(ROTATE_LEFT);
        break;
      }
      case ROTATE_RIGHT:
      case HOME_TAB_PAGE_ROTATE_RIGHT:
      case ORGANIZE_TAB_PAGE_ROTATE_RIGHT: {
        this.rotateCurrentPage(ROTATE_RIGHT);
        break;
      }
      case DOWNLOAD_CLIENT: {
        doDownloadClient();
        break;
      }
      case HELP_CENTER: {
        this.doHelpCenterNav();
        break;
      }
      case UPDATE_LOGS: {
        this.onShowUpdateLogs();
        break;
      }
      case FEEDBACK:
      case ESIGN_CN_FEEDBACK: {
        store.appStore.onOpenFeedbackPage();
        break;
      }
      case FOXIT_SOFTWARE: {
        this.onShowAboutFoxitDlg();
        break;
      }
      case EDU_EXCLUSIVE: {
        this.doOpenEduExclusivePage();
        break;
      }
      // TODO FOXIT 注释福软的转换功能
      case CONVERT_FILES_TO_PDF: {
        console.log('测试：转换2 打开文件时候判断是否转换');
        if (result.type === 'application/pdf') {
          this.onShowToSaveBeforeOpen((isToSave) => {
            let fileName = result.name;
            !isToSave && store.appStore.doUpdateDocModified(false);
            // is true, do not open new file
            !isToSave &&
              window.pdfui.openPDFByFile(result, { fileName }).then(() => {
                // this.onHideHomeStart()
              });
          });
          return;
        }
        // TODO FOXIT 如果result.type 为image 图片
        if (result.type.match('image') || store.convert.MIMEType.includes(result.type)) {
          this.onShowToSaveBeforeOpen((isToSave) => {
            // is true, do not open new file
            // TODO FOXIT 原图片格式，默认是字节打开，0701版本更改为office、图片格式走转换接口后打开pdf文档
            !isToSave && this.convertImageToPDFDoc(result);
            // !isToSave && store.appStore.doUpdateDocModified(true);
          });
          return;
        }
        // TODO FOXIT 云编辑占不支持转换，将此处转换改为弹窗提示非pdf
        store.common.setIsShowNoPdfDialog(true);
        break;
      }
      case CONVERT_PDF_TO_WORD:
      case CONVERT_PDF_TO_EXCEL:
      case CONVERT_PDF_TO_PPT:
      case CONVERT_PDF_TO_IMG:
      case EXPORT_ALL_IMG:
      case OCR_PDF_TO_PDF:
        this.onShowConvertDlg(btnName);
        break;
      case HELP_CUSTOMER_SERVICE:
        console.log('帮助');
        this.showCustomerService();
        break;
      case HELP_ABOUT:
        this.onShowAboutFoxitDlg();
        break;
      case HELP_OPEN_MEMBER:
        let payOrigin = isMacSsoNoIos || isSafari ? 'edit.foxitcloud.cn/pay/edit/' : 'www.foxitcloud.cn/pay/edit/';
        let url = `https://${payOrigin}${location.search.trim().slice(1) && '?'}${location.search.trim().slice(1)}`;
        if (window.location.search.includes('from=pdf365/?refer=bd')) {
          url = `https://www.foxitcloud.cn/pay/edit/baidu365/${location.search.trim().slice(1) && '?'}${location.search.trim().slice(1)}`;
        }
        window.open(url);
        break;
      case HELP_EXCHANGE_MEMBER:
        window.open('https://edit.foxitcloud.cn/duihuan/');
        break;
      case CONVERT_PREFLIGHT:
        this.onShowPreflightDlg();
        break;
      case FORM_RESET_FIELD:
        this.onShowResetFormWarningDlg();
        break;
      case FORM_ADD_TOOLTIP:
        fileController.addTooltipForFormFiled();
        break;
      case FORM_COMBINE_FORMS_TO_SHEET:
        this.onShowExportMultiFormsDlg();
        break;
      case CREATE_NEW_ACTION:
        this.createNewActionDialogRef.current.showDialog('create');
        break;
      case RUN_ACTION:
        this.runActionDialogRef.current.showDialog();
        break;
      case MANAGE_ACTIONS:
        this.manageActionsDialogRef.current.showDialog();
        break;
      case VIEW_TAB_COMPARE:
        this.onShowCompareDlg(VIEW_TAB_COMPARE);
        break;
      case USER_ENTRY_SIGN_IN: {
        this.onLoginIn();
        break;
      }
      case USER_ENTRY_SIGN_UP: {
        // this.onSignUp();
        this.onLoginIn();
        break;
      }
      case USER_SWITCH_LANGUAGE: {
        store.appStore.changeLanguage();
        break;
      }
      case USER_GOTO_ADMIN_CONSOLE: {
        this.onGoToAdminConsole();
        break;
      }
      case USER_GOTO_EXIT: {
        this.onLoginOut(false);
        break;
      }
      case USER_POLICY: {
        windowActionFn(window, 'open', [getPrivacyPolicyUrl()]);
        break;
      }
      case USER_ACCOUNT: {
        store.userStore.doGoToAccount();
        //store.userStore.setAcountVisibe(true);
        store.userStore.doSendGAEventByUser({ eventKey: MY_ACCOUNT, label: 'upper_right_area' });
        break;
      }
      case USER_TERMS: {
        windowActionFn(window, 'open', [getTermsOfServiceUrl()]);
        break;
      }
      case OCR_QUICK_RECOGNITION:
        const loopAlert = function (exprFunction) {
          pdfui
            .alert({
              id: 'OCR_QUICK_RECOGNITION' + Date.now(),
              again: 'recognition-form:quickRecognition.alert.againText',
              message: 'recognition-form:quickRecognition.alert.content',
              level: 'warning',
            })
            .then((isNotAgain) => {
              !isNotAgain && exprFunction() && loopAlert(exprFunction);
            });
        };
        let storageData = localStorage.getItem(RecoginizeText.storageKey());
        const { languages = [], findAll = false, textType = 2, recognize = false } = storageData ? JSON.parse(storageData) : {};
        convertController.doConvertScannedDocument(
          {
            languages: languages.join(','),
            is_editable: textType === 2,
            to_find_all_suspects: findAll,
            to_recognize_line_as_path: recognize,
            can_do_ocr: true,
          },
          (result) => {
            let disablePages = result.data.disablePage;
            disablePages = (disablePages && disablePages.split(',')) || [];
            if (disablePages.length > 0) {
              let index = 0;
              loopAlert(() => {
                index += 1;
                return disablePages[index] !== undefined;
              });
            }
          },
        );
        break;
      default: {
        if (newBtnName.indexOf(USER_SWITCH_LANGUAGE_) === 0) {
          store.appStore.changeLanguage(newBtnName.substr(USER_SWITCH_LANGUAGE_.length));
          break;
        }
        willDoFn();
        break;
      }
    }
  }
  showCustomerService = () => {
    this.setState({
      isShowCustomerServiceDlg: true,
    });
  };
  hideCustomerService = () => {
    this.setState({
      isShowCustomerServiceDlg: false,
    });
  };
  onClickFileInputToOpen = () => {
    // const { hasSignIn } = store.userStore
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      //! 打开文件未登录时，先login
      store.loginNewStore.login();
      return true;
    }
    if (!hasSignIn && !isJPDomain()) {
      //TODO FOIXT 替换sso登录弹框
      store.loginNewStore.login();
      return true;
    }
    const fn = async () => {
      store.docStore.setDocDriveName('');
      const input = this.inputFileRef.current;
      if (!isMobile) {
        let button = await pdfui.getComponentByName(OPEN_FILE_LOCAL);
        if (!button) {
          const paddle = await pdfui.getComponentByName('fv--file-tab-paddle');
          await paddle.trigger('shown');
          button = await pdfui.getComponentByName(OPEN_FILE_LOCAL);
        }
        button.parent.select(button);
      }
      if (input) {
        // to do click input
        input.click();
        // 监听文本上传事件，消除已编辑记录
        input.addEventListener('change', () => {
          store.appStore.doUpdateDocModified(false);
        });
      }
    };

    if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
      fn();
      return;
    }
    this.onShowToSaveBeforeOpen((isToSave) => {
      // 这里选择不保存后会清空修改的记录，导致鉴权问题，先去除
      // !isToSave && store.appStore.doUpdateDocModified(false);
      // is true, do not open new file
      !isToSave && fn();
    });
  };
  onShowCertificateProtectDlg = () => {
    const pdfDoc = window.pdfui.pdfViewer.currentPDFDoc;
    const { securityUtils, securityEncryptType } = window.UIExtension.PDFViewCtrl.shared;

    const handler = (showAlreadySecuredMsg) => {
      const showDlg = () => {
        store.accountStore.updateTrialPermission(PROTECT_CERTIFICATE_PROTECT);
        this.setState({ isShowCertificateProtectDialog: true });
      };
      if (showAlreadySecuredMsg) {
        window.pdfui
          .confirm({
            message: 'password-protect:warning.already-secured',
            level: 'question',
          })
          .then(
            () => {
              showDlg();
            },
            () => {},
          );
      } else {
        showDlg();
      }
    };
    pdfDoc.getSecurityType().then((securityType) => {
      if (securityType === securityEncryptType.Password) {
        if (pdfDoc.hasOwnerPassword && !securityUtils.getHasInputOwnerPwd()) {
          securityUtils.requestOwnerPassword(window.pdfui, () => {
            handler(true);
          });
        } else {
          handler(true);
        }
      } else if (
        securityType === securityEncryptType.Certificate ||
        securityType === securityEncryptType.Unknown ||
        securityType === securityEncryptType.None
      ) {
        handler(false);
      } else {
        handler(true);
      }
    });
  };
  onClickCreateBlankPdfToOpen = async () => {
    store.docStore.setDocDriveName('');
    if (createBlankPageThrottle || !window.pdfui) {
      return;
    }
    const createNewDoc = () => {
      pdfui.createNewDoc().then(() => {
        const pdfViewer = pdfui.pdfViewer;
        pdfViewer.currentPDFDoc.setViewPreference('PageLayout', 'SinglePage');
        pdfViewer.getViewModeManager().switchTo('single-page-view-mode');
      });
    };

    if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
      createNewDoc();
      createBlankPageThrottle = true;
      setTimeout(() => {
        createBlankPageThrottle = false;
      }, 3000);
      return;
    }
    let doc = await pdfui.getCurrentPDFDoc();
    // let fileName = '';
    if (doc && doc.metadata) {
      fileName = doc.metadata.FileName;
    }

    // ! 云编辑 当添加封面页后打开文件，不在弹窗提示文件修改是否保存,直接打开文档
    if (store.addCoverPageStore.addCoverOpenFile) {
      callback && callback(false);
      store.addCoverPageStore.setAddCoverOpenFile(false);
      store.appStore.doUpdateDocModified(false);
      return false;
    }
    this.onShowWarningMessage((isOk) => {
      if (isOk) {
        // TODO FOXIT 原有修改后保存文件逻辑，修改为云编辑加入封面页的保存逻辑
        // fileController.saveToLocal(() => {
        //   store.appStore.doUpdateDocModified(false);
        //   pdfui.createNewDoc();
        // });
        store.saveFileNewStore.saveFile('downFile', store.appStore.docModified);
        // store.appStore.doUpdateDocModified(false);
      } else {
        // store.appStore.doUpdateDocModified(false);
        pdfui.createNewDoc();
      }
    });
  };

  onShowFoxitPlugInsDlg = () => {
    this.setState({
      messageDlgCfg: {
        target: FoxitPlugIns,
        config: { onCancel: this.onCloseModalDlg.bind(this, null) },
      },
    });
    file = file instanceof File ? file : file.target.files[0];
    const fn = () => {
      console.log('测试：转换3');
      console.log('测试：打开文件时进行文件转换前判断');
      if (file.type === 'application/pdf') {
        store.viewer
          .doOpenFile(file, (isLoading) => {
            isLoading && this.doShowEditorLoading();
          })
          .catch((e) => {
            this.doCloseSidebar();
            this.onErrorFromViewer(e, OPEN_FILE_LOCAL);
          });
      } else {
        if (this.isDisableButton(CONVERT_FILES_TO_PDF)) {
          return;
        }
        // TODO FOXIT 如果result.type 为image 图片
        if (file.type.match('image') || store.convert.MIMEType.includes(file.type)) {
          this.convertImageToPDFDoc(file);
          return;
        }
        // TODO FOXIT 云编辑占不支持转换，将此处转换改为弹窗提示非pdf
        store.common.setIsShowNoPdfDialog(true);
        return;
      }
    };
    fn();
  };
  // onClickFileInputToOpen = ()=>{
  //   this.fileTabRef.current.wrappedInstance.onClickFileInputToOpen();
  // }
  // onShowCertificateProtectDlg = () => {
  //   this.protectTabRef.current.wrappedInstance.onShowCertificateProtectDlg();
  // };
  doCloseSidebar = async () => {
    if (!this.pdfui) return;
    const sidebar = await this.pdfui.getComponentByName('sidebar');
    sidebar && sidebar.collapse();
  };
  doGoToPage = async (index) => {
    let pdfDocRender = await this.pdfui.getPDFDocRender();
    pdfDocRender.goToPage(index);
  };
  onErrorFromViewer(err, name) {
    console.error('TCL: onErrorFromViewer -> err, name', err, name);
    this.onCloseViewerLoading();
    let messageDlgCfg = {
      target: MessageDialog,
      config: {
        msg: { id: 'Error.OpenFile' },
        onOk: this.onCloseModalDlg,
        onClose: null,
      },
    };

    switch (name) {
      case OPEN_FILE_LOCAL:
        break;
      case OPEN_FILE_FROM_URL:
      case OPEN_FILE_FROM_URL_MOBILE:
        messageDlgCfg.msg = { id: 'Error.OpenURLFile' };
        break;
      default:
        return;
        break;
    }

    this.setState({
      messageDlgCfg,
    });
  }
  get componentsNameWithoutController() {
    return [
      ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
      ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
      ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
      ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
      ORGANIZE_TAB_PAGE_REVERSE,
    ];
  }

  onProxyComponentHandle(component) {
    if (!component || !component.controller || component.rewrite) {
      return;
    }
    let _this = this;
    const name = component.name;

    let _instance;
    let defaultFn = () => {};
    const _fn = function () {
      try {
        let args = arguments;
        let tabName = _this.getComponentTabName(component);
        let value = { btnName: name, result: arguments[0], tabName };
        if (isBuiltIn(name)) {
          value.before = true;
          value.willDoFn = () => {
            try {
              const _promise = defaultFn.apply(this, args);
              if (!_promise) {
                return;
              }
              return _promise.catch((err) => {
                console.error('TCL: onProxyComponentHandle value.willDoFn -> err', err, name);
                console.log('errorfrom 7');
                _this.onErrorFromViewer(err, name);
              });
            } catch (error) {
              console.error('TCL: value.willDoFn -> error', error, name);
            }
          };
        } else value.willDoFn = defaultFn.bind(_instance);
        if ([REQUEST_SIGNATURE, DOCUMENT_STATUS, MANAGE_SIGNATURE, APPLY_ALL_SIGNATURE].includes(name)) {
          value.tabName = 'Foxit_eSign_Tab';
        }
        _this.onClickViewerBtn(value);
      } catch (err) {
        console.error('TCL: component.controller.handle -> err', err);
      }
    };

    const rewriteFunction = (instance, fn = 'click') => {
      _instance = instance;
      defaultFn = _instance[fn];
      _instance[fn] = _fn;
    };

    // if (this.componentsNameWithoutController.includes(name)) {
    //   return rewriteFunction(component);
    // }
    if (component.controller) {
      component.controller.onlinePermissionHandler = function (component, eventType, continueTodo) {
        //console.log(component, eventType);
        if (eventType !== 'click') {
          return continueTodo();
        }
        if (!isBuiltIn(component.name)) {
          return continueTodo();
        }
        let tabName = _this.getComponentTabName(component);
        _this.onClickViewerBtn({
          btnName: component.name,
          tabName: tabName,
          before: true,
          willDoFn: continueTodo,
        });
      };
      rewriteFunction(component.controller, 'handle');
    }

    //rewriteFunction(component.controller,'handle')
  }

  async onProxyComponentsHandle(pdfui, names) {
    let root = await pdfui.getRootComponent();

    if (!isMobile) {
      let selectors = [
        'dropdown-zoom @dropdown-button',
        'editable-zoom-dropdown @dropdown-button',
        'float-bar-view-size @dropdown-button',
        'fv--page-contextmenu @contextmenu-item',
        'fv--bookmark-contextmenu @contextmenu-item',
        'fv--bookmark-contextmenu @option-group-item',
        'sidebar-bookmark @xbutton',
        'fll-sign-tab-group @xbutton,create-signature-btn',
        'fv-attachment-sidebar-panel @xbutton',
        'comment-operate-button-group @xbutton',
        'destinations @xbutton',
        'sidebar-field @option-group-item',
        'commentlist-show-comments,commentlist-hide-comments,commentlist-sort-comment @dropdown-button',
        'fv--contextmenu-item-create-push-button',
        ...this.componentsNameWithoutController,
      ];
      selectors.forEach((selector) => {
        root.querySelectorAll(selector).forEach((item) => {
          names += ',' + item.name;
          addAutoNameBuiltIn(item.name);
        });
      });
    }

    names = ',' + names + ',';

    const rewriteControll = (this.rewriteControll = () => {
      root.querySelectorAll(names).forEach((component) => {
        names = names.replace(',' + component.name + ',', ',');
        this.onProxyComponentHandle(component);
      });
    });

    rewriteControll();

    root.on('lazy-content', async (cmp) => {
      if (cmp.name.indexOf('paddle') === -1) {
        return;
      }
      rewriteControll();
      const doc = pdfui.pdfViewer.getCurrentPDFDoc();
      if (doc) {
        this.onDisableComponentsByPermission();
        this.changeEditorBtnState();
      }
      if (isCNDomain()) {
        this.onHideViewerComponents(['help-tab-group-download-client']);
        const { isWindowsOS, isMacOS } = store.appStore;
        if (!isWindowsOS && !isMacOS) {
          this.onHideViewerComponents(['help-tab-group-download-client-cn']);
        }
      } else {
        this.onHideViewerComponents(['help-tab-group-edu-exclusive', EDU_EXCLUSIVE, 'help-tab-group-download-client-cn']);
      }

      doc && this.updateButtons(doc);

      switch (cmp.name) {
        case 'fv--file-tab-paddle':
          const list = toJS(store.userStore.invisibleOpenSaveBtn);

          this.onHideViewerComponents(list);
          break;
        case 'foxit-ai-panel':
          !isMobile && onDragAiPanel();
          break;
        case 'fv--fill-sign-tab-paddle':
          // show foxitSign when  US or EU Domain
          if (isPdfOnlineDomain() || isCommonFeatureDomain()) {
            const signGroup = await pdfui.getComponentByName('add-define-text-group-sign');

            signGroup && signGroup.removeCSSClass('hide-request-signature');
          }
          break;
        case 'fv--help-tab-paddle':
          const pluginStore = getQueryVariable('pluginStore');
          const { isEdu } = store.userStore;

          if (pluginStore || isEdu) {
            document.querySelector('div[name=help-tab-group-foxit-plug-ins]').style.display = 'inline-flex';
          }
          break;
      }
    });
  }

  async onProxyPluginComponentsHandle(pdfui, names) {
    let root = await pdfui.getRootComponent();
    root.querySelectorAll(names).forEach((component) => {
      this.onProxyComponentHandle(component);
    });
  }

  onBindComponentsCallback(pdfui) {
    let names = '';
    if (isMobile) {
      names = COMMON_BUTTONS_MOBILE.join(',');
    } else {
      names = COMMON_BUTTONS.join(',');
    }
    this.onProxyComponentsHandle(pdfui, names);
    // TODO FOXIT 此处调用福软接口，页面去掉这个逻辑。
    // this.onBindTabComponentCallback(pdfui);
  }

  loadPlugin(pdfui) {
    if (isMobile) {
      return;
    }
    if (this.pluginLoaded) return Promise.resolve();
    return pdfui.loadPluginByUrl(PLUGIN_URLS.pageEditor).then((plugin) => {
      plugin.on('load-finish', () => {
        this.onProxyPluginComponentsHandle(pdfui, PE_PLUGIN_ALL_BTNS.join(','));
      });
      plugin.enable();
      this.pluginLoaded = true;
    });
  }
  async onBindTabComponentCallback(pdfui) {
    if (!isIE && !isMobile) {
      pdfui.getComponentByName('edit-tab').then((component) => {
        if (!component) {
          return;
        }
        component.once(window.UIExtension.UIConsts.COMPONENT_EVENTS.ACTIVE, () => this.loadPlugin(pdfui));
      });
    }

    try {
      const manager = await pdfui.getPluginManager();
      const plugin = await manager.loadPluginByObj(JSON.parse(devPluginManifest));

      plugin.enable();
    } catch (error) {}
  }

  onLoadLocalDevPlugin = async () => {
    const devPluginManifest = storageGetItem(localStorage, 'devPluginManifest');

    if (!devPluginManifest) {
      return;
    }

    try {
      const manager = await pdfui.getPluginManager();
      const plugin = await manager.loadPluginByObj(JSON.parse(devPluginManifest));

      plugin.enable();
    } catch (error) {}
  };
  onLoadUserPlugin = (emitter, loadbehavior) => {
    const hasSignIn = store.loginNewStore.isLogin;
    const loadUserPlugin = async () => {
      try {
        const res = await store.appStore.doGetUserPluginList();

        if (res.ret === 0) {
          for (let i = 0; i < res.data.list.length; i++) {
            const item = res.data.list[i];
            const manifest = JSON.parse(item.config_text);
            // 如果加载时机的配置项不存在,默认加载时机是文件打开后才加载.
            // 如果插件加载时机配置项存在, 判断是否的当前时机再进行加载.
            if (
              (!manifest.load_behavior && loadbehavior == WEBPLUGIN_LOAD_BEHAVIOR_FILEOPEN) ||
              (manifest.load_behavior && manifest.load_behavior.includes(loadbehavior))
            ) {
              if (item.status === '0') {
                continue;
              }

              try {
                const manager = await pdfui.getPluginManager();
                const plugin = await manager.loadPluginByObj(manifest);
                plugin.enable();
              } catch (error) {
                store.pluginStore.doAppendLoadFailedPlugin([manifest]);
              }
            }
          }
        }
      } catch (error) {}
    };

    if (hasSignIn) {
      loadUserPlugin();
    } else {
      emitter.on(USER_SIGN_IN_SUCCESS, () => {
        loadUserPlugin();
      });
    }
  };
  onBindSidebarComponentsCallback(commentComponent) {
    if (!commentComponent.menuComponent) {
      return;
    }
    SIDEBAR_COMMENT_CARD_LIST.forEach((name) => {
      let component = commentComponent.menuComponent.getComponentByName(name);
      if (!component) return;
      this.onProxyComponentHandle(component);
    });
  }

  onShowViewerLoading() {
    if (this.loadingPromise) {
      return this.loadingPromise.then((cmp) => {
        !this.docRendered && cmp.show(document.body);
        return cmp;
      });
    }
    return (this.loadingPromise = new Promise((res) => {
      useIdleCallback(() => {
        const loadingComponent = this.pdfui.parseTemplate(`<loading text="" animation="" focus="false"></loading>`, []);
        loadingComponent.mounted();

        let coverOn = document.body;
        loadingComponent.open(coverOn);

        loadingComponent.on('shown', () => {
          // clearTimeout(this.hideTimeout)
        });

        loadingComponent.close = () => {
          // clearTimeout(this.hideTimeout)
          // this.hideTimeout = setTimeout(() => {
          if (this.docRendered) this.loadingCmp.hide();
          // }, 0);
        };

        this.loadingCmp = loadingComponent;

        res(loadingComponent);
      });
    }));
  }
  onCloseViewerLoading() {
    store.appStore.updateProgressingInfo(false);
    this.docRendered = 1;
    this.loadingPromise.then(() => {
      this.loadingCmp.hide();
    });
  }
  onListenSidebarResize() {
    let $jQuery = window.UIExtension.jQuery;
    window.pdfui.getComponentByName('sidebar').then((component) => {
      if (!component) {
        return;
      }

      let thumb_page_selector = '.fv__ui-thumbnail-container .fv__thumb-image-container .fv__thumb-page';
      component.on(window.UIExtension.UIConsts.COMPONENT_EVENTS.RESIZE, function () {
        let pages = $jQuery(thumb_page_selector);
        if (isMobile) {
          pages.css({ 'margin-left': '0.1rem' });
          return;
        }
      });
    });
  }

  async onDisableComponentsByPermission(excludes = []) {
    //BUTTONS_BY_PERMISSION
    let _this = this;
    const { User_Permissions } = window.UIExtension.PDFViewCtrl.PDF.constant;
    const { securityEncryptType } = window.UIExtension.PDFViewCtrl.shared;
    useIdleCallback(async () => {
      const permission = await fileController.getUserPermissions();
      const pdfDoc = await window.pdfui.getCurrentPDFDoc();
      if (!pdfDoc) return;

      const hasForm = await pdfDoc.hasForm();
      const isPdfaDoc = await pdfDoc.isPdfaDoc();
      const pdfaEditable = pdfDoc.pdfaEditable;
      const securityType = await pdfDoc.getSecurityType();
      console.log(User_Permissions);

      // TODO FOXIT 云编辑禁用复制功能后，处理转换置灰
      const currentDoc = window.pdfui.pdfViewer.currentPDFDoc;
      const { securityUtils } = window.UIExtension.PDFViewCtrl.shared;
      let conventArr = [
        'convert-pdf-to-word',
        'convert-pdf-to-excel',
        'convert-pdf-to-ppt',
        'convert-pdf-to-img',
        'export-all-img',
        'ocr-pdf-to-pdf',
        'convert-tab-group-to-file',
      ];
      let uiData = null;
      currentDoc.getStdCipherOptions().then((options) => {
        uiData = Object.assign(securityUtils.getPermissionDefaultUIData(), options, securityUtils.convertPermissionToUIData(options.permission));
        console.log(uiData);
        if (uiData.copy === false) {
          // 转换功能lock
          conventArr.map((item) => {
            _this.pdfui.getComponentByName(item).then((component) => {
              component && component.lock();
            });
          });
        } else {
          conventArr.map((item) => {
            _this.pdfui.getComponentByName(item).then((component) => {
              component && component.unlock();
            });
          });
        }
      });

      if (permission & User_Permissions.modify && permission & User_Permissions.annotForm && permission & User_Permissions.fillForm) {
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-edit').then((component) => component && component.unlock());
        _this.pdfui.getComponentByName('find-replace').then((component) => component && component.unlock());
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-add-text').then((component) => component && component.unlock());
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-add-image').then((component) => component && component.unlock());
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-add-shape').then((component) => component && component.unlock());
      } else {
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-edit').then((component) => component && component.lock());
        _this.pdfui.getComponentByName('find-replace').then((component) => component && component.lock());
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-add-text').then((component) => component && component.lock());
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-add-image').then((component) => component && component.lock());
        _this.pdfui.getComponentByName('fv--plugin-PageEditor-add-shape').then((component) => component && component.lock());
      }
      BUTTONS_BY_PERMISSION.forEach((btn) => {
        if (excludes.indexOf(btn) !== -1) return;

        let isEnable = fileController.checkPermission(permission, User_Permissions, btn);
        if (btn === FORM_RESET_FIELD) {
          // form-reset-field功能权限需要结合hasForm进行判断
          isEnable = isEnable && hasForm;
        } else if (
          btn === FORM_RECOGNITION_FORM ||
          btn === FORM_CREATE_TEXT_FIELD ||
          btn === FORM_CREATE_SIGN_FIELD ||
          btn === FORM_CREATE_RADIO_BTN_FIELD ||
          btn === FORM_CREATE_PUSH_BTN_FIELD ||
          btn === FORM_CREATE_CHECK_BOX_FIELD ||
          btn === FORM_CREATE_COMBO_BOX_FIELD ||
          btn === FORM_CREATE_LIST_BOX_FIELD ||
          btn === FORM_CREATE_IMAGE_FIELD ||
          btn === FORM_CREATE_DATE_FIELD ||
          btn === FORM_ADD_TOOLTIP
        ) {
          isEnable = isEnable && (!isPdfaDoc || (isPdfaDoc && pdfaEditable));
        } else if (btn === PROTECT_CERTIFICATE_PROTECT) {
          isEnable = securityType === securityEncryptType.Certificate ? pdfDoc.isOwner() : isEnable && (!isPdfaDoc || (isPdfaDoc && pdfaEditable));
          if (pdfDoc.hasSignature()) isEnable = false;
        } else if (btn === HELP_CUSTOMER_SERVICE || btn === HELP_ABOUT || btn === HELP_OPEN_MEMBER || btn === HELP_EXCHANGE_MEMBER) {
          isEnable = true;
        } else if (btn === OCR_PDF_TO_PDF) {
          isEnable = true;
        }
        if (!isEnable) {
          _this.pdfui.getComponentByName(btn).then((component) => component && component.lock());
        } else {
          _this.pdfui.getComponentByName(btn).then((component) => component && component.unlock());
        }
      });

      this.hideComponentsByDashboard();
    });
  }

  onListenClickEventByGA() {
    window.pdfui.addViewerEventListener(window.UIExtension.PDFViewCtrl.PDF.DataEvents.pageMoved, function (/*fromPageIndex, destPageIndex*/) {
      store.userStore.doSendGAEvent({ eventKey: SIDEBAR_MOVE_PAGE, label: 'sidebar' });
    });
    // add stamp
    let $$ = window.UIExtension.jQuery;
    let listenEvent = 'mouseup';
    if (isMobile) listenEvent = 'touchend';
    let selector = "ul.fv__ui-stamplist-dropdown [name='create-stamp-handle-ui'] li ul li";
    $$("#pdf-ui [name='stamp-drop-down-ui']").on(listenEvent, selector, function (/*event*/) {
      store.userStore.doSendGAEvent({ eventKey: COMMENT_ADD_STAMP, label: 'comment_tab' });
    });
    $$("#pdf-ui [name='stamp-drop-down-ui']").on(listenEvent, `[name='${COMMENT_ADD_CUSTOM_STAMP}']`, function (/*event*/) {
      store.userStore.doSendGAEvent({ eventKey: COMMENT_ADD_CUSTOM_STAMP, label: 'comment_tab' });
    });
    $$("#pdf-ui [name='change-color-dropdown-list']").on('mousedown', '.fv__ui-change-color-dropdown-color-round', (e) => {
      let index = $$(e.currentTarget).prevAll().length;
      store.userStore.doSendGAEvent({ eventKey: HOME_CHANGE_MODE + index, label: 'home_tab' });
    });
    //
    $$("#pdf-ui [name='" + FORM_HIGHLIGHT_FIELDS + "'] input[type='checkbox']").on('change', () => {
      store.userStore.doSendGAEvent({ eventKey: FORM_HIGHLIGHT_FIELDS, label: 'form_tab' });
    });
    $$("#pdf-ui [name='" + FORM_KEEP_TOOL_SELECTED + "'] input[type='checkbox']").on('change', () => {
      store.userStore.doSendGAEvent({ eventKey: FORM_KEEP_TOOL_SELECTED, label: 'form_tab' });
    });

    // sidebar:
    let sidebarNav = '.fv__ui-sidebar-ctls a.fv__ui-sidebar-nav-ctrl .fv__ui-sidebar-nav-icon';
    $$('#pdf-ui .fv__ui-sidebar')
      .off(listenEvent)
      .on(listenEvent, sidebarNav, (e) => {
        if (!e.currentTarget || !e.currentTarget.classList) {
          return;
        }
        let classList = e.currentTarget.classList;
        // ie10/11 compatibility
        let value = getDOMTokenListValue(classList);
        if (!value) {
          return;
        }

        let cls = value.replace('fv__ui-sidebar-nav-icon', '').replace(/\s+/g, '');
        if (cls && cls.indexOf('fv__icon-sidebar-') !== -1) {
          let name = cls.replace('fv__icon-sidebar-', 'sidebar-');
          store.userStore.doSendGAEvent({ eventKey: name, label: 'sidebar' });
        }
      });
    window.pdfui.addUIEventListener(window.UIExtension.UIEvents.addReplySuccess, (/*a, b*/) => {
      store.userStore.doSendGAEvent({ eventKey: SIDEBAR_ADD_REPLY, label: 'sidebar' });
    });
    window.pdfui.addUIEventListener(window.UIExtension.UIEvents.addContentSuccess, (/*a, b*/) => {
      store.userStore.doSendGAEvent({ eventKey: SIDEBAR_PUBLISH_REPLY, label: 'sidebar' });
    });
    selector = '[name="comment-item-status-menu"] ul.fv__ui-dropdown-list li';
    $$('#pdf-ui .fv__ui-sidebar').on(listenEvent, selector, (e) => {
      let cls = e.currentTarget.getAttribute('icon-class');
      if (cls && cls.indexOf('fv__icon-comment-state-menu-') !== -1) {
        let name = cls.replace('fv__icon-comment-state-menu-', 'set_status_');
        store.userStore.doSendGAEvent({ eventKey: name, label: 'sidebar' });
      }
    });
    selector = 'ul.fv__search-panel-form-dropdown li:nth-child(1) label';
    $$("#pdf-ui [name='fv-search-sidebar-panel']").on(listenEvent, selector, function (/*event*/) {
      store.userStore.doSendGAEvent({ eventKey: SIDEBAR_SET_WHOLE_WORD, label: 'sidebar' });
    });
    selector = '.fv__search-panel-form-submit';
    $$("#pdf-ui [name='fv-search-sidebar-panel']").on(listenEvent, selector, function (/*event*/) {
      store.userStore.doSendGAEvent({ eventKey: SIDEBAR_SEARCH_TEXT, label: 'sidebar' });
    });
    selector = '.fv__search-panel-form-input';
    $$("#pdf-ui [name='fv-search-sidebar-panel']").on('keydown touchend', selector, function (event) {
      if (event.keyCode == '13') {
        store.userStore.doSendGAEvent({ eventKey: SIDEBAR_SEARCH_TEXT, label: 'sidebar' });
      }
    });
    selector = 'ul.fv__search-panel-form-dropdown li:nth-child(2) label';
    $$("#pdf-ui [name='fv-search-sidebar-panel']").on(listenEvent, selector, function (/*event*/) {
      store.userStore.doSendGAEvent({ eventKey: SIDEBAR_SET_CASE_SENSITIVE, label: 'sidebar' });
    });
    selector = '.fv__ui-addon-font-family-dropdown ul.fv__ui-dropdown-list li';
    $$('#pdf-ui [name="fv--addon-textobject-font-family-size-dropdown"]  ').on(listenEvent, selector, (/*e*/) => {
      store.userStore.doSendGAEvent({ eventKey: EDIT_TEXT_FONT, label: 'edit_tab' });
    });
    $$('#pdf-ui [name="font-size-dropdown"]   ul.fv__ui-dropdown-list li').on(listenEvent, (/*e*/) => {
      store.userStore.doSendGAEvent({ eventKey: EDIT_TEXT_SIZE, label: 'edit_tab' });
    });
    if (isMobile) {
      selector = '[name="fv--mobile-topbar-search-button"]';
      $$('#pdf-ui .fv__ui-mobile-header-right').on(listenEvent, selector, (e) => {
        if (!$$(e.currentTarget).hasClass('disabled')) {
          store.userStore.doSendGAEvent({ eventKey: SIDEBAR_VIEW_SEARCH, label: 'sidebar' });
        }
      });
    }
  }

  onEventByCloseFile() {
    // ga
    store.userStore.doSendGAEventByDocDuration();
  }

  onShowFoxitAiComing = () => {
    const fn = (/* ev */) => {
      const { foxitAiUrl } = store.appStore;
      !!foxitAiUrl && windowActionFn(window, 'open', [foxitAiUrl, '_blank']);
    };
    function Node() {
      return (
        <span>
          <span className={'url-foxit-ai'} onClick={fn}>
            {'idox.ai'}
          </span>
          {' is coming!'}
        </span>
      );
    }
    store.appStore.alertTips({
      type: 'notification',
      title: { text: Node, iconType: 'foxitAi' },
      content: { text: 'Document Intelligence Service for you!' },
    });
  };
  async onEventByRenderFileSuccess() {
    //打开成功后 设置 isAutomatically 属性；
    const { isAutomatically, isRectangle } = store.docStore.formPreference;
    const { commentPreference } = store.docStore;

    fileController.getPDFViewer().then(async (viewer) => {
      let doc = await window.pdfui.getCurrentPDFDoc();
      if (!doc) {
        return;
      }
      viewer.setAutoCalculateFieldsFlag(isAutomatically);
      viewer.setFormFieldFocusRectangleVisible(isRectangle);
      viewer.setUserConfig({ commentPreference });
      //判断doc是否含有表单域
      this.showFormMessage(viewer);
      this.showNoCountryMessage();
      this.showHistoricalDataMessage();
    });
  }
  async onEventByOpenFileSuccess() {
    try {
      window.pdfui && window.pdfui.setUserName(store.userNewStore.userData.nickname);
      // 处理用户在帮助tab内续费或开通文本
      const { userData } = store.userNewStore;
      if (userData && userData.identity === 'vip') {
        let openMemeber = await window.pdfui.getComponentByName('help-open-member');
        openMemeber && openMemeber.setText('立即续费');
      }

      if (store.common.docModifiedNoSave) {
        store.common.setDocModifiedNoSave(false);
      }

      this.doSwitchTab();
      // 无表单域 禁用 formreset 按钮
      fileController.isShowFormResetButton();
      //nps start
      // TODO FOXIT 云编辑不使用nps
      //nps end
      let doc = await window.pdfui.getCurrentPDFDoc();
      const isCpdf = await doc.isCPDF();
      let fileSize = (doc.info.fileSize / 1000) >>> 0;
      let isPasswordProtected = doc.info.passwordType > 1 ? 1 : 0;
      let isTagged = doc.info.isTagged ? 1 : 0;

      if (doc.info.isCompareDoc) {
        await this.loadAddon('viewAddon');
        const paddle = await window.pdfui.getComponentByName('fv--view-tab-paddle');
        paddle.trigger('shown'); //Make sure the lazy component is loaded.
      }

      store.userStore.doSendGAEvent({ eventKey: DOCUMENT_LOADED, label: 'doc_event' });
      store.userStore.doSendGAEvent({ eventKey: DOC_PROP_IS_PASSWORD_PROTECTED, label: 'Property', value: isPasswordProtected });
      store.userStore.doSendGAEvent({ eventKey: DOC_PROP_DOCUMENT_SIZE, label: 'Property', value: fileSize });
      store.userStore.doSendGAEvent({ eventKey: DOC_PROP_IS_TAGGED, label: 'Property', value: isTagged });
      store.userStore.doUpdateDocOpenTime();
      store.accountStore.setHasGotUserABRole(`hk_` + Math.random());

      let hasfirstOpenFile = storageGetItem(localStorage, 'hasfirstOpenFile');
      if (!hasfirstOpenFile) {
        storageSetItem(localStorage, 'hasfirstOpenFile', true);
        this.onShowFoxitAiComing();
      }
      this.onHideHomeStart();

      const {
        sharePointInfo: { isFromSharePoint },
      } = store.appStore;

      if (isCanvas()) {
        store.appStore.viewerEventEmitter.emit('changeToolBar', 'collaboration');
        store.appStore.showLoading(false);
      } else if ((!store.appStore.isFromShareLink && !isCpdf) || isFromSharePoint) {
        store.appStore.setCommonMode();
      }

      if (isCpdf && !isFromSharePoint) {
        store.collaborationStore.openCPDFTocllaborationMode();
      }

      // TODO FOXIT 这里打开文件后处理，是否协同
      // 打开文档成功，隐藏<cloudShare>组件
      store.shareCollaborationStore.setCloudShareStart(false);
      console.log('this.state.openCPDFTocllaboration');
      console.log(this.state.openCPDFTocllaboration);
      console.log(store.collaborationStore.fwBeginShare);
      // 这里需要多一层，如果在这样链接的页面再次打开文，不能走这个逻辑
      if (location.search.includes('reviewSessionID') && !this.state.openCPDFTocllaboration) {
        store.collaborationStore.setReviewSessionID('');
        let url = location.search;
        let docId = '';
        let url2 = decodeURIComponent(decodeURIComponent(url));
        if (url2.includes('docId=')) {
          docId = url2.split('docId=')[1].split('&')[0];
          store.shareStore.setShareDocId(docId);
        }
        store.collaborationStore.openCPDFTocllaborationMode();
        this.setState({
          openCPDFTocllaboration: true,
        });
      } else if (store.collaborationStore.fwBeginShare) {
        store.collaborationStore.openCPDFTocllaborationMode();
        store.collaborationStore.setFwBeginShare(false);
      }
      if (window.location.href.includes('/cloudShare/') && this.state.openCPDFTocllaboration) {
        store.collaborationStore.openCPDFTocllaborationMode();
      }
      this.updateButtons(doc, true);
      console.log(this.targetTab);
      console.log(store.homePageStore.openFileToolbarTab);
      if (this.targetTab) {
        useIdleCallback(async () => {
          const tab = await window.pdfui.getComponentByName(this.targetTab);
          store.homePageStore.setOpenFileToolbarTab(this.targetTab);
          tab && tab.active();
        });
      }
      if (store.homePageStore.openFileToolbarTab) {
        this.setState({
          targetTab: store.homePageStore.openFileToolbarTab,
        });
        setTimeout(() => {
          store.homePageStore.setOpenFileToolbarTab(null);
        }, 100);
        const tab = await window.pdfui.getComponentByName(store.homePageStore.openFileToolbarTab);
        // store.homePageStore.setOpenFileToolbarTab(this.targetTab)
        tab && tab.active();
      }
      store.storageAppStore.setCurAutoSavedAtTime('');
    } catch (error) {
      store.appStore.setCommonMode();
      console.error(error);
    }
  }

  async updateButtons(doc, handleMsgCenter = false) {
    const isPdfaDoc = await doc.isPdfaDoc();
    const isPortfolio = doc.isPortfolio();
    const isProtectedView = localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true : false;
    const { vieMode } = JSON.parse(localStorage.getItem('PREFERENCES-DOCUMENTS'));
    const optimizerDom = document.querySelector('div[icon-class="fv__icon-toolbar-pdf-optimizer"]');
    const measurementDom = getElementByIconClass('fv__icon-toolbar-measurement');
    const stampDom = getElementByIconClass('fv__icon-toolbar-stamp');
    // const importDom = getElementByIconClass('fv__icon-toolbar-import');
    const rotatepageDom = getElementByIconClass('fx-icon-ribbon_home_rotatepagesleft-32');
    const watermarkDom = getElementByIconClass('fv__icon-toolbar-watermark');
    const flattenDom = getElementByIconClass('fv__icon-toolbar-flatten-pdf');
    const headerfooterDom = getElementByIconClass('fv__icon-toolbar-headerfooter');
    const insertPagesDom = getElementByIconClass('fv__icon-toolbar-insert-pages');
    const backgroundDom = getElementByIconClass('fv__icon-toolbar-background');
    let mayChangaeEle = [measurementDom, stampDom, rotatepageDom, insertPagesDom, backgroundDom, watermarkDom, flattenDom, headerfooterDom];
    const vieModeFlag = vieMode === 'never';
    function addDiableAttr(elementArr) {
      elementArr.forEach((element) => {
        element && !isProtectedView && !vieModeFlag && element.classList.add('fx-ribbon-item-disabled');
      });
    }
    function removeDisableAttr(elementArr) {
      elementArr.forEach((element) => {
        if (element) {
          !isProtectedView && !vieModeFlag && element.classList.remove('fx-ribbon-item-disabled');
        }
      });
    }
    if (isPdfaDoc && !this.state.pdfaEditable) {
      handleMsgCenter && this.showPdfAMessage();
      !isProtectedView && !vieModeFlag && optimizerDom && optimizerDom.classList.add('fx-ribbon-item-disabled');
      addDiableAttr(mayChangaeEle);
    } else if (!isPortfolio) {
      !isProtectedView && optimizerDom && optimizerDom.classList.remove('fx-ribbon-item-disabled');
      removeDisableAttr(mayChangaeEle);
      // handleMsgCenter&&!isProtectedView && this.closeMessageCenterDlg();
    }
    // TODO FOXIT 云编辑不做引导
    //  //中国区esign用户引导toolTip;协作模式不做引导
    //  if(!store.appStore.isCollaborationMode()){
    //   if(isCNDomain()){
    //     store.userStore.guideToolTip("toolTip_esignTabCN",{
    //       targetDom:document.getElementById("wrap-esignCN-tab"),
    //       id:"toolTip_esignCN-tab",
    //       title:intl.formatMessage({id:'esign.guideTitle'}),
    //       content:intl.formatMessage({id:'esign.guideContent'}),
    //       width:250
    //     })
    //   } else {
    //     let foxit_eSign_tab_timer = setTimeout(()=>{
    //       clearTimeout(foxit_eSign_tab_timer)
    //       store.userStore.showFoxitEsignTooltip();
    //     }, 500)
    //   }
    //  }

    // let insertPage = [
    //   ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
    //   ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
    //   ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
    //   ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
    //   ORGANIZE_TAB_PAGE_REVERSE,
    // ]
    // console.log("jiesuo")
    // insertPage.map(item => {
    //   window.pdfui.getComponentByName(item).then((component) => component && component.unlock())
    // })
    // let $$ = window.UIExtension.jQuery;
    // $$(['name=organize-tab-page-insert-from-file']).removeClass("disable")
    // $$(['name=organize-tab-page-insert-from-clipboard']).removeClass("disable")
    // $$(['name=organize-tab-page-insert-blank-page']).removeClass("disable")
    // $$(['name=organize-tab-page-insert-into-file']).removeClass("disable")
  }

  async pdfaEditableHandler(canEdit) {
    const doc = await window.pdfui.getCurrentPDFDoc();
    const Events = UIExtension.PDFViewCtrl.Events;
    const isProtectedView = localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true : false;
    const optimizerDom = document.querySelector('div[icon-class="fv__icon-toolbar-pdf-optimizer"]');
    const measurementDom = getElementByIconClass('fv__icon-toolbar-measurement');
    const stampDom = getElementByIconClass('fv__icon-toolbar-stamp');
    const importDom = getElementByIconClass('fv__icon-toolbar-import');
    const rotatepageDom = getElementByIconClass('fx-icon-ribbon_home_rotatepagesleft-32');
    const watermarkDom = getElementByIconClass('fv__icon-toolbar-watermark');
    const flattenDom = getElementByIconClass('fv__icon-toolbar-flatten-pdf');
    const headerfooterDom = getElementByIconClass('fv__icon-toolbar-headerfooter');
    const insertPagesDom = getElementByIconClass('fv__icon-toolbar-insert-pages');
    const reversePagesDom = getElementByIconClass('fv__icon-toolbar-reverse-pages');
    const backgroundDom = getElementByIconClass('fv__icon-toolbar-background');
    const recognitionDom = document.querySelector('div[icon-class="fv__icon-toolbar-recognition-form"]');
    const createPushbuttonDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-push-button"]');
    const addToolTipDom = document.querySelector('div[icon-class="fv__icon-toolbar-add-tooltip"]');
    const createCheckBoxDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-check-box"]');
    const createRadionDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-radio-button"]');
    const createTextDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-text"]');
    const createSignDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-sign"]');
    let mayChangaeEle = [
      measurementDom,
      stampDom,
      importDom,
      rotatepageDom,
      insertPagesDom,
      reversePagesDom,
      backgroundDom,
      watermarkDom,
      flattenDom,
      headerfooterDom,
    ];

    function addDiableAttrForEidt(elementArr) {
      elementArr.forEach((element) => {
        element && !isProtectedView && element.classList.add('fx-ribbon-item-disabled');
      });
    }
    function removeDisableAttrForEdit(elementArr) {
      elementArr.forEach((element) => {
        element && !isProtectedView && element.classList.remove('fx-ribbon-item-disabled');
      });
    }
    const disabledClass = 'fx-ribbon-item-disabled';

    if (canEdit) {
      window.pdfui.pdfViewer.viewerUI
        .confirm({ message: intl.get('Notification.pdfaeiditinfor'), level: 'warning' })
        .then(() => {
          // window.pdfui.eventEmitter.emit('PDFAEDIT', true);
          doc.setPdfaEditable(true);
          this.setState({ pdfaEditable: true, isShowMessageCenter: false });
          window.pdfui.eventEmitter.emit(Events.permissionChanged, doc);
          // ONLINERD-7790, Enable PDF/A Editing
          window.pdfui.eventEmitter.emit(Events.docModified, doc);
          if (!isProtectedView) {
            [optimizerDom, recognitionDom, createPushbuttonDom, addToolTipDom, createRadionDom, createTextDom, createSignDom, createCheckBoxDom].forEach(
              (d) => d && d.classList.remove(disabledClass),
            );
          }
          store.fwMobileToolStore.setPdfaEditable(true); // 设置文档是否可编辑
          removeDisableAttrForEdit(mayChangaeEle);
        })
        .catch((e) => {
          console.error(e);
          // window.pdfui.eventEmitter.emit('PDFAEDIT', false);
          doc.setPdfaEditable(false);
          this.setState({ pdfaEditable: false });
        });
    } else {
      // window.pdfui.eventEmitter.emit('PDFAEDIT', false);
      doc.setPdfaEditable(false);
      store.fwMobileToolStore.setPdfaEditable(false); // 设置文档是否可编辑
      this.setState({ isShowMessageCenter: false });

      if (!isProtectedView) {
        [optimizerDom, recognitionDom, createPushbuttonDom, addToolTipDom, createRadionDom, createTextDom, createSignDom, createCheckBoxDom].forEach(
          (d) => d && d.classList.add(disabledClass),
        );
      }

      addDiableAttrForEidt(mayChangaeEle);
    }
  }
  showPdfAMessage() {
    if (getDocumentViewMode() === 'never') return;
    const messages = this.state.messageCenterConfig.messages;
    const messageConfig = {
      ...this.state.messageCenterConfig,
      messages: [
        ...messages,
        {
          doNotShowAgainCheckedVal: false,
          messageType: PdfADocument,
          title: 'Notification.PdfADocument',
          info: 'Notification.pdfaDocumentNotice',
          extendContent: () => (
            <div className="btn-container">
              <Button type="link" onClick={() => this.pdfaEditableHandler(true)}>
                {intl.get('Notification.enableEdit')}
              </Button>
              <Button type="link" onClick={() => this.pdfaEditableHandler(false)}>
                {intl.get('Notification.disableEdit')}
              </Button>
            </div>
          ),
        },
      ],
    };
    this.showMessageCenterDlg(messageConfig);
  }
  onEventByAnnotationRemoved(annots) {
    annots.forEach((annot) => {
      if (annot.getType() == 'widget') {
        // 动态控制 formRest按钮 able  disabled
        fileController.isShowFormResetButton();
      }
      // sign china remove stamp
      if (annot.getType() === 'stamp' && annot.getInfo().iconName && annot.getInfo().iconName.split('_')[0] === 'sign-china-stamp') {
        store.appStore.setSignChinaStampTotal(false);
      }
    });
  }
  /**
   * !关闭引导遮罩
   */
  closeGuide() {
    store.office.getIsShowGuide(false);
  }
  onEventByAnnotationAdd(annots) {
    annots.forEach((annot) => {
      if (annot.getType() == 'widget') {
        // 动态控制 formRest按钮 able  disabled
        fileController.isShowFormResetButton();
      }
      // sign china add stamp
      if (annot.getType() === 'stamp' && annot.getInfo().iconName && annot.getInfo().iconName.split('_')[0] === 'sign-china-stamp') {
        store.appStore.setSignChinaStampTotal();
      }
    });
  }
  onSupportFieldContextMenuAsNewDefault(pdfui) {
    if (isMobile) {
      return;
    }
    // ui => addon
    const onInitFormProps = (data) => {
      pdfui.callAddonAPI('FormDesignerUIXAddon', 'ev-update-form-field-default-props', data);
    };

    // load from cache or customs
    let formProps = null;
    let _formProps = storageGetItem(localStorage, 'fx-contextmenu-form-field-props');
    if (_formProps) {
      formProps = JSON.parse(_formProps);
      onInitFormProps(formProps);
    }
    if (pdfui.addonInstanceMap['RecognitionFormUIXAddon']) {
      pdfui.callAddonAPI('FormDesignerUIXAddon', 'ev-receive-form-field-default-props', function (data) {
        // save data
        let value = JSON.stringify(data);
        storageSetItem(localStorage, 'fx-contextmenu-form-field-props', value);
        onInitFormProps(data);
      });
    }
  }
  onListenSubscriptionStatus(pdfui, Events) {
    // thumb page
    const fn_thumb = async (doc, enable) => {
      if (!store.viewer.hasOpenFile) return;
      if (!doc) {
        doc = await pdfui.getCurrentPDFDoc();
      }
      const node = await pdfui.getComponentByName('fv-thumbnail-panel');
      if (!node) return;

      if (enable) {
        let flag = doc.checkPermission(0b1000);
        node.enableDragAndDrop(flag);
      } else {
        node.enableDragAndDrop(false);
      }
    };

    const isEnable = () => {
      const hasSignIn = store.loginNewStore.isLogin;
      if (!hasSignIn) {
        return false;
      }
      if (this.isEnablePremium() || this.isEnableByDashboard() || this.isEnableByEnterprise()) {
        return true;
      }
      return false;
    };
    // ONLINERD-1157 => ONLINERD-1147
    // USER_SIGN_IN_SUCCESS => USER_UPDATE_SUBSCRIPTION
    // hasSignIn => isActive||isTrial
    let event = isMore20201231() ? USER_UPDATE_SUBSCRIPTION : USER_SIGN_IN_SUCCESS;
    store.appStore.addAppEventListener(event, () => {
      const enable = isEnable();
      // fn(enable);
      fn_thumb(null, enable);
    });

    //const enable = isEnable();
    // fn(enable);

    pdfui.addUIEventListener(Events.renderFileSuccess, function (doc) {
      let handle = setTimeout(() => {
        const enable = isEnable();
        clearTimeout(handle);
        fn_thumb(doc, enable);
      }, 1000);
    });
  }
  loadAddon(fileName, library = fileName) {
    if (isMobile) {
      fileName += '.mobile';
      library += '.mobile';
    }

    if (UIXAddons[fileName]) return Promise.resolve();
    UIXAddons[fileName] = 1;

    let style = document.createElement('link');
    style.href = `/foxitwebsdk/lib/uix-addons/${fileName}.css?_t_=` + window.__hashVersion__;
    document.body.appendChild(style);
    style.rel = 'stylesheet';
    style.type = 'text/css';

    return pdfui.loadAddon(`/foxitwebsdk/lib/uix-addons/${fileName}.js?_t_=` + window.__hashVersion__, true, library).then(() => {
      this.rewriteControll();
    });
  }

  onMonitorViewerRender(pdfui, Events, UIExtension) {
    let pSDK1 = new Promise((resolve) => {
      pdfui.addUIEventListener(UIExtension.UIEvents.initializationCompleted, (data) => {
        doAction('sdk-ui-finish', '', null, APP_CONSTANTS.SDK_FINISH_INIT);
        resolve(data);
      });
    });
    let pSDK2 = new Promise((resolve) => {
      pdfui.addUIEventListener(Events.jrLicenseSuccess, () => {
        // const { full } = store.appStore.lng;
        store.appStore.loadLocales(store.appStore.lng).then(() => {
          store.appStore.doAddResourceBundle(pdfui);
          // pdfui.changeLanguage(full);
        });

        // fileController.doAnnotSelectionState(pdfui, Events)
        //this.handleAnnotationStateHandler(pdfui, Events);
        this.onBindComponentsCallback(pdfui);
        resolve();
      });
    });
    let startTime = window.__start_time__;
    if (performance.timeOrigin || (performance.timing && performance.timing.navigationStart)) {
      startTime = performance.timeOrigin || performance.timing.navigationStart;
    }

    doAction(APP_CONSTANTS.ONLINE_START_LOAD, '', startTime);
    doAction(APP_CONSTANTS.SDK_START_LOAD, '', window.__start_sdk_time__);
    doAction(APP_CONSTANTS.SDK_START_INIT, '', null);
    // ONLINERD-6276 “加载引擎完成的当前时间/内存”和“首页渲染完成的当前时间/内存”
    Promise.all([pSDK1, pSDK2]).then(() => {
      doAction('sdk-loaded', '', null, APP_CONSTANTS.SDK_FINISH_LOAD, APP_CONSTANTS.SDK_FINISH_INIT, true);
      checkStatusAndPrintPerformanceData(store.appStore, 'SDK Loaded');
      pdfui.pdfViewer.webPDFJR.api.registerWorkflow('fontProfile', (data) => {
        doAction('fontProfile', '', data.time, data.name, 'fontProfile', false);
      });
    });

    const onRenderPage = (pageRender) => {
      if (pageRender && pageRender.index === 0) {
        pdfui.removeViewerEventListener(Events.renderPageSuccess, onRenderPage);

        let fileName;
        this.pdfDoc && (fileName = this.pdfDoc.info.fileName);
        let time = Date.now();

        if (process.env.NODE_ENV == 'development') {
          checkStatusAndPrintPerformanceData(store.appStore, 'File Opened');
        }
        doAction(APP_CONSTANTS.SDK_RENDER_FIRST_PAGE, fileName, time, APP_CONSTANTS.SDK_RENDER_FIRST_PAGE, APP_CONSTANTS.SDK_BEFORE_OPEN_DOC, true);

        useIdleCallback(() => {
          this.checkScannedPage(1);
          this.loadAddon('utilAddon');
          this.loadAddon('ppoAddon');
          this.loadAddon('editAddon');
        });
      }

      this.initFullRibbon(store.appStore.isFromShareLink);
    };
    pdfui.addUIEventListener(Events.renderPageSuccess, onRenderPage);
    pdfui.addViewerEventListener(Events.openFileSuccess, (pdfDoc) => {
      useIdleCallback(async () => {
        store.viewer.changeFileState(true);
        this.onListenScrollPageNumber();
        store.common.setIsShowMeeting(false);
        store.driveStore.setIsOpenedFromDrive(false);
        store.privateDriveStore.setIsOpenedFromPrivateDrive(false);
        store.driveStore.setOpenFileInfo({ driveName: '' });

        this.onSupportFieldContextMenuAsNewDefault(pdfui);
        this.changeEditorBtnState();

        this.resetPreFileOpenStatus();
        this.onChangeFoxitSignTabVisible(store.appStore.pdfSignConfig.isDisableFoxitEsignService);
        this.setActiveMainPageTab();

        let states = this.showProtectedViewTips() || this.state;

        this.pdfDoc = pdfDoc;

        states.pdfaEditable = false;

        const isProtectedView = localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true : false;
        if (!isProtectedView) {
          let { messageCenterConfig } = states;
          messageCenterConfig.messages = [];
          states.isShowMessageCenter = false;
        }

        window.sessionStorage.removeItem('setPasswordAndPermission');
        store.common.protectAuth();
        // let addDom = false
        // if(store.userNewStore.userData && store.userNewStore.userData.identity === "vip") {
        //   return
        // } else {
        //   if(addDom) {
        //     return
        //   }
        //   setInterval(() => {
        //     // TODO FOXIT 这里添加一个修改 在保护功能上加几个蒙版
        //     let dom1 = document.querySelectorAll('[name="protect-tab-hidden-data"]')
        //     let dom4 = document.querySelectorAll('[name="password-protect-btn"]');
        //     let dom5 = document.querySelectorAll('[name="remove-protect-btn"]');
        //     let dom6 = document.querySelectorAll('[name="create-redaction-controllers"]');
        //     let dom2 = document.querySelectorAll('[name="redaction-apply"]');
        //     let dom3 = document.querySelectorAll('[name="redaction-search"]');
        //     if(dom1[0] && dom4[0] && dom5[0] && dom6[0] && dom2[0] && dom3[0] && !addDom) {
        //       addDom = true;
        //       [dom1, dom4, dom5, dom6, dom2, dom3].map(item => {
        //         let mask = document.createElement('div');
        //         mask.className="addMaskDom"
        //         item[0].style.position = "relative";
        //         item[0].appendChild(mask);
        //         mask.onclick=((e)=> {
        //           if(store.userNewStore.userData.identity !== "vip") {
        //             store.common.getIsShowOpenMember(true);
        //             e.stopPropagation()
        //             return
        //           } else {
        //             [dom1, dom4, dom5, dom6, dom2, dom3].map(item => {
        //               let childs = item[0].getElementsByClassName("addMaskDom");
        //               item[0].removeChild(childs[0]);
        //             })
        //           }
        //         })
        //       })
        //     }
        //   }, 1000)
        // }

        pdfDoc.isPdfaDoc().then((isPdfaDoc) => {
          useIdleCallback(() => {
            const isPortfolio = pdfDoc.isPortfolio();
            if (!isPdfaDoc && !isPortfolio) {
              states.isClearMessageCenter = true;
            }

            states.docPageCount = pdfDoc.getPageCount();
            states.currentPageIndex = 0;
            states.pageSizes = pdfDoc.getPageSizesSync();

            store.docStore.setAutoRecognitionForm();
            store.appStore.updateShowHomeStart(false);
            this.setState(states);
            pdfui.getPDFDocRender().then((docRender) => {
              this.docRender = docRender;
            });
            ['context_menu_sign', 'signedList', 'has_context_menu_sign', 'copy-cut-sign', 'applyEventFromCloseSave', 'curMouseClickSignRecord'].forEach((k) =>
              storageRemoveItem(sessionStorage, k),
            );
            pdfui.pdfViewer.onlineSignManager.clear();
            store.appStore.doUpdateDocModifiedCounts(0);
            doAction(APP_CONSTANTS.SDK_OPEN_DOC_SUCCESS, '', null, APP_CONSTANTS.SDK_OPEN_DOC_SUCCESS, '', true);
          });
        });
      });
    });
    pdfui.addUIEventListener(Events.toolbarTabsClicked, async (activeComp) => {
      if (!activeComp) return;
      let addonLoadingPromise = Promise.resolve();
      switch (activeComp.name) {
        case 'home-tab':
          if (isCNDomain()) {
            let paperCheckHomeGroup = document.querySelector('[name="paper-check-home-group"]');
            if (paperCheckHomeGroup && paperCheckHomeGroup.classList.contains('hide')) {
              paperCheckHomeGroup && paperCheckHomeGroup.classList.remove('hide');
            }
          }
          break;
        case 'form-tab':
          console.log('add formAddon');
          addonLoadingPromise = this.loadAddon('formAddon').then(() => {
            const { full } = store.appStore.lng;
            store.appStore.doReplaceResourceAfterInit(pdfui, full);
            this.onSupportFieldContextMenuAsNewDefault(pdfui);
          });
          break;
        case 'organize-tab':
          console.log('add ppoAddon');
          addonLoadingPromise = this.loadAddon('ppoAddon');
          break;
        case 'fill-sign':
        case 'foxit-eSign':
          console.log('add editAddon fill-sign');
          this.fillSignESignToolbarTabsClickedHandleFn(activeComp);
          console.log('add editAddon');
          addonLoadingPromise = this.loadAddon('editAddon');
          break;
        case 'edit-tab':
          console.log('add editAddon');
          addonLoadingPromise = this.loadAddon('editAddon');
          break;
        case 'view-tab':
          console.log('add viewAddon');
          addonLoadingPromise = this.loadAddon('viewAddon');
          break;
        default:
          break;
      }
      addonLoadingPromise.then(() => {
        if (!this.loadedTabs) this.loadedTabs = {};
        if (this.loadedTabs[activeComp.name]) return;
        pdfui.eventEmitter.emit('tab-ui-ready', activeComp.name);
        this.loadedTabs[activeComp.name] = true;
      });
      // 补充一个util的addon加载
      // let utilAddonLoadingPromise = this.loadAddon('utilAddon')
      // utilAddonLoadingPromise.then( ()=> {
      //   if(!this.loadedTabs)  this.loadedTabs = {};
      //   if(this.loadedTabs[activeComp.name]) return;
      //   pdfui.eventEmitter.emit('tab-ui-ready', activeComp.name);
      //   this.loadedTabs[activeComp.name] = true;
      // });

      this.toolbarTabsClicked(activeComp);
      if (activeComp.name === 'file-tab') {
        this.changeSaveFileBtnIcon();
      }
    });

    pdfui.getComponentByName('sidebar-thumbnail-panel').then((thumbCpnt) => {
      thumbCpnt.once('active', () => {
        this.loadAddon('ppoAddon');
      });
    });

    pdfui.addViewerEventListener('changeFoxitEsignVisible', (isDisableFoxitEsignService) => {
      this.onChangeFoxitSignTabVisible(isDisableFoxitEsignService);
    });

    pdfui.eventEmitter.on('need-sign-tip', (callback) => {
      this.doOnlineSignHandleBeforeClose(true, callback, true);
    });

    pdfui.eventEmitter.on('apply-esign-to-save', () => {
      this.inMobileHandler();
    });

    pdfui.eventEmitter.on('flatten-from-apply-all-fillSign', () => {
      // this.onShowFlattenDlg(); --- if need modal to set
      // handle directly
      fileController.flattenPDF({
        mode: 'all',
        pageRange: [],
      });
    });
  }
  initFullRibbon(hideRibbon) {
    return pdfui.getRootComponent().then((root) => {
      if (!isMobile && !root.getComponentByName('toolbar')) {
        const { fragments, toolbarTemplate } = store.appStore.getUIconfig();
        root.insert(toolbarTemplate, 0, fragments);
        let toolbarNode = root.getComponentByName(hideRibbon ? 'toolbar' : 'collaboration-toolbar');
        toolbarNode && toolbarNode.hide();
      }
    });
  }

  onFinishInitSDK({ pdfui, Events, /* UIExtension, */ emitter }) {
    const showGlobalSpin = this.isShowGlobalSpinForInitWebSDK();
    const { isFromShareLink } = store.appStore;
    showGlobalSpin && this.setState({ isShowGlobalSpin: false });
    pdfui.getPDFViewer().then((viewer) => {
      viewer.snapshotServer.origin = store.appStore.cwsApiUrl;
    });

    this.viewerRef.current.append(this.uiextContainer);

    const { full } = store.appStore.lng;
    store.appStore.doReplaceResourceAfterInit(pdfui, full);
    pdfui.i18n.on('languageChanged', (lng) => {
      store.appStore.doReplaceResourceAfterInit(pdfui, lng);
    });
    this.onListenSubscriptionStatus(pdfui, Events);
    window.__end_time__ = new Date().getTime();
    isFromShareLink && store.appStore.setCollaborationMode();

    store.appStore.setIsSdkFinishInit(true);
    store.appStore.emitEvent(APP_CONSTANTS.SDK_FINISH_INIT);
    // do somthing
    //AiPluginController.init()
    // TemplatePluginController.init('home')// template have two entrance:home  and  convert;
    // listen sidebar resize
    store.appStore.emitEvent('templateInit');
    this.onListenSidebarResize();

    this.hideComponentsByDashboard();

    this.onListenClickEventByGA(pdfui);

    // FileSelectorController
    FILE_SELECTOR_INNER.forEach((name) => {
      pdfui.getComponentByName(name).then((component) => {
        if (!component) {
          return;
        }
        doUpdateFileSelectorController(component, emitter, this.onMountedViewerComponents, this.onClickViewerComponents);
      });
    });

    const nodeVirtual = document.querySelector('#pdf-ui-virtual');
    nodeVirtual && nodeVirtual.classList.add('d-n');

    // this.onShowGetStartGuid()
    let status = this.onShowFirstBlankContent();

    this.setState({
      isShowGlobalSpin: false,
      isShowDropFileHere: true,
      isShowGetStartGuid: status,
    });

    if (!store.appStore.isOnPremiseDeployMode && !isCNDomain()) {
      this.onOpenFileByGoogleDrive(emitter);
    }
    this.onOpenFileFromOffice(emitter);
    this.onOpenFileFromOneDrive(emitter);
    this.onShowSubscribePlane();

    const pluginStore = getQueryVariable('pluginStore');
    if (pluginStore) {
      this.onLoadLocalDevPlugin();
      this.onLoadUserPlugin(emitter, WEBPLUGIN_LOAD_BEHAVIOR_APPINITFINISH);
    }
    if (!store.appStore.isCollaborationMode()) {
      this.showMoreTab();
    }
  }
  showMoreTab() {
    if (!this.isShowSignTab) {
      this.isShowSignTab = true;
      if (isCNDomain()) {
        // toolbar
        let esignCN_tab = document.querySelector("[name='wrap-esignCN-tab']");
        esignCN_tab && esignCN_tab.classList.remove('hide');

        let paperCheck_tab = document.querySelector("[name='paper-check-tab']");
        paperCheck_tab && paperCheck_tab.classList.remove('hide');
      } else {
        if (isJPDomain() || store.foxitSignStore.isDisableEsign) {
          return;
        }
        let foxitEsign_tab = document.querySelector("[name='wrap-foxitESign-tab']");
        foxitEsign_tab && foxitEsign_tab.classList.remove('hide');
      }
    }
  }
  // 验证当前页是否扫描页面，是的话给予右上角提示
  checkScannedPage = async (data) => {
    _throttle(
      async () => {
        if (!this.docRender) {
          const docRender = await pdfui.getPDFDocRender();
          this.docRender = docRender;
        }
        if (this.docRender.doc.info.isPortfolio) return;
        const permission = this.docRender.getUserPermission().getValue();
        const modifyPermission = UIExtension.PDFViewCtrl.Consts.PDFDocPermission.ModifyDocument;
        if (!(permission & modifyPermission)) return;

        let pageIndex = 0;
        if (isNaN(data)) {
          // from graphicsUpdated, data is a pdfPage;
          pageIndex = data.getIndex();
        } else {
          pageIndex = data - 1;
        }
        pdfui
          .getPDFPageRender(pageIndex)
          .then((pdfPageRender) => {
            return pdfPageRender.getPDFPage();
          })
          .then((pdfPage) => {
            return pdfPage ? pdfPage.isScannedPage() : false;
          })
          .then((isScannedPage) => {
            const idStr = 'SCANNED-PAGE';
            let messageCenterConfig = this.state.messageCenterConfig;
            if (isScannedPage && JSON.stringify(messageCenterConfig.messages).indexOf(idStr) === -1) {
              messageCenterConfig.isShowClear = true;
              messageCenterConfig.isShowDonnotShowAgain = true;
              messageCenterConfig.doNotShowAgainChecked = true;
              messageCenterConfig.messages.push({
                id: idStr + '-' + pageIndex,
                title: 'Notification.Recognition.Title',
                info: 'Notification.Recognition.Content',
                extendContent: () => (
                  <Button type="link" onClick={this.showRecoginizeTextDialog}>
                    {intl.get('Preferences.Content.editing.EditingScanned.Recognize')}
                  </Button>
                ),
              });
              this.showMessageCenterDlg(messageCenterConfig);
            }
          });
      },
      1000,
      {
        leading: false,
        trailing: true,
      },
    )();
  };
  doUIExtensionEventBinder(pdfui, Events, UIExtension, emitter) {
    let _this = this;
    this.onMonitorViewerRender(pdfui, Events, UIExtension);

    const { isOpenPropertiesAfterCreating } = store.docStore.formPreference;
    pdfui.openFormPropertyBoxAfterCreated(isOpenPropertiesAfterCreating);

    pdfui.addUIEventListener(UIExtension.UIEvents.appendCommentListComment, function (commentCardComponent /*annot*/) {
      // do something such as add a button into commentCardComponent
      // to listen sidebar
      _this.onBindSidebarComponentsCallback(commentCardComponent);
    });
    pdfui.addUIEventListener(UIExtension.UIEvents.appendCommentListReply, function (replyCardComponent /*annot*/) {
      // do something such as add a button into replyComponent
      _this.onBindSidebarComponentsCallback(replyCardComponent);
    });
    pdfui.addViewerEventListener(UIExtension.PDFViewCtrl.PDF.DataEvents.docModified, function (a, b) {
      console.log(a);
      console.log(b);
      if (store.appStore.isCollaborationMode()) {
        return;
      }
      if (store.addCoverPageStore.printOk) {
        store.addCoverPageStore.setPrintOk(false);
        return;
      }
      store.appStore.doUpdateDocModified(true);
    });
    pdfui.addViewerEventListener(UIExtension.PDFViewCtrl.PDF.DataEvents.permissionChanged, function (/*PDFDoc*/) {
      _this.onDisableComponentsByPermission();
    });

    pdfui.addViewerEventListener(UIExtension.PDFViewCtrl.PDF.DataEvents.recognitionForm, function (/*PDFDoc*/) {
      _this.onDisableComponentsByPermission(['recognition-form-button']);
    });
    // TODO FOXIT 打印不在触发修改记录保存，此处去除点击打印后的不存记录逻辑
    // pdfui.addViewerEventListener(Events.printController, function() {
    //   store.addCoverPageStore.setPrintOk(true)
    // })
    // //! 处理左侧菜单栏-打印页面功能鉴权
    // pdfui.addViewerEventListener(Events.printPage, function(type) {
    //   let identity = store.userNewStore.userData.identity
    //   if (store.appStore.docModified) {
    //     if(identity === "vip") {
    //       type();
    //     } else {
    //       store.saveFileNewStore.saveFileDialog("print")
    //     }
    //   } else {
    //     // ! 未做修改，直接弹窗
    //     type();
    //   }
    //   store.addCoverPageStore.setPrintOk(true)
    // })
    // //! 处理左侧菜单栏-打印节功能鉴权
    // pdfui.addViewerEventListener(Events.printSection, function(type) {
    //   let identity = store.userNewStore.userData.identity
    //   if (store.appStore.docModified) {
    //     if(identity === "vip") {
    //       type();
    //     } else {
    //       store.saveFileNewStore.saveFileDialog("print")
    //     }
    //   } else {
    //     // ! 未做修改，直接弹窗
    //     type();
    //   }
    //   store.addCoverPageStore.setPrintOk(true)
    // })
    pdfui.addViewerEventListener(Events.willCloseDocument, () => {
      this.docRendered = 0;

      store.viewer.changeFileState(false);
      store.appStore.doUpdateDocModified(false);
      store.docStore.setFormMessage(null);
      store.docStore.setDocInfo({});

      _this.onRemoveScrollPageNumber();
      _this.closeMessageCenterDlg(true);
      this.onCloseModalDlg();

      this.sharePointFileHandlerEnd();
      this.fileOpenedFromGoogleDriveEnd();
      this.fileOpenedFromIManageEnd();
      // store.collaborationStore.resetAnnotList()
      store.appStore.emitEvent(APP_CONSTANTS.SDK_WILL_CLOSE_DOC);
      _this.setState({
        isShowSignatureListContainer: false,
      });
      _this.setActiveMainPageTab();
      store.appStore.setServiceModeOfClientInfo(null);
      store.appStore.doUpdateDocModifiedCounts(0);
      store.viewer.resetMultiTabsTabPane();
    });
    pdfui.addViewerEventListener(Events.beforeOpenFile, () => {
      store.appStore.updateShowHomeStart(false);
      this.sharePointFileHandlerStart();
      store.appStore.doAbleMessageCenterDlg();
      _this.onEventByCloseFile();
      // drive last open clean
      store.appStore.updateProgressingInfo(true);
      _this.onRemoveScrollPageNumber();

      !isCollabURL() && this.loadPlugin(pdfui);
    });
    pdfui.addViewerEventListener(Events.openFileSuccess, async () => {
      //_this.onResetPageViewerState();
      store.viewer.changeFileState(true);
      // TODO FOXIT 打开文件后检测是否有权限分享，如果没有权限则企业用户不显示协同分享按钮，暂时普通分享
      const checkAnnotFormPermission = await fileController.checkAnnotFormPermission();
      if (checkAnnotFormPermission === 0) {
        store.shareCollaborationStore.setNoCollaborationToShare(true);
        // store.appStore.setGlobalMessage({type: 'error', content: intl.get("collaboration.Dlg.noPermission")})
        // return
      }
      const doc = await pdfui.getCurrentPDFDoc();
      if (doc && doc.isPortfolio()) {
        store.shareCollaborationStore.setNoCollaborationToShare(true);
        // store.appStore.setGlobalMessage({type: 'error', content: intl.get("collaboration.Error.portfolioNotSupport")})
        // return
      }
      // TODO FOXIT 打开文件后添加滚动监听
      if (isMobile) {
        _this.setState({
          showMobileFooter: false,
        });
        setTimeout(() => {
          _this.setState({
            showMobileFooter: true,
          });
        }, 200);
        _this.scrollPage();
        // 获取权限信息
        // 添加一个权限判断————当文档权限非注释或所有的时候，禁用注释、编辑等操作
        store.fwMobileToolStore.getPermissionsInfo();
        // 取消查找或密文头部
        store.fwMobileToolStore.closeUseEncryption();
      }
      // TODO FOXIT 打开文件后,监听是否触发toolbar点击，当通过主页热门功能进入
      // _this.onCloseViewerLoading();
      _this.requestDocInfo();
      //_this.onFloatBarVisibility();
      _this.onListenScrollPageNumber();
      _this.onDisableComponentsByPermission();

      store.driveStore.setIsOpenedFromDrive(false);
      store.privateDriveStore.setIsOpenedFromPrivateDrive(false);
      store.driveStore.setOpenFileInfo({ driveName: '' });

      // _this.onEventByOpenFileSuccess();
      _this.onSupportFieldContextMenuAsNewDefault(pdfui);
      store.docStore.setCurrentDocInfo();
      store.docStore.setAutoRecognitionForm();
      _this.changeEditorBtnState();
      _this.showProtectedViewTips();
      _this.resetPreFileOpenStatus();
      // 分享功能重置信息
      store.shareStore.resetShare();
      // 处理加封面页保存弹窗提示
      if (store.addCoverPageStore.addCoverOpenFile) {
        store.addCoverPageStore.setAddCoverOpenFile(false);
        store.appStore.doUpdateDocModified(false);
      }
      // 消除协同分享数据
      if (store.appStore.headerType === COLLABORATION_HEADER) {
        store.shareCollaborationStore.resetShareCollaboration();
      }
      _this.setState({
        isInitSignatureListContainer: true,
      });
      _this.onChangeFoxitSignTabVisible(store.appStore.pdfSignConfig.isDisableFoxitEsignService);
      _this.setActiveMainPageTab();

      doAction(APP_CONSTANTS.SDK_BEFORE_OPEN_DOC, '', null, APP_CONSTANTS.SDK_BEFORE_OPEN_DOC, '', true);
    });

    pdfui.addViewerEventListener(Events.annotationAdd, function (annots /*, page*/) {
      _this.onEventByAnnotationAdd(annots);
    });
    pdfui.addViewerEventListener(Events.annotationRemoved, function (annots /*, page*/) {
      _this.onEventByAnnotationRemoved(annots);
    });
    // pdfui.addViewerEventListener(Events.beforeRenderPage, function(/* doc */) {
    //   _this.onCloseViewerLoading();
    // });
    pdfui.addViewerEventListener(Events.renderFileSuccess, function (/* doc */) {
      _this.onCloseViewerLoading();
      useIdleCallback(() => {
        let emitter = new UIExtension.vendors.EventEmitter();
        store.docStore.setCurrentDocInfo();
        _this.onEventByRenderFileSuccess();
        _this.onEventByOpenFileSuccess();
        _this.onLoadUserPlugin(emitter, WEBPLUGIN_LOAD_BEHAVIOR_FILEOPEN);

        _this.onDisableComponentsByPermission();
      });
      hideFullScreen();
    });
    pdfui.addViewerEventListener(Events.setFromFieldHighlight, function (res) {
      const mgr = pdfui.editingMgr;
      if (mgr) {
        if (!mgr.type) store.docStore.updateFormPreference('isHighlight', res);
      } else {
        store.docStore.updateFormPreference('isHighlight', res);
      }
    });
    pdfui.addViewerEventListener(Events.renderFileFailed, function (/* doc */) {});
    const updateDocInfo = (needUpdateState = true) => {
      if (needUpdateState) {
        _this.requestDocInfo();
      }
      store.docStore.setCurrentDocInfo();
    };
    pdfui.addViewerEventListener(Events.securityTypeChanged, () => {
      updateDocInfo(false);
    });
    pdfui.addViewerEventListener([Events.pageAdded, Events.pagesInserted, Events.pageRemoved], function () {
      updateDocInfo();
    });
    pdfui.addViewerEventListener(Events.openFileFailed, function (type) {
      store.appStore.backToHomeStart();
      _this.onCloseViewerLoading();
      _this.doCleanTargetTab();
      // ga
      store.userStore.doSendGAEvent({ eventKey: DOCUMENT_LOAD_FAILED, label: 'doc_event' });
      store.docStore.setAutoRecognitionForm();
      // 打印文件打开失败后，重新打开文件弹打印窗口 错误 #69589
      store.addCoverPageStore.setPrintTrue(false);
      // 打开加密文件失败
      if (type === 'openHome') {
        _this.onShowHomeStart();
      }
    });
    const gridToggleHandle = (status, needToggle) => {
      if (needToggle === true) {
        const layoutPreference = JSON.parse(storageGetItem(localStorage, 'layoutPreference'));
        store.docStore.undateLayoutPreferenceAll(layoutPreference);
      }
    };
    // If grid toggle by view-tab, update store.
    pdfui.addViewerEventListener({
      [Events.gridToggle]: gridToggleHandle,
      [Events.snapGridToggle]: gridToggleHandle,
    });

    pdfui.addUIEventListener(UIExtension.UIEvents.initializationCompleted, () => {
      let handle = setTimeout(() => {
        clearTimeout(handle);
        this.onFinishInitSDK({ pdfui, Events, UIExtension, emitter });
      }, 0);
    });

    // 扫描文档弹窗提示窗口
    pdfui.addUIEventListener([Events.pageNumberChange, Events.graphicsUpdated], this.checkScannedPage);

    pdfui.addUIEventListener(Events.showSignatureVerifyInfoEvent, async ({ signedSignatures }) => {
      let messageCenterConfig = this.state.messageCenterConfig;

      let isShowFormInfo = store.appStore.isShowDocFormInfo();
      messageCenterConfig.doNotShowAgainChecked = !isShowFormInfo;

      let formFieldsFoundMessageConfig = this.getFormFieldsFoundMessageConfig();
      let formMessageIndex = this.state.messageCenterConfig.messages.findIndex((item) => item.messageType === FormFieldsFound);
      if (this.isShowFormFieldsFoundMessage()) {
        if (formMessageIndex === -1) {
          messageCenterConfig.messages.push(formFieldsFoundMessageConfig);
        } else {
          messageCenterConfig.messages.splice(formMessageIndex, 1, formFieldsFoundMessageConfig);
        }
      } else {
        if (formMessageIndex > -1) {
          messageCenterConfig.messages.splice(formMessageIndex, 1);
        }
      }

      let verifySignatureMessageConfig;
      if (signedSignatures.length) {
        verifySignatureMessageConfig = await this.getVerifySignatureMessageConfig(signedSignatures, pdfui);
      }

      let verifySignatureMessageIndex = this.state.messageCenterConfig.messages.findIndex((item) => item.messageType === VerifySignature);
      let oldVerifySignatureMessage;
      if (verifySignatureMessageIndex > -1) {
        oldVerifySignatureMessage = messageCenterConfig.messages[verifySignatureMessageIndex];
        messageCenterConfig.messages.splice(verifySignatureMessageIndex, 1);
      }
      if (verifySignatureMessageConfig && verifySignatureMessageConfig.info) {
        messageCenterConfig.messages.unshift(verifySignatureMessageConfig);
      }

      if (this.state.isShowMessageCenter) {
        if (oldVerifySignatureMessage && verifySignatureMessageConfig) {
          let { info, hasManageTrustBtn } = verifySignatureMessageConfig;
          let { info: info_old, hasManageTrustBtn: hasManageTrustBtn_old } = oldVerifySignatureMessage;
          if (info !== info_old || hasManageTrustBtn !== hasManageTrustBtn_old) {
            this.showMessageCenterDlg(messageCenterConfig);
          }
        } else {
          if (verifySignatureMessageConfig && verifySignatureMessageConfig.info) {
            this.showMessageCenterDlg(messageCenterConfig);
          }
        }
      } else {
        // 之前打开过 点击过 clear 不显示
        if (oldVerifySignatureMessage) {
          if (!this.state.isClearMessageCenter) {
            this.showMessageCenterDlg(messageCenterConfig);
          }
        } else {
          if (isShowFormInfo && this.docRender.doc.PDFForm && !this.docRender.doc.PDFForm.isEmpty()) {
            this.showMessageCenterDlg(messageCenterConfig);
          }
        }
      }
    });

    pdfui.addUIEventListener(Events.showCompareSignedVersionResultEvent, (data) => {
      let { isShowMessageCenter } = _this.state;

      let compareResultConfig = this.state.messageDlgCfg.config;
      if (!compareResultConfig) compareResultConfig = defaultSignCompareConfig;
      let { status, progress, docId } = compareResultConfig;
      if (!isShowMessageCenter || data.progress !== progress || data.status !== status || data.docId !== docId) {
        this.showCompareResultDialog(data);
      }
    });
    pdfui.addViewerEventListener(Events.sideBarChanged, () => {
      this.calcFloatPageNumberRight();
    });
    pdfui.addViewerEventListener(Events.showWhatsNew, () => {
      this.onShowUpdateLogs();
    });
    store.appStore.viewerEventEmitter.on('switchWorker', (docStream) => {
      this.switchWorker(1, docStream);
    });
  }
  esignCN_Tab_Ctrl(data) {
    const tabName = data.attrs.name;
    let toolTip_esignCN_tab = document.getElementById('toolTip_esignCN-tab');
    if (toolTip_esignCN_tab) {
      toolTip_esignCN_tab.remove();
    }
    setTimeout(() => {
      this.setState({
        showEsignChinaGalleryTool: tabName === 'esignCN-tab',
      });
    }, 200);
  }
  switchWorker(loading = 0, docStream) {
    loading && store.appStore.showLoadingWithMsg({ show: true, msg: 'Loading.file' });
    let ret = Promise.resolve();
    if (this.partialWorker) {
      this.partialWorker = false;
      const { licenseKey, licenseSN, l } = this.state;
      loadWorker(licenseKey, licenseSN, l, false);
      ret = pdfui.pdfViewer.setWorker(window.readyWorker.worker).then(() => {
        const userName = store.userStore.userName;
        fileController.setDocAuthor(userName);
        fileController.fullFeature = 1;

        store.appStore.showLoading(false);

        if (docStream) {
          pdfui.openPDFByFile(new Blob(docStream[0]), { fileName: docStream[1] });
        }
        if (!store.appStore.isCollaborationMode()) {
          this.showMoreTab();
        }
      });
    }
    if (!this.pluginLoaded) {
      this.loadPlugin(pdfui);
    }
    return ret;
  }
  sharePointFileHandlerStart = () => {
    let autoSaveTimer;
    let retryNum = 0;
    const { isFromSharePoint } = store.appStore.sharePointInfo;

    if (isFromSharePoint) {
      autoSaveTimer = setInterval(async () => {
        try {
          const { docModified } = store.appStore;

          if (docModified) {
            store.driveStore.updateSharePointAutoSavingFlag(true);
            await store.driveStore.saveFileBackToDrive().catch(() => {
              throw 'save file to sharepoint error';
            });

            retryNum = 0;
            store.driveStore.resetSharePointAutoSavingFlag();
            store.appStore.doUpdateDocModified(false);
          }
        } catch (error) {
          retryNum++;
          store.driveStore.resetSharePointAutoSavingFlag();

          if (retryNum >= 3) {
            retryNum = 0;
            store.appStore.doUpdateDocModified(false);
            store.driveStore.resetSharePointAutoSaveTimer();
          }
          console.error(error);
        }
      }, 30000);

      store.driveStore.updateSharePointAutoSaveTimer(autoSaveTimer);

      // 显示文件新版本提示
      const { sharepointFilesInfoArr } = store.driveStore;
      const {
        parentReference: { driveId },
        id: itemId,
        lastModifiedDateTime,
        webUrl,
      } = sharepointFilesInfoArr[0];

      sharePointService.updateLastModifiedDateTime(lastModifiedDateTime);
      sharePointService.hasNewUpdateForFile({
        driveId,
        itemId,
        callback: (res) => {
          this.onShowWarningMessage(
            () => {
              store.appStore.showLoading(true);
              sharePointService.updateIsSyncingFile(true);
              store.driveStore.updateSharepointFilesInfoArr([res]);
              fileController.doOpenFileByUrl(res['@microsoft.graph.downloadUrl'], res.name, null, true, () => {
                const backToSharePointUrl = res.webUrl.substring(0, res.webUrl.lastIndexOf('/'));

                // store.driveStore.updateSharepointFilesInfoArr([res])
                store.appStore.updateSharePointInfo({ isFromSharePoint: true, backToSharePointUrl, fromDrive: getFromDriveNameForSharePoint(webUrl) });
                sharePointService.updateIsSyncingFile(false);
                store.appStore.showLoading(false);
                // successCallback && successCallback()
              });
            },
            {
              title: 'SharePoint.NewVersionAvailable',
              message: 'SharePoint.Warning.HasNewUpdate',
              ok: 'SharePoint.GetLatestVersion',
              noCancel: true,
              closable: false,
            },
          );
        },
      });

      // 添加文档更新webHook
      // store.driveStore.webHookSubscribeForSharePoint()
    }
  };
  sharePointFileHandlerEnd = () => {
    const { isFromSharePoint } = store.appStore.sharePointInfo;

    if (isFromSharePoint) {
      if (!sharePointService.isSyncingFile) {
        store.driveStore.leaveSharePointEditMode();
      } else {
        store.driveStore.resetSharePointAutoSaveTimer();
        store.driveStore.resetSharePointAutoSavingFlag();
        sharePointService.cleanIntervalForFileMetaData();
      }
    }
  };
  fileOpenedFromIManageEnd = () => {
    const { isFromIManage } = store.driveStore.iManageInfo;

    if (isFromIManage) {
      store.driveStore.resetIManageInfo();
    }
  };
  fileOpenedFromGoogleDriveEnd = () => {
    const { isFromGoogleDrive } = store.appStore.googleDriveInfo;

    if (isFromGoogleDrive) {
      store.appStore.resetGoogleDriveInfo();
      store.driveStore.resetGoogleDriveFilesInfoArr();
    }
  };
  fillSignESignToolbarTabsClickedHandleFn = (activeComp) => {
    console.log('fillSign');
    const currentActiveTabName = activeComp.name;
    const groupName = activeComp.groupName;
    if (!currentActiveTabName || groupName !== 'toolbar-tab' || (pdfui.activeMainPageTab && currentActiveTabName === pdfui.activeMainPageTab.name)) return;

    pdfui.activeMainPageTab = activeComp;
    console.log(TAB_NAME_MAP.FillSign);
    console.log(TAB_NAME_MAP.FoxitESign);
    console.log(currentActiveTabName);
    if ([TAB_NAME_MAP.FillSign, TAB_NAME_MAP.FoxitESign].includes(currentActiveTabName)) {
      const fillSignESignHandleFn = async () => {
        try {
          console.log('fillSignESignHandleFn');
          // const foxitSignESignContainer = await pdfui.getComponentByName('foxit-sign-esign-tab-group');
          const closeSignBtn = await pdfui.getComponentByName('close-sign');
          console.log(closeSignBtn);
          const requestSignBtn = await pdfui.getComponentByName('request-signature');
          console.log(requestSignBtn);
          const documentStatusBtn = await pdfui.getComponentByName('document-status');
          console.log(documentStatusBtn);
          const switchAccountsGroup = await pdfui.getComponentByName('switch-accounts-group');
          switchAccountsGroup.hide();
          console.log(switchAccountsGroup);
          if (currentActiveTabName === TAB_NAME_MAP.FillSign) {
            closeSignBtn.show();
            requestSignBtn.hide();
            documentStatusBtn.hide();
          } else if (currentActiveTabName === TAB_NAME_MAP.FoxitESign) {
            closeSignBtn.hide();
            requestSignBtn.show();
            documentStatusBtn.show();
          }

          let signatureListContainerDomInWebSdk = document.querySelector('.signature-list[name="signature-list-container"]');
          console.log('signatureListContainerDomInWebSdk');
          console.log(signatureListContainerDomInWebSdk);
          let setWebsdkDomFn = (signatureListContainerDomInWebSdk) => {
            if (signatureListContainerDomInWebSdk) {
              this.setState({
                isShowSignatureListContainer: true,
                signatureListContainerDomInWebSdk,
              });
            }
          };
          if (signatureListContainerDomInWebSdk) {
            setWebsdkDomFn(signatureListContainerDomInWebSdk);
          } else {
            setTimeout(() => {
              signatureListContainerDomInWebSdk = document.querySelector('.signature-list[name="signature-list-container"]');
              setWebsdkDomFn(signatureListContainerDomInWebSdk);
            }, 100);
          }
          if (currentActiveTabName === TAB_NAME_MAP.FoxitESign) {
            if (!store.foxitSignStore.isInitESignAccount) {
              await store.foxitSignStore.initFoxitSignCountInfo();
            }
            if (store.foxitSignStore.eSignAccountList.length > 1) {
              switchAccountsGroup.show();
            }
          }
        } catch (error) {}
      };
      console.log(this.state.isInitSignatureListContainer);
      if (!this.state.isInitSignatureListContainer) {
        this.setState(
          {
            isInitSignatureListContainer: true,
          },
          fillSignESignHandleFn,
        );
      } else {
        fillSignESignHandleFn();
      }
    } else {
      let { isShowSignatureListContainer, signatureListContainerDomInWebSdk } = this.state;
      if (isShowSignatureListContainer || signatureListContainerDomInWebSdk) {
        this.setState({
          isShowSignatureListContainer: false,
          signatureListContainerDomInWebSdk: null,
        });
      }
    }
  };
  toolbarTabsClicked = (data) => {
    if (!isCNDomain()) return;
    if (data?.attrs?.body == 'fv--esignCN-tab-paddle') {
      this.esignCN_Tab_Ctrl(data);
    }

    pdfui.addUIEventListener('pageeditor-started', () => {
      this.loadPlugin(pdfui).then(async () => {
        const rightPanel = await pdfui.getComponentByName('sidebar-right');
        rightPanel.show();
        const tabs = await pdfui.getComponentByName('sidebar-right-tabs');
        tabs.openTab('edit-properties-panel');
        tabs.setActivetab('edit-properties-panel');

        let tool = await pdfui.getComponentByName('edit-properties');
        tool.setHost(
          {
            effectClippingType1: { enable: true },
            effectClippingType2: { enable: true },
            effectClippingType3: { enable: true },
            effectClippingType4: { enable: true },
            effectClippingType5: { enable: true },
            effectClippingType6: { enable: true },
            effectEditClipping: { enable: false },
            effectClearClipping: { enable: false },
            arrangeAlignmentVertically: { enable: false },
            arrangeAlignmentHorizontally: { enable: false },
            arrangeAlignmentLeft: { enable: false },
            arrangeAlignmentRight: { enable: false },
            arrangeAlignmentTop: { enable: false },
            arrangeAlignmentBottom: { enable: false },
            arrangeDistributeVertically: { enable: false },
            arrangeDistributeHorizontally: { enable: false },
            arrangeZorderToBack: { enable: true },
            arrangeZorderToFront: { enable: false },
            effectOpacity: { enable: true, value: 1 },
          },
          3,
        );
      });
    });
  };
  manageTrustAllCertificate = () => {
    if (this.pdfui) {
      this.pdfui.manageTrustAllCertificate && this.pdfui.manageTrustAllCertificate();
    }
  };

  clickSignaturePanel = () => {
    if (this.pdfui) {
      this.pdfui.clickSignaturePanel && this.pdfui.clickSignaturePanel();
    }
  };

  doNotShowAgainChange = (checked) => {
    this.setState({
      messageCenterConfig: Object.assign({}, this.state.messageCenterConfig, { doNotShowAgainChecked: checked }),
    });
  };

  showMessageCenterDlg = (messageCenterConfig) => {
    const { disableMessageCenterDlg } = store.appStore;
    if (disableMessageCenterDlg) return;
    this.setState({
      isClearMessageCenter: false,
      isShowMessageCenter: true,
      messageCenterConfig,
    });
  };
  showMessageCenterDlgCallback() {
    if (!window.UIExtension) return;
    let $$ = window.UIExtension.jQuery;
    $$('#MsgCenter').on('click', '#goToMyCount', () => {
      //消息弹窗中 翻译词条 事件绑定
      store.userStore.doGoToAccount();
    });
  }
  closeMessageCenterDlg(isCloseDocument = false) {
    let { messageCenterConfig } = this.state;
    messageCenterConfig.messages = isCloseDocument ? [] : messageCenterConfig.messages;
    this.setState({
      isClearMessageCenter: !isCloseDocument,
      isShowMessageCenter: false,
      messageCenterConfig,
    });
  }

  async getVerifySignatureMessageConfig(signedSignatures, pdfui) {
    let messageCenterConfig = {
      messageType: VerifySignature,
      info: '',
      infoOptions: {},
      extendContent: () => {},
    };
    let hasCertifySignature = signedSignatures.some((field) => field.signatureInfo && field.signatureInfo.isSigned && field.signatureInfo.isCertified);
    let hasSignedSignature = signedSignatures.some((field) => field.signatureInfo && field.signatureInfo.isSigned && !field.signatureInfo.isCertified);

    let hasManageTrustBtn = false;

    if (signedSignatures.every((item) => item.signatureInfo.status === 'notYetVerified')) {
      messageCenterConfig.info = 'Notification.NotYetVerified';
    } else if (signedSignatures.every((item) => item.signatureInfo.isValid && item.signatureInfo.isTrustedCert)) {
      messageCenterConfig.info = 'Notification.AllValid';
    } else if (signedSignatures.some((item) => item.signatureInfo.status === 'verified' && !item.signatureInfo.isTrustedCert)) {
      if (
        signedSignatures.some(
          (item) =>
            item.signatureInfo.status === 'verified' &&
            (item.signatureInfo.isInvalid || item.signatureInfo.hasErrorData || item.signatureInfo.isErrorByteRange),
        )
      ) {
        messageCenterConfig.info = 'Notification.HasInValid';
        hasManageTrustBtn = false;
      } else {
        let untrustedAlterInfo = store.appStore.verifySignatureRule && store.appStore.verifySignatureRule.untrustedAlterInfo;
        if (hasCertifySignature && !hasSignedSignature) {
          messageCenterConfig.info = 'Notification.certifyNotTrustInfo';
        } else {
          messageCenterConfig.info = untrustedAlterInfo ? 'Notification.UntrustedSignatureInfo' : 'Notification.HasProblemInSignature';
          hasManageTrustBtn = untrustedAlterInfo;
        }
      }
    } else {
      if (
        signedSignatures.some((item) => item.signatureInfo.status === 'verified' && item.signatureInfo.isInvalid) ||
        signedSignatures.some((item) => item.signatureInfo.status === 'verified' && (item.signatureInfo.hasErrorData || item.signatureInfo.isErrorByteRange))
      ) {
        messageCenterConfig.info = 'Notification.HasInValid';
      } else if (signedSignatures.some((item) => item.signatureInfo.status === 'notYetVerified')) {
        messageCenterConfig.info = 'Notification.NotYetVerified';
      } else {
        messageCenterConfig.info = 'Notification.HasProblemInSignature';
      }
    }

    if (signedSignatures.every((item) => item.signatureInfo.status === 'verified' && item.signatureInfo.isVerifyChange)) {
      messageCenterConfig.info = 'Notification.HasProblemInSignature';
      hasManageTrustBtn = false;
    }

    if (messageCenterConfig.info === 'Notification.AllValid' && hasCertifySignature) {
      messageCenterConfig.info = 'Notification.certifyValidInfo';
      let verifiedFields = signedSignatures.find((field) => field.signatureInfo && field.signatureInfo.status === 'verified');
      if (verifiedFields) {
        let { signer, certificateInfo = {} } = verifiedFields.signatureInfo;
        let { issuerChain = [] } = certificateInfo;
        let { issuerName, email = '', orgName = '' } = issuerChain[issuerChain.length - 1] || {};
        email = email ? `<${email}>` : '';
        let isESignCNFile = await pdfui.pdfViewer.getCurrentPDFDoc().isESignCNFile();
        if (isESignCNFile) {
          orgName = '';
        } else {
          const lang = localStorage.getItem('language');
          orgName = orgName && lang !== 'ja-JP' ? `${orgName},` : orgName;
        }
        messageCenterConfig.infoOptions = { email, signer, issuer: issuerName, orgName };
      }
    }

    messageCenterConfig.extendContent = () => (
      <div className="btn-container">
        {hasManageTrustBtn ? (
          <Button type="link" onClick={this.manageTrustAllCertificate}>
            {intl.get('Notification.manageTrustBtn')}
          </Button>
        ) : null}
        <Button type="link" onClick={this.clickSignaturePanel}>
          {intl.get('Notification.signaturePanelBtn')}
        </Button>
      </div>
    );

    return messageCenterConfig;
  }

  isShowFormFieldsFoundMessage() {
    const { formPreference } = store.docStore;
    const isHideDocumentMessage = formPreference.isHideDocumentMessage;
    return !isHideDocumentMessage;
  }

  getFormFieldsFoundMessageConfig() {
    let messageCenterConfig = {
      messageType: FormFieldsFound,
      title: 'Notification.FormFieldsFound',
      info: 'Notification.ContainForm',
    };
    return messageCenterConfig;
  }

  async showFormMessage(viewer) {
    let doc = viewer.getCurrentPDFDoc();
    if (doc) {
      let hasForm = await doc.hasForm();
      let isShowFormInfo = store.appStore.isShowDocFormInfo();
      if (hasForm && isShowFormInfo && this.isShowFormFieldsFoundMessage()) {
        let hasSignatureFields = false;
        let pdfForm = viewer.getCurrentPDFDoc().getPDFForm();
        let { fields } = pdfForm;
        if (fields.length) {
          let signatureFields = fields.filter((item) => item.getType() === 7);
          hasSignatureFields = signatureFields.length;
        }

        if (!hasSignatureFields) {
          // 只显示发现表单域
          let messageCenterConfig = this.state.messageCenterConfig;
          messageCenterConfig.doNotShowAgainChecked = !isShowFormInfo;
          messageCenterConfig.messages = [];
          let formFieldsFoundMessageConfig = this.getFormFieldsFoundMessageConfig();

          let formMessageIndex = messageCenterConfig.messages.findIndex((item) => item.messageType === FormFieldsFound);
          if (formMessageIndex < 0) {
            messageCenterConfig.messages.push(formFieldsFoundMessageConfig);
          } else {
            messageCenterConfig.messages.splice(formMessageIndex, 1, formFieldsFoundMessageConfig);
          }
          this.showMessageCenterDlg(messageCenterConfig);
        }
      }
    }
  }
  showNoCountryMessage() {
    const userEnv = !!store.userStore.userInfo ? store.userStore.userInfo.region : null;
    const { hasSignIn } = store.userStore;
    if (!!userEnv || !hasSignIn || (!isPdfOnlineDomain() && !isCommonFeatureDomain())) {
      return;
    }
    let noCountryMessageConfig = {
      messageType: NoCountry,
      title: 'Notification.NoCountry',
      info: 'Notification.NoCountryContent',
    };
    this.addMessage(noCountryMessageConfig);
  }
  showHistoricalDataMessage() {
    let { onlineUSUrl } = store.appStore;
    const { hasHistoricalData } = store.userStore;
    if (hasHistoricalData) {
      let downloadUrl = onlineUSUrl + '/download-share';
      const msg = {
        messageType: hasUsData,
        title: 'Notification.hasUsData',
        titleParams: { URL: downloadUrl },
      };
      this.addMessage(msg);
    }
  }
  addMessage = (MsgConfig) => {
    let messageCenterConfig = this.state.messageCenterConfig;

    let MessageIndex = messageCenterConfig.messages.findIndex((item) => item.messageType === MsgConfig.messageType);
    if (MessageIndex < 0) {
      messageCenterConfig.messages.push(MsgConfig);
    } else {
      messageCenterConfig.messages.splice(MessageIndex, 1, MsgConfig);
    }
    this.showMessageCenterDlg(messageCenterConfig);
  };

  showCompareResultDialog(compareResultConfig) {
    if (!compareResultConfig.hide) compareResultConfig.hide = this.onCloseModalDlg;
    this.setState({
      messageDlgCfg: {
        target: CompareResult,
        config: compareResultConfig,
      },
    });
  }

  onShowDropFileHere = () => {
    this.setState({
      isShowDropFileHere: true,
    });
  };
  onShowGetStartGuid = () => {
    this.setState({
      isShowGetStartGuid: true,
    });
  };

  onMountedViewerComponents(component) {
    if (!component || !component.name) {
      return;
    }
    // check user sign in
    // CONVERT_FILES_TO_PDF
    // const {hasSignIn} = store.userStore;
    //TODO FOXIT 屏蔽福软业务
    //const hasSignIn = store.loginNewStore.isLogin
    // if(!hasSignIn && isFileSelector(component.name)){
    //   component.doEnableNoticeClick();
    //   return;
    // }
    // if(isFileSelector(component.name)){
    //   component.doEnableInput();
    // }
  }

  getComponentTabName(component) {
    let tabComponent;
    const regFn = (name) => {
      // fv--home-tab-paddle
      // let reg = /fv--(\S)+-tab-paddle/;
      let regs = [/fv--(\S)+-tab-paddle/, /fv--field-contextmenu/];
      let hasIn = regs.some((reg) => {
        if (reg.test(name)) {
          return true;
        }
        return false;
      });

      return hasIn;
    };
    tabComponent = component.findClosestComponent((comp) => {
      if (regFn(comp.name)) {
        return true;
      }
      return (
        comp.nodeName === 'tab' ||
        comp.name === 'sidebar' ||
        comp.name === 'float-bar' ||
        // comp.name === 'fv--mobile-header-right'||
        comp.name === 'fv--mobile-topbar-tools-dropdown' ||
        comp.name === 'fv--bookmark-contextmenu' ||
        comp.name === 'fv--thumbnail-contextmenu'
      );
    });
    let tabName = !!tabComponent ? tabComponent.name : '';
    tabName = tabName.replace('joinsplit', 'edit');
    if (!tabComponent && isMobile) {
      do {
        if (component.name === HAND_TOOL || component.name === HOME_SINGLE_PAGE || component.name === HOME_CONTINUOUS) {
          tabName = 'home-tab';
          break;
        }
        tabComponent = component.findClosestComponent((comp) => comp.attrs && comp.attrs['tab']);
        if (!!tabComponent && tabComponent.attrs && tabComponent.attrs['tab']) tabName = tabComponent.attrs['tab'] + '-tab';
      } while (false);
    }
    if (!tabName) return '';
    if (regFn(tabName) && tabName.indexOf('tab-paddle') > -1) {
      tabName = tabName.replace('fv--', '').replace('tab-paddle', 'tab');
      return tabName;
    } else if (tabName === 'fv--field-contextmenu') {
      return 'sidebar';
    }
    if (!!tabComponent && tabComponent.nodeName === 'tab' && tabName.indexOf('tab') === -1) tabName = tabName + '-tab';
    tabName = tabName.replace('float-bar', 'floating_bar').replace('fv--mobile-topbar-tools-dropdown', 'home-tab');
    tabName = tabName.replace('fv--bookmark-contextmenu', 'sidebar');
    tabName = tabName.replace('fv--thumbnail-contextmenu', 'sidebar');
    return tabName;
  }

  onClickViewerComponents(component) {
    if (!component || !component.name) {
      return;
    }
    let tabName = this.getComponentTabName(component);
    this.onClickViewerBtn({ btnName: component.name, tabName });
  }
  doAutoOpenPaperCheckResult() {
    let paperCheckId = getQueryVariable('paperCheckId');
    let paperCheckTitle = getQueryVariable('paperCheckTitle');
    let paperCheckEngine = getQueryVariable('paperCheckEngine');
    if (paperCheckId && paperCheckTitle && paperCheckEngine) {
      fileController.doAutoOpenPaperCheckResult(
        paperCheckEngine,
        paperCheckId,
        paperCheckTitle,
        (/* error */) => {
          window.history.pushState('', '', '/');
        },
        (/* result */) => {
          window.history.pushState('', '', '/');
        },
      );
    }
  }
  doAutoOpenFileByUrl = (/*pdfui*/) => {
    let fileUrl = getQueryVariable('fileurl');
    const esignOpenFile = getQueryVariable('esignOpenFile');
    let fileName = getQueryVariable('filename');
    let callback = null;
    if (+esignOpenFile === 1) {
      // 打开esign示例文档
      const URL_ESIGNCN = eSignChinaService.getURL_ESIGNCN();
      fileUrl = `${URL_ESIGNCN}/api/uploads/sample.pdf`;
      fileName = 'sample.pdf';
      callback = () => {
        // 打开完成后切换到签章菜单
        let $ = window.UIExtension.jQuery;
        $(document.querySelector("[name='esignCN-tab']")).trigger('click');
      };
    }
    if (!!fileUrl) {
      let serviceMode = getQueryVariable('service_mode');
      // Service mode: server, client
      let _fileUrl = fileUrl;

      if (serviceMode === 'client') {
        if (isSafari) {
          this.pdfui.alert('phantom_online:openServerModeOfClientInSafariErrorTip', 'phantom_online:alertTitle');
          this.closeClient();
          return;
        }
        store.userStore.doSendGAEvent({
          eventKey: 'double_click_to_open_local_files',
          label: 'getting_started',
        });
        let filePath = getQueryVariable('filepath');
        let serviceModeOfClientParams = window.location.search;
        store.appStore.setServiceModeOfClientInfo({
          fileUrl,
          fileName,
          serviceMode,
          filePath,
          serviceModeOfClientParams,
        });
        fileController.doOpenFileOfServiceModeOfClient(
          fileUrl,
          fileName,
          filePath,
          (/* error */) => {
            this.closeClient();
          },
          (/* result */) => {
            this.closeClient();
          },
        );
      } else {
        _fileUrl = store.appStore.getFileUrlByTransferStation(fileUrl);

        if (!fileName) {
          fileName = getFileNameByUrl(fileUrl);
          fileName = !!fileName ? fileName : 'file-url-input.pdf';
        }
        if (!_fileUrl) {
          return;
        }
        fileController.doOpenFileByUrl(_fileUrl, fileName, null, true, callback);
      }
      return;
    }
    //pdfui.openPDFByFile(buffer, {});
    let debug = getQueryVariable('debug');
    if ('file' !== debug) {
      return;
    }

    let baseUrl = getBaseUrl();
    fileUrl = baseUrl + 'butterflies with oval.pdf';
    fileController.doOpenFileByUrl(fileUrl, 'butterflies with oval.pdf');
  };
  doAutoOpenOnedriveFileByUrl = async () => {
    const ServerType = getQueryVariable('ServerType');
    if (ServerType != 'OneDriveBusiness' && ServerType != 'OneDrivePersonal') {
      return;
    }

    const originalPath = getQueryVariable('originalPath');

    const originalPath_base64 = window.btoa(originalPath);

    const newUrl = `u!${trimEnd(originalPath_base64, '=').replace('/', '_').replace('+', '-')}`;

    let isSignInOneDrive = await isSignInDrive('OneDrive');
    if (isSignInOneDrive) {
      store.driveStore.getOneDriveFileByUrl(
        newUrl,
        (result) => {
          this.onOpenFileForUrl({ url: result['@microsoft.graph.downloadUrl'], fileName: result.name });
        },
        (error) => {
          console.error('doAutoOpenOnedriveFileByUrl -> error', error);
          signOut('OneDrive', (/* result */) => {
            this.doAutoOpenOnedriveFileByUrl();
          });
        },
      );
    } else {
      signIn(
        'OneDrive',
        () => {
          store.driveStore.getOneDriveFileByUrl(
            newUrl,
            (result) => {
              this.onOpenFileForUrl({ url: result['@microsoft.graph.downloadUrl'], fileName: result.name });
            },
            (error) => {
              console.error('doAutoOpenOnedriveFileByUrl -> error', error);
              signOut('OneDrive', (/* result */) => {
                this.doAutoOpenOnedriveFileByUrl();
              });
            },
          );
        },
        () => {
          console.error('OneDrive signIN closed');
        },
      );
    }
  };
  onShowSubscribePlane = () => {
    const fromOfficeAddIn = isFromOfficeAddIn();

    if (fromOfficeAddIn) {
      window.pdfui.eventEmitter.emit('need-pay-event');
      browserService.doSwitchViewPageBy(BROWSER_REMOVE_FOR_OFFICE_ADD_IN);
    }
  };
  onOpenFileFromOneDrive = async (emitter) => {
    SharepointAndOneDriveFlow(emitter, {
      doCloseSidebar: this.doCloseSidebar,
      onShowCombineFilesDlg: this.onShowCombineFilesDlg,
      onShowMulFiles2PDFDlg: this.onShowMulFiles2PDFDlg,
      onShowSaveAsDlg: this.onShowSaveAsDlg,
      showNotActive: this.showNotActive,
      showSubscribeForExpired: this.showSubscirbeForExpired,
    });
  };
  onOpenFileFromOffice = () => {
    const docId = getQueryVariable('docidForOffice');
    const fileName = getQueryVariable('fileName');

    if (!docId || !fileName) {
      return;
    }

    const openFile = async () => {
      const fileUrl = convertApis.doGetDownloadUrlForOffice365(docId);

      try {
        fileController.doOpenFileByUrl(fileUrl, fileName);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          store.appStore.setGlobalMessage({ type: 'error', content: intl.get('FileNotExist') });
        }
      }
    };
    openFile();
  };
  onOpenFileByGoogleDrive = (emitter) => {
    GoogleDriveFlow(emitter, this.fileTabRef, this.state.folderPath, this.onHandlePDFByResponse);
  };
  onOpenFileByAi = () => {
    let ai_file_id = getQueryVariable('ai_file_id');
    if (!ai_file_id) return;

    let szValue = storageGetItem(localStorage, 'open_file_in_tab');
    if (!szValue) return;
    let fileInfo = JSON.parse(szValue);
    const { fileUrl, fileName, aiFileId } = fileInfo;
    fileController
      .doOpenFileByUrl(fileUrl, fileName, null, true)
      .then((result) => {
        let doc = result;
        let info = doc.info;

        AiPluginController.AiPluginDocFns.addDocIdToMap(info.id, aiFileId);
        //this.docIdMap[info.id] = aiFileId;

        showAiPanel();
      })
      .catch((err) => {
        console.error('onOpenFileByAi -> err', err);
      });
    // clean param
    store.historyStore.goToHomePage();
  };

  onShowToSaveBeforeOpen = async (callback) => {
    // const { hasSignIn } = store.userStore;
    const hasSignIn = store.loginNewStore.isLogin;
    const { isFromSharePoint } = store.appStore.sharePointInfo;

    if (!hasSignIn && !isJPDomain() && !isFromSharePoint) {
      //TODO FOIXT 替换sso登录弹框
      store.loginNewStore.login();
      //   store.appStore.doUpdateSignInNotice({ id: 'Permission.SignIn' });
      return true;
    }

    const showToSaveBeforeOpenFn = async () => {
      if (!window.pdfui || !store.viewer.hasOpenFile) {
        callback && callback(false);
        return false;
      }

      let fileName = '';
      let isCancelOpen = false;

      if (!store.appStore.docModified || store.appStore.currentMode === COLLABORATION_MODE) {
        callback && callback(isCancelOpen);
        return isCancelOpen;
      }

      let doc = await window.pdfui.getCurrentPDFDoc();
      if (doc && doc.metadata) {
        fileName = doc.metadata.FileName || 'undefied.pdf';
      }
      //   this.onShowWarningMessage(
      //     (isOk) => {
      //       const hasSign = store.viewer.pdfViewer.getOnlineSignList().length;
      //       if(isOk){
      //         if(hasSign){
      //           this.doOnlineSignHandleBeforeClose(isOk,callback);
      //         }else{
      //           this.inMobileHandler();
      //           callback && callback(isOk);
      //         }
      //       }else{
      //         store.appStore.doUpdateDocModified(false);
      //         callback && callback(isOk);
      //       }
      //     },
      //     { message: 'File.ToStopOpen', messageParams: {FileName: fileName}, cancel: 'No', ok: 'Yes', closable: true, customClose: true, iconType: 'alert' }
      // );
      console.log('File.ToStopOpen 1');
      this.onShowWarningMessage(
        (isOk) => {
          console.log('store.appStore.docModified');
          console.log(store.appStore.docModified);
          // const {driveName} = this.state;
          // let isInMobile = isMobile;
          if (isOk) {
            // 判断是否vip
            let identity = store.userNewStore.userData.identity;
            if (identity === 'vip') {
              // store.saveFileNewStore.saveFile("downFile")
              store.appStore.doUpdateDocModified(false);
              store.appStore.saveToLocalComputer({ btnName: '' }, fileName);
            } else {
              store.saveFileNewStore.saveFileDialog('downFile');
            }
            callback && callback(isOk);
          } else {
            console.log('ToStopOpen editorContain 1');
            store.appStore.doUpdateDocModified(false);
            callback && callback(isOk);
          }
        },
        { message: 'File.ToStopOpen', messageParams: { FileName: fileName }, cancel: 'No', ok: 'Yes', closable: true, customClose: true, iconType: 'alert' },
      );

      // this.onShowWarningMessage(
      //     (isOk) => {
      //       const hasSign = store.viewer.pdfViewer.getOnlineSignList().length;
      //       if(isOk){
      //         if(hasSign){
      //           this.doOnlineSignHandleBeforeClose(isOk,callback);
      //         }else{
      //           this.inMobileHandler();
      //           callback && callback(isOk);
      //         }
      //       }else{
      //         store.appStore.doUpdateDocModified(false);
      //         callback && callback(isOk);
      //       }
      //     },
      //     { message: 'File.ToStopOpen', messageParams: {FileName: fileName}, cancel: 'No', ok: 'Yes', closable: true, customClose: true, iconType: 'alert' }
      // );
    };
    if (store.appStore.signChinaStampTotal > 0) {
      const Events = UIExtension.PDFViewCtrl.Events;
      const cancelApplyCallback = () => {
        showToSaveBeforeOpenFn();
      };
      window.pdfui.eventEmitter.emit(Events.signChinaNoApply, cancelApplyCallback);
      return;
    }
    const signChinaStampState = window.pdfui.pdfViewer.esignChinaProps?.signChinaStampState;
    const toSaveBeforeOpenFnState = window.pdfui.pdfViewer.esignChinaProps?.toSaveBeforeOpenFnState;
    if (signChinaStampState && !toSaveBeforeOpenFnState) {
      const Events = UIExtension.PDFViewCtrl.Events;
      const cancelApplyCallback = () => {
        showToSaveBeforeOpenFn();
      };
      window.pdfui.eventEmitter.emit(Events.signChinaFlowNoApply, cancelApplyCallback);
      return;
    }
    showToSaveBeforeOpenFn();
  };

  inMobileHandler = () => {
    const { driveName } = this;
    let isInMobile = isMobile;
    !isInMobile && this.commonForSaveDrives('LOCAL_COMPUTER');
    isInMobile && driveName !== '' && this.onShowDrivesList({ type: 'save' });
    isInMobile && driveName === '' && window.pdfui.getComponentByName('fv--mobile-topbar-tools-dropdown').then((component) => component && component.active());
  };
  doOnlineSignHandleBeforeClose = (isOk, callback, saveDirect = false) => {
    const fn = () => {
      !saveDirect && this.inMobileHandler();
      callback && callback(isOk);
    };
    const onlineSignList = store.viewer.pdfViewer.getOnlineSignList();
    if (onlineSignList.length && onlineSignList.every((item) => item.signType === TAB_NAME_MAP.FoxitESign)) {
      this.onApplyAllESignSignature(false, fn);
    } else if (onlineSignList.length && onlineSignList.every((item) => item.signType === TAB_NAME_MAP.FillSign)) {
      store.viewer.pdfViewer.getStateHandlerManager().switchTo('onlinePdfSign');
      const cancel = 'SignatureListContainer.optionsDialog.discard';
      const ok = 'SignatureListContainer.optionsDialog.applyAll';
      const message = 'SignatureListContainer.optionsDialog.needApplyFillSign';
      this.setState(
        {
          messageDlgCfg: {},
        },
        () => {
          this.onShowWarningMessage(
            (isCurOk) => {
              if (isCurOk) {
                const pdfViewer = store.viewer.pdfViewer;
                pdfViewer.getCurrentPDFDoc().addFillSignSignaturesToDoc(pdfViewer, null, fn);
                window.sessionStorage.setItem('applyEventFromCloseSave', 'yes');
              } else {
                const $ = window.UIExtension.jQuery;
                const pdfViewer = store.viewer.pdfViewer;
                const list = pdfViewer.getOnlineSignList();
                list.forEach(({ id }) => $(`#${id}`).remove());
                pdfViewer.getOnlineSignManger().clear();
                store.viewer.pdfui.eventEmitter.emit('no-sign-apply');
                $('.fv__pdf-page-handler-container .mouse-move-img').remove();
                pdfViewer.getStateHandlerManager().switchTo('hand');
                fn();
                window.sessionStorage.setItem('applyEventFromCloseSave', 'no');
              }
            },
            { message, cancel, ok, closeable: false, customClose: false, iconType: 'alert' },
          );
        },
      );
    } else {
      fn();
    }
  };
  onHideFloatBar = async () => {
    const floatBar = await pdfui.getComponentByName('float-bar');

    floatBar && floatBar.hide();
  };

  doInitializePDFViewerUI(UIExtension, clickFunc) {
    this.setState({
      isShowGlobalSpin: true,
    });
    const { licenseKey, licenseSN, l } = this.state;
    // 启动服务前需要判断，是否已经加载了脚本，若没有，则先加载,后重新执行
    if (!this.state.loadViewerEnd) {
      loadViewer(
        (UIExtension) => {
          window._UIExtension = UIExtension;
          let $ = window.UIExtension.jQuery;
          const $uixStyles = $(`<link rel='StyleSheet' href='${FOXITWEBSDK_URLS.UIExtension.replace('full.js', 'css')}'></link>`);

          $(document.body).append(`<link rel='StyleSheet' href='${isMobile ? FOXITWEBSDK_URLS.addonsMobileStylePC : FOXITWEBSDK_URLS.addonsStylePC}'></link>`);

          $uixStyles.on('load', () => {
            this.doInitializePDFViewerUI(UIExtension, clickFunc);

            this.pdfuiInitialized.resolve(window.pdfui);
          });

          $uixStyles.appendTo(document.body);
          this.setState({
            loadViewerEnd: true,
          });
          // this.doInitializePDFViewerUI(UIExtension, clickFunc);
        },
        licenseSN,
        licenseKey,
        l,
      );
      return;
    }

    const me = this;
    let emitter = new UIExtension.vendors.EventEmitter();
    store.appStore.setViewerEventEmitter(emitter);
    const { isAdmin } = store.userStore;
    const hasSignIn = store.loginNewStore.isLogin;
    let getEmail = () => {
      const { userInfo } = store.userStore;
      let email = userInfo.userEmail.substr(0, 10) + '...';
      return email;
    };
    const { isOnPremiseDeployMode } = store.appStore;
    const { fragments, fullTemplate, toolbar, collabTemplate } = composeUI(this.onClickViewerBtn, isOnPremiseDeployMode);

    store.appStore.setUIConfig(fragments, toolbar);

    // options for UIExtension.PDFUI
    initializeViewerComponents(UIExtension, emitter, {
      mountedCallback: this.onMountedViewerComponents,
      onClickCallback: this.onClickViewerComponents,
      getEmail,
      hasSignIn,
      isAdmin,
    });
    let addons = window.allInOne ? window.allInOne : window.UIExtensionAddons ? window.UIExtensionAddons : FOXITWEBSDK_URLS.addons;

    console.log('addons');
    console.log(addons);

    let enableJS = localStorage.getItem('enable_js_action');
    enableJS = JSON.parse(enableJS || 'true');

    let template = fullTemplate.replace('<Download></Download>', SaveBtn(isOnPremiseDeployMode));

    if (isCollabURL() && !isMobile) {
      template = collabTemplate;
      this.partialWorker = true;
    }
    const { full } = store.appStore.lng;

    const renderTo = (this.uiextContainer = document.createElement('div'));
    renderTo.id = 'pdf-ui';

    let options = {
      i18n: window.__hashVersion__ ? { version: window.__hashVersion__, lng: full } : void 0,
      viewerOptions: {
        enableJS,
        minScale: 0.01,
        maxScale: 25,
        showAnnotTooltip: true,
        showFormFieldTooltip: true,
        fontPath: FOXITWEBSDK_URLS.fontPath,
        libPath: FOXITWEBSDK_URLS.libPath, // the library path of web sdk.
        jr: {
          readyWorker: window.readyWorker,
          licenseSN: licenseSN,
          licenseKey: licenseKey,
          l: l,
          fontServer: '../external/fonts',
          // fontPath: '../external/brotli'
        },
        customs: {
          pluginCommonForOpenDrivers: (driverId) => {
            me.commonForDrives(driverId);
          },
          pluginCommonForSaveDrivers: (driverId) => {
            me.commonForSaveDrives(driverId);
          },
          pluginShowDialog: (params) => {
            // 提供对话框给插件使用,插件可以在此对话框中加载iframe.
            store.pluginStore.pluginCommonDialog.isShowPluginCommonDialog = true;
            store.pluginStore.pluginCommonDialog.width = params.rect.width;
            store.pluginStore.pluginCommonDialog.title = params.title;
            store.pluginStore.pluginCommonDialog.url = params.url;
          },
          pluginCloseDialog: () => {
            // 提供对话框给插件使用,关闭对话框
            store.pluginStore.pluginCommonDialog.isShowPluginCommonDialog = false;
            store.pluginStore.pluginCommonDialog.width = '790px';
            store.pluginStore.pluginCommonDialog.title = '';
            store.pluginStore.pluginCommonDialog.url = '';
          },
          netDriverSetUserInfo: (driverId, userInfo) => {
            debugger;

            store.netDriverStore.netDriverSetUserInfo(driverId, userInfo);
          },
          setNetDriverIsSignIn: (driverId, isSignIn) => {
            store.netDriverStore.setNetDriverIsSignIn(driverId, isSignIn);
          },
          setNetDriverSignInResult: (params) => {
            // store.driveStore.func_numberOfAjaxCAllPendingDecrease()
            console.log(params);
          },
          addNetDriverItem: (params) => {
            store.netDriverStore.AddNetDrivers(params);
            store.netDriverStore.ReloadFirstPageMenu();
          },
          isFromSharePoint: () => {
            const { isFromSharePoint } = store.appStore.sharePointInfo;

            return isFromSharePoint;
          },
          saveFileToSharePoint: ({ arrayBuffer, fileName, needCuid }) => {
            const fn = async () => {
              const { isFromSharePoint, fromDrive } = store.appStore.sharePointInfo;

              if (isFromSharePoint) {
                try {
                  const fileNameWithoutExtension = getFileNameWithoutExtension(fileName);
                  // const unit8ArrayData = new Uint8Array([arrayBuffer]);
                  const blob = new Blob(arrayBuffer, {
                    type: 'application/pdf',
                  });

                  blob.name = needCuid ? `${fileNameWithoutExtension}-${cuid()}.pdf` : fileName;
                  await store.driveStore.saveFileBackToDrive(blob).catch(() => {
                    throw 'save to sharepoint error';
                  });

                  store.appStore.pushNotificationMessageArr(
                    Object.assign({}, APP_CONSTANTS.SavedToSharePointNotificationSucceed, { infoParam: { fromDrive } }),
                  );
                } catch (error) {
                  store.appStore.pushNotificationMessageArr(
                    Object.assign({}, APP_CONSTANTS.SavedToSharePointNotificationFailed, { onErrorBtn: fn, infoParam: { fromDrive } }),
                  );
                }
              }
            };

            fn();
          },
          setFullScreen: (params) => {
            preferenceFullScreenController.showFullScreenMode(params);
          },
          isFullScreen: () => preferenceFullScreenController.isFullscreen,
          passwordProtectSaveSecurityPolicy,
          isAttachFileOverSize: (file) => {
            if (!file || store.appStore.currentMode !== COLLABORATION_MODE) {
              return;
            }
            if (file.size > 1024 * 1024 * ATTACH_FILE_SIZE_LIMIT) {
              store.appStore.setGlobalMessage({
                type: 'error',
                content: intl.get('collaboration.Dlg.FileOverSizeCommon', { fileSize: ATTACH_FILE_SIZE_LIMIT }),
              });

              return true;
            }
          },
          isCollaborationMode: () => {
            return isCollabURL() || store.appStore.isCollaborationMode();
          },
          getShareUserList: store.collaborationStore.getShareUserList.bind(store.collaborationStore),
          sendMentionMsg: store.collaborationStore.sendMentionMsg.bind(store.collaborationStore),
          isAnnotOwner: (annotName) => {
            return store.collaborationStore.isAnnotOwner(annotName);
          },
          getCommentPermission: () => {
            return store.collaborationStore.canComment;
          },
          getRootAnnotNodeRecursiveAnnotNameArr: (annotName) => {
            return store.collaborationStore.getRootAnnotNodeRecursiveAnnotNameArr(annotName);
          },
          isOwnerDeleteCollaboratorAnnot: () => {
            return store.collaborationStore.isOwnerDeleteCollaboratorAnnot;
          },
          isCollaboratorAnnotBeDeletedByOwner: () => {
            return store.collaborationStore.isCollaboratorAnnotBeDeletedByOwner;
          },
          resetIsOwnerDeleteCollaboratorAnnot: () => {
            store.collaborationStore.resetIsOwnerDeleteCollaboratorAnnot();
          },
          resetIsCollaboratorAnnotBeDeletedByOwner: () => {
            store.collaborationStore.resetIsCollaboratorAnnotBeDeletedByOwner();
          },
          getAnnotPermissionsSync: (annot) => {
            if (!annot) {
              return;
            }
            const fully = UIExtension.PDFViewCtrl.constants.ANNOTATION_PERMISSION.fully;
            if (store.appStore.isCollaborationMode() || store.teamsAppStore.inTeamsApp) {
              let headerAnnot;
              const replyAble = UIExtension.PDFViewCtrl.constants.ANNOTATION_PERMISSION.replyable;
              const deleteAble = UIExtension.PDFViewCtrl.constants.ANNOTATION_PERMISSION.deletable;
              const { inTeamsApp } = store.teamsAppStore;

              if (annot.isGrouped && annot.isGrouped()) {
                headerAnnot = annot.getGroupHeader();
              } else {
                headerAnnot = annot;
              }
              if (!headerAnnot) return [fully];

              const annotName = headerAnnot.getName();

              if (!store.userStore.hasSignIn) {
                return [];
              } else if (store.collaborationStore.isAnnotOwner(annotName)) {
                return [fully];
              } else if (headerAnnot.$PERMISSION_DELETE === true) {
                return [deleteAble];
              } else if (store.collaborationStore.isShareReviewOwner() && !inTeamsApp) {
                return [replyAble, deleteAble];
              } else {
                return [replyAble];
              }
            }
            return [fully];
          },
          getAnnotPermissions: (annot) => {
            return Promise.resolve(options.viewerOptions.customs.getAnnotPermissionsSync(annot));
          },
          closeDocBefore: () => {
            // And don't pop up the save dialog when afterHiddenDataOperateAndReopenFile is equaled true.
            if (this.pdfDoc && this.pdfDoc.otherOptions.afterHiddenDataOperateAndReopenFile) return true;
            return new Promise((resolve) => {
              this.onShowToSaveBeforeOpen((isToSave) => {
                if (!isToSave || !(this.pdfDoc && this.pdfDoc.otherOptions && this.pdfDoc.otherOptions.isOpenNewFileAfterClose)) {
                  resolve(!isToSave);
                } else {
                  /**
                   * openNewFileAfterCloseResolve 保存了  当前这个 Promise 的resolve钩子，
                   * 需要在 '保存文件弹窗' 关闭之后, 将 当前这个 Promise 的状态置为 resolve，
                   * 在 PdfViewer  的  close方法里面 可以接受这个 resolve这个状态，从而在文件保存后打开新的文件
                   * 这样实现的原因：’保存文件提示的弹窗' 和 '保存文件弹窗' 不在一个 UI进程里面, 没法将当前这个 Promise 的状态置为 resolve
                   *
                   */
                  this.openNewFileAfterCloseResolve = resolve;
                }
              });
            });
            //return confirm('Close the current document?');
          },
          // URIActionCallback / submitFormActionCallback
          javascriptDisabledActionCallback: () => {
            this.onShowWarningMessage(null, { message: 'DisableJS.Warning' }, true);
          },
          getDocPermissions: () => {
            const vieMode = getDocumentViewMode();
            if (vieMode === 'onlyForPDFA') {
              const pdfaEditable = this.state.pdfaEditable;
              if (this.pdfDoc) {
                const isPdfaDoc = !!this.pdfDoc.info.pdfaid;
                if (isPdfaDoc && !pdfaEditable) return 2052;
              }
              return -1;
            }
            return -1;
          },
          namedActionCallback: (name) => {
            if (name in menuContainer) {
              return pdfui.getRootComponent().then((root) => {
                root.getComponentByName(menuContainer[name]).trigger('shown');
              });
            }
          },
          PageCustomRender: cutomPageRender,
          getFieldPasteType: (widgets, pageIndex) => pdfViewerService.getFieldPasteType(widgets, pageIndex),
          eSignCNHasInitFlow() {
            return (
              toJS(store.esignCnStore.eSignCN_TotalActiveFieldList).length > 0 ||
              store.esignCnStore.flowSignFormStatus === 1 ||
              store.esignCnStore.flowSignFormStatus === 2
            );
          },
          getCurrentESignCNSignerSubject() {
            return store.esignCnStore.currentSignerSubject;
          },
          getUserName: () => store.userStore.userData.nickname,
          getUserEmail: () => store.userNewStore.userData.email,
          getESignCNInitSignFieldsColor() {
            return eSignChinaService.getESignCNInitSignFieldsColor();
          },
          updateInitSignFieldsColor(item, type) {
            return eSignChinaService.updateInitSignFieldsColor(item, type);
          },
          cleanInitSignFieldsColor() {
            return eSignChinaService.cleanInitSignFieldsColor();
          },
          updateDocModifiedInStore: (flag) => {
            store.appStore.doUpdateDocModified(flag);
          },
        },
      },
      customs: {
        resetDocDriveName: () => {
          store.docStore.resetDocDriveName();
        },
        supportFormAsDefaultProps: true,
        // disableSignature:()=>{
        //   this.onShowWarningMessage(null, {message:'NotSupportSign'}, true)
        // },
        hasSignIn: () => store.loginNewStore.isLogin,
        isShowingGlobalLoadAnimation: () => {
          const {
            progressingInfo: { show: isShowingProgressBar },
            loadingMessage: { show: isShowingGlobalCircleLoad },
          } = store.appStore;

          return isShowingProgressBar || isShowingGlobalCircleLoad;
        },
        getUserInfoByAnnotName: () => store.collaborationStore.getUserInfoByAnnotName.bind(store.collaborationStore),
        showSaveAsDialog: this.onShowSaveAsDlg,
        showReduceFileSizeDialog: this.onReduceFileSize,
        showOptimizeScanned: this.onOptimizeScanned,
        showBackgroundDlg: () => {}, //None for action wizard now.
        showBatesNumberingDlg: () => {}, //None for action wizard now.
        showHeaderFooterDlg: () => {}, //None for action wizard now.
        showWatermarkDlg: () => {}, //None for action wizard now.
        retryLocalCertificate: fileController.retryLocalCertificate,
        onShowCertificateProtectDlg: this.onShowCertificateProtectDlg,
        getDefaultPredefinedText: () => {
          const key = PreferencesDialog.storageIdentityKey();
          let defaultPredefinedData = localStorage.getItem(key);
          if (defaultPredefinedData) {
            defaultPredefinedData = JSON.parse(defaultPredefinedData);
          } else {
            defaultPredefinedData = [];
          }
          if (store.userStore.userInfo) {
            defaultPredefinedData.unshift({ id: 0, content: store.userStore.userInfo.fullname });
            defaultPredefinedData.push({ id: 1, content: new Date().format('yyyy/MM/dd') });
          }
          return defaultPredefinedData;
        },
        getMeasuringConfig: () => {
          const key = PreferencesDialog.measuringKey();
          let measuringConfig = localStorage.getItem(key);
          if (measuringConfig) {
            return JSON.parse(measuringConfig);
          } else {
            return {};
          }
        },
        setMeasuringConfig: (key, value) => {
          const storageKey = PreferencesDialog.measuringKey();
          let measuringConfig = localStorage.getItem(storageKey);
          measuringConfig = measuringConfig ? JSON.parse(measuringConfig) : {};
          measuringConfig[key] = value;
          localStorage.setItem(storageKey, JSON.stringify(measuringConfig));
        },
        addSubCheckEventInTeams: (fromFun = false) => {
          store.appStore.emitEvent('need-pay-event', fromFun);
        },
        activeTabName: () => {
          return window.pdfui.activeMainPageTab.name;
        },
        updateDocModifiedInStore: (flag) => {
          store.appStore.doUpdateDocModified(flag);
        },
        isEnablePremiumFunInCn: (btnName) => {
          if (isCNDomain()) {
            const isPremiumFunInCn = permissionManager.isCNJPPremiumFeature(btnName);
            return isPremiumFunInCn;
          }
          return false;
        },
        isCNEveriment: () => {
          return isCNDomain();
        },
        isAccountExpired: (isAlert = true, gaEvent) => {
          const hasSignIn = store.loginNewStore.isLogin;
          // 插件过来的订阅逻辑
          const addInType = thirdPartyService.isFromThirdParty();

          if (addInType) {
            let isPremiumFeature = false;
            const { currentClickBtnName } = store.appStore;

            if (currentClickBtnName) {
              isPremiumFeature = permissionManager.isPremiumFeature(currentClickBtnName);
            }

            const checkPassed = thirdPartyService.checkPermissionAndReflectSync({ addInType }, isPremiumFeature);

            store.appStore.resetCurrentClickBtnName();

            if (!hasSignIn && isPremiumFeature) {
              isAlert && store.appStore.doShowSignInDialog();

              return true;
            }

            return !checkPassed;
          }

          // EC原有订阅逻辑
          const { isEdu } = store.userStore;
          const { isOnPremiseDeployMode } = store.appStore;
          const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = store.userStore;

          if (isCNDomain() || isJPDomain()) {
            if (store.esignCnStore.flowSignFormStatus < 1 && store.esignCnStore.flowSignFormStatus !== -1) {
              // esigncn 创建表单域时忽略权限判断
              isAlert = true;
            }
          }
          if (!hasSignIn) {
            isAlert && this.doShowSignInDialog();
            return true;
          }
          const { btnName, tabName, gaEventKey } = gaEvent || {};

          if (gaEvent && btnName && !this.isFilterGaEvent(btnName)) {
            store.userStore.doSendGAEvent({ eventKey: gaEventKey ? gaEventKey : btnName, label: tabName });
          }

          options.customs.sendGAEvent(gaEvent);
          if (this.isEnablePremium()) {
            return false;
          }

          if (isEnterpriseUser) {
            if (!hasEditPermissionAndEnterpriseUser) {
              // enterprise users
              if (isOnPremiseDeployMode) {
                isAlert &&
                  this.onShowWarningMessage(
                    (isOk) => {
                      isOk && this.onLoginOut(true);
                    },
                    { message: 'account.notActiveDisableAll', title: 'account.notActiveDisableAllTitle', ok: 'user.signOut', cancel: 'Cancel' },
                    false,
                  );
                return true;
              }
              if (isAlert) {
                if (isPdfOnlineDomain() || isCommonFeatureDomain()) {
                  window.pdfui.eventEmitter.emit('need-pay-event');
                } else {
                  console.info('🍭  ~ file:HeaderEntrance method:showPayDlg line:59 -----', '端午后处理');
                  this.onShowWarningMessage((/*isOk*/) => {}, { message: 'account.notActive', title: 'PhantomPDF.Online.TitleWithOnline' }, true);
                }
              }
              return true;
            }
            return false;
          }
          const { isDashboardTrial } = store.accountStore;
          if (isCNDomain()) {
            if (isDashboardTrial) {
              return false;
            }
          }
          if (this.isUnablePremium()) {
            if (isCNDomain() || isJPDomain()) {
              const { isExpired } = store.accountStore;
              let messageKey = 'account.expiredTip';
              if (!isExpired) {
                messageKey = isCNDomain() ? 'account.trialExpiredTip_CN' : 'account.trialExpiredTip';
              }
              isAlert &&
                this.onShowWarningMessage(
                  (isOk) => {
                    isOk && store.userStore.setSubscribeVisible(true);
                  },
                  { message: messageKey, title: 'PhantomPDF.Online.TitleWithOnline', ok: 'subscription.plan.Subscribe', noCancel: true },
                );
            } else {
              if (isEdu) {
                // const {isExpired} = store.accountStore;
                // let messageKey = "account.expiredTip";
                // if (!isExpired) {
                //   messageKey = "account.trialExpiredTip";
                // }
                // isAlert && this.onShowWarningMessage((isOk)=>{ isOk && store.userStore.setSubscribeVisible(true); }, {message:messageKey, title:"PhantomPDF.Online.TitleWithOnline", ok: "subscription.plan.Subscribe", noCancel: true} );
                isAlert && this.pdfui.eventEmitter.emit('need-pay-event', true);
              } else if (isAlert) {
                this.pdfui.eventEmitter.emit('need-pay-event', true);
              }
            }
            return true;
          }
          return false;
        },
        // 发送GA事件 gaEvent = { eventKey, label, category, action, value }
        sendGAEvent: (gaEvent = {}) => {
          const label = gaEvent && gaEvent.label;
          if (label && !this.isFilterGaEvent(label)) {
            store.userStore.doSendGAEvent(gaEvent);
          }
        },
        // 显示Preference dialog
        showPreferences: (defaultActiveKey) => {
          this.fileTabRef.current.wrappedInstance.onShowPreferencesDlg(defaultActiveKey);
        },
        // esign cn api
        uploadSignedFile: ({ fileName, blob, processId, recipientOrder }) => {
          return eSignChinaService.uploadSignedFile({ fileName, blob, processId, recipientOrder });
        },
        createSignProcess: ({ title, wardType, saveType, creatorName, creatorPhone, creatorEmail, recipients }) => {
          return eSignChinaService.createSignProcess({ title, wardType, saveType, creatorName, creatorPhone, creatorEmail, recipients });
        },
        getSignFlowInfo: ({ processId }) => {
          return eSignChinaService.getSignFlowInfo({ processId });
        },
        signESignProcessMessage: (type, content) => {
          return eSignChinaService.signProcessMessage(type, content);
        },
        getESignConfig: () => {
          return eSignChinaService.getESignConfig();
        },
        getESignerAdminUrl: ({ accountId, orgId }) => {
          return eSignChinaService.getAdminUrl({ accountId, orgId });
        },
        getESignerUserInfo: (isOrg) => {
          return eSignChinaService.getUserInfoForESignCN(isOrg);
        },
        getESignerUserSubscription: (cnt, enterpriseId) => {
          return eSignChinaService.getUserSubscriptionForESignCN(cnt, enterpriseId);
        },
        getMySignStampList: ({ person, orgList }) => {
          return eSignChinaService.getMySignStampList({ person, orgList });
        },
        verifyUserInformation: () => {
          return eSignChinaService.verifyUserInformation();
        },
        getAuthUrl: (data) => {
          return eSignChinaService.getAuthUrl(data);
        },
        handleWillingnessAuth_V2: (data) => {
          return eSignChinaService.handleWillingnessAuth_V2(data);
        },
        signFileDigest: (data) => {
          return eSignChinaService.signFileDigest(data);
        },
        esignConfirm: ({ processId, recipientOrder }) => {
          return eSignChinaService.esignConfirm({ processId, recipientOrder });
        },
        addEvidenceForSign: (data) => {
          return eSignChinaService.addEvidenceForSign(data);
        },
        getESignerRoleInfo: () => {
          return store.userStore.roleInfo;
        },
        searchEmailForSign: (params) => {
          return eSignChinaService.searchEmailForSign(params);
        },
        validateSAMLResponse: (data) => {
          return eSignChinaService.ValidateSAMLResponse(data);
        },
        eSignChinaService,
        promptUserSaveToLocal: (fileName) => {
          this.onShowWarningMessage(
            (isOk) => {
              if (isOk) {
                console.log('File.ToStopOpen 2');
                fileController.saveToLocal();
              } else {
                console.log('ToStopOpen editorContain 2');
              }
              // todo eSignChina 修改提示词条
            },
            { message: 'File.ToStopOpen', messageParams: { FileName: fileName }, cancel: 'No', ok: 'Yes', closable: true, customClose: true },
          );
        },
        getAccountSubscription: (data) => {
          return eSignChinaService.getAccountSubscription(data);
        },
        innerSealCreate: (data) => {
          return eSignChinaService.innerSealCreate(data);
        },
        getInnerSealList: () => {
          return eSignChinaService.getInnerSealList();
        },
        innerSealDisable({ sealId }) {
          return eSignChinaService.innerSealDisable({ sealId });
        },
        getUserSubscription({ wardType }) {
          return eSignChinaService.getUserSubscription({ wardType });
        },
        getRecordSubscription: ({ wardType }) => {
          return eSignChinaService.getRecordSubscription({ wardType });
        },
        getJwtToken(enterpriseId) {
          return eSignChinaService.getJwtToken(enterpriseId);
        },
        getSAMLResponse() {
          return eSignChinaService.getSAMLResponse();
        },
        getEsignCNLicence(product) {
          return eSignChinaService.getEsignCNLicence(product);
        },
        getEnterpriseUser(enterpriseId) {
          return eSignChinaService.getEnterpriseUser(enterpriseId);
        },
        getUserRole(enterpriseId) {
          return eSignChinaService.getUserRole(enterpriseId);
        },
        openEsignTools() {
          return EsignTools.openEsignTools();
        },
        updateValueOfFlowSignFormStatus(val) {
          return store.esignCnStore.updateValueOfFlowSignFormStatus(val);
        },
        getESignCNFlowSignFormStatus() {
          return store.esignCnStore.flowSignFormStatus;
        },
        eSignCNHasInitFlow() {
          return (
            toJS(store.esignCnStore.eSignCN_TotalActiveFieldList).length > 0 ||
            store.esignCnStore.flowSignFormStatus === 1 ||
            store.esignCnStore.flowSignFormStatus === 2
          );
        },
        updateCurrentESignCNSignerSubject(val) {
          return store.esignCnStore.updateCurrentSignerSubject(val);
        },
        onLoginOut: ({ msg, cancel = 'Cancel', ok = 'logBackIn', title = 'Foxit PDF Editor' }) => {
          this.onShowWarningMessage(
            (isOk) => {
              if (isOk) {
                return this.onLoginOut(false, true);
              }
            },
            { message: msg, cancel, ok, title, closable: true, customClose: true, isI18n: false },
          );
        },
        generateUUID() {
          return eSignChinaService.generateUUID();
        },
        updateESignCN_ActiveFieldList(list) {
          return eSignChinaService.updateESignCN_ActiveFieldList(list);
        },
        updateESignCN_TotalActiveFieldList(list) {
          return eSignChinaService.updateESignCN_TotalActiveFieldList(list);
        },
        cleanActiveFieldList() {
          return eSignChinaService.cleanActiveFieldList();
        },

        cleanTotalFieldList() {
          return eSignChinaService.cleanTotalFieldList();
        },
        isESignCNField(fieldObjectNum) {
          return eSignChinaService.isESignCNField(fieldObjectNum);
        },
        getESignCNInitSignFieldsColor() {
          return eSignChinaService.getESignCNInitSignFieldsColor();
        },
        updateInitSignFieldsColor(item, type) {
          return eSignChinaService.updateInitSignFieldsColor(item, type);
        },
        cleanInitSignFieldsColor() {
          return eSignChinaService.cleanInitSignFieldsColor();
        },
        updateOutSignStampList() {
          return eSignChinaService.updateOutSignStampList(...arguments);
        },
        fetchOutStampList() {
          return store.esignCnStore.outSignStampList;
        },
        switchESignChinaTab(tabName, signRightFlowState, refresh) {
          me.ESignChinaGalleryToolRef.current.switchTab(tabName, signRightFlowState, refresh);
        },
        enterESignAdmin(type, callback, pdfUI) {
          if (type === 'person') return eSignChinaService.enterPersonAdmin(callback, pdfUI);
          if (type === 'org') return eSignChinaService.enterOrgAdmin(callback, pdfUI);
        },
        onShowWarningMessageAsync(data, noClose) {
          return store.appStore.onShowWarningMessageAsync(data, noClose);
        },
        checkOutSignSubscription() {
          return eSignChinaService.checkOutSignSubscription();
        },
        handleCheckOutSignSubscriptionError(data) {
          return eSignChinaService.handleCheckOutSignSubscriptionError(data);
        },
        searchFlowMan: (params) => {
          return eSignChinaService.searchFlowMan(params);
        },
        convert: {
          doConvertToPDF: (file) => {
            console.log('doConvertToPDF');
            this.convertImageToPDFDoc(file);
          },

          // doConvertToPDF: (file, isBlob = true, showSpin = true) =>
          //   new Promise((resolve, reject) =>
          //     convertController.doConvertToPDF(
          //       file,
          //       (result) => {
          //         if (result && result != 'stop' && result.ret == 0 && result.url) {
          //           try {
          //             getFileBufferByUrl(result.url, (blob) => resolve(new File([blob], file.name))).then();
          //           } catch (e) {
          //             reject(e);
          //           }
          //         }
          //       },
          //       reject,
          //       isBlob,
          //       showSpin,
          //     ),
          //   ),
          // doConvertScannedDocument: (option, callback) => {
          //   convertController.doConvertScannedDocument(option, callback);
          // }
        },
        // 更新dashboard次数，taskName: 参数名称
        updateTrialPermission: (taskName) => {
          store.accountStore.updateTrialPermission(taskName);
        },
        // alertable: 是否需要弹窗提示
        isDisableButton: (btnName, alertable = true) => {
          return this.isDisableButton(btnName, alertable);
        },
        onShowWarningMessage: (...props) => {
          return this.onShowWarningMessage(...props);
        },
        getSearchPreference: () => {
          return { ...store.docStore.searchPreference };
        },
        async showPageTransitionsDialog() {
          if (this.isDisableButton(SIDEBAR_THUMBNAIL_PAGE_TRANSITIONS)) {
            return;
          }
          const docInfo = await fileController.getDocInfo();

          me.setState(getRefDlgCfg(PageTransitionsDialog, me.pageTransitionsDialogRef));
          store.accountStore.updateTrialPermission(SIDEBAR_THUMBNAIL_PAGE_TRANSITIONS);
          console.log(docInfo);
          me.delayDialog('pageTransitionsDialogRef', 'showDialog', {
            docInfo,
          });
        },
        showRecordDialog() {
          me.setState(getRefDlgCfg(RecordDialog, me.recordDialogRef));
          me.delayDialog('recordDialogRef', showDialog);
        },
        confirmPasteFieldDialog(fieldTypeName, newFieldName) {
          me.setState(getRefDlgCfg(PasteFieldConfirmDialog, me.pasteFieldConfirmDialogRef));
          return me.pasteFieldConfirmDialogRef.current.confirm(fieldTypeName, newFieldName);
        },
        showESignCNPagingSealDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnPagingSeal,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showEsignCnShareOnlineDocDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnShareOnlineDocDialog,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showESignCNManageOutSealDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnManageOutSeals,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showEsignCnStamp4MultPagesDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnStamp4MultPages,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showESignCNOutStampManageDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnOutStampsPanel,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showEsignCnApplyOrgSealsDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnApplyOrgSeals,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showESignCNAuthPromotionDialog(opts) {
          me.setState({
            messageDlgCfg: {
              target: DLG_TARGETS.EsignCnAuthPromotion,
              toCache: true,
              config: {
                ...opts,
                close: () => {
                  me.setState({
                    messageDlgCfg: {},
                  });
                },
              },
            },
          });
        },
        showScannedEditing: () => {
          store.appStore.showScannedDocumentSetting();
        },
        isCNDomain: () => {
          return isCNDomain();
        },
        // 获取偏好设置窗口中的默认数据
        getPreferencesDefaultData: (name) => {
          return store.appStore.preferencesDefaultData[name];
        },
        getFileUrlByTransferStation: store.appStore.getFileUrlByTransferStation.bind(store.appStore),
        getVerifySignatureRule: store.appStore.getVerifySignatureRule.bind(store.appStore),
        getDefaultCompareOptions,
        getCompareResultStrings,
        getCompareTemplateDocs: store.docStore.getCompareTemplateDocs.bind(store.docStore),
        inTeamsApp: store.teamsAppStore.inTeamsApp,
        isCollaborationMode: () => {
          return store.appStore.currentMode === COLLABORATION_MODE;
        },
        guideToolTip: (name, toolTipMsg) => {
          store.userStore.guideToolTip(name, toolTipMsg);
        },
        toEsignDocList: () => {
          store.appStore.toEsignDocList();
        },
        loadUrlConfig: async () => {
          return await baseUrlApis.loadUrlConfig();
        },
        gotoSignPC: async (processId) => {
          return store.esignCnStore.gotoSignPC(processId);
        },
        requestFoxitSign: () => {
          this.onRequestFoxitSign();
        },
        // 打开combine窗口，可传初始文件
        showCombineDialog: (files) => {
          this.onClickViewerBtn({
            btnName: CONVERT_COMBINE_FILES,
            tabName: 'getting_started',
            result: {
              files: files || [],
            },
          });
        },
        sendCollabOp(data) {
          return false;
          collaborationService.sendCollabOp(data);
        },
        loading: this.onShowViewerLoading,
        checkAppSignIn: store.appStore.checkAppSignInForCustoms.bind(store.appStore),
        showNewDigitalID: (callback) => {
          this.showAddDigitalID(callback);
        },
        proxyComponent: (cmp) => {
          this.onProxyComponentHandle(cmp);
        },
        showBatchSignDialog: (setting, ap, type) => {
          this.setState({
            messageDlgCfg: {
              target: 'BatchSign',
              config: {
                action: 'add',
                type: 'sign',
                onOk: (files, outputOptions) => {
                  pdfui.callAddonAPI('SignDoc', 'signMultipleFiles', [setting, ap, files, outputOptions, type]).then(
                    (signResult) => {
                      this.setState({
                        messageDlgCfg: {
                          target: 'SignResultDialog',
                          config: {
                            signResult,
                            onOk: () => {
                              this.setState({ messageDlgCfg: {} });
                            },
                          },
                        },
                      });
                    },
                    (e) => {
                      this.setState({ messageDlgCfg: {} });
                      console.error(e);
                    },
                  );
                },
                onCancel: () => {
                  this.setState({ messageDlgCfg: {} });
                },
              },
            },
          });
        },
        localStorageUserMapUtils: () => ({
          getLocalStorageUserMapValue: getLocalStorageUserMapValue.bind(null, store.userStore.userId),
          setLocalStorageUserMapValue: setLocalStorageUserMapValue.bind(null, store.userStore.userId),
        }),
      },
      renderTo: renderTo, // the div (id="pdf-ui").
      appearance: UIExtension.appearances.adaptive,
      addons: addons,
      fragments: fragments,
      plugin: {
        externalPath: EXTERNAL_PATH,
      },
    };

    // set template in mobile
    if (template !== void 0) {
      options.template = template;
    }

    let pdfui = (this.pdfui = new UIExtension.PDFUI(options));
    store.appStore.doAddResourceBundle(pdfui);

    try {
      pdfui.getKeyboard().then((keyboard) => {
        keyboard.setup(getKeymap(UIExtension));
      });
      pdfui.setActionCallback(
        class {
          alertAsync(data) {
            pdfui.alert(data);
          }
        },
      );
    } catch (error) {
      console.log('===>>> ~ EditorContainer ~ doInitializePDFViewerUI ~ error', error);
    }
    fileController.initialize(pdfui);
    let Events = UIExtension.PDFViewCtrl.Events;

    this.doUIExtensionEventBinder(pdfui, Events, UIExtension, emitter);

    pdfui.setPencilDrawingTimeOut(0);

    // TODO FOXIT 添加一个jrsuccess后的回调
    pdfui.addViewerEventListener(Events.jrLicenseSuccess, () => {
      // store.pageOnloadStore.pageOnload()
      this.setState({
        isShowGlobalSpin: false,
      });
      // 如果登录 打开分享文件？
      if (hasSignIn) {
        console.log('这里开始分享文件打开');
        this.openShareFile();
      }
      this.onUpdateViewerByUserStatus(emitter);
    });
    window.pdfui = pdfui;

    clickFunc && clickFunc();

    if (store.viewer.pdfuiTask.resolve) {
      store.viewer.pdfuiTask.resolve(pdfui);
    }
    store.viewer.initialize(window.pdfui);
    // trust manager => viewer, doc author => viewer

    // cloud drive init
    this.onHideViewerComponents(PRIVATE_STORAGE_BTNS);

    if (isCNDomain()) {
      this.onHideViewerComponents(['help-tab-group-download-client']);
      const { isWindowsOS, isMacOS } = store.appStore;
      if (!isWindowsOS && !isMacOS) {
        this.onHideViewerComponents(['help-tab-group-download-client-cn']);
      }
    } else {
      this.onHideViewerComponents(['help-tab-group-download-client-cn']);
    }
    if (isOnPremiseDeployMode) {
      this.onDynamicDisplayPrivateDriveBtn();
    } else {
      this.onDynamicDisplayDriveBtn();
    }

    //
    this.onOpenFileByAi();
    // test
    this.doAutoOpenFileByUrl();
    this.onDynamicDisplayEduExclusiveBtn();
    this.doAutoOpenOnedriveFileByUrl();
    if (store.teamsAppStore.inTeamsApp && window.pdfui) {
      if (store.loginNewStore.isLogin) {
        store.teamsAppStore.openFileForTeamsApp();
      } else {
        //TODO FOIXT 替换sso登录弹框
        store.loginNewStore.login();
        //store.appStore.doUpdateSignInNotice({id:'Permission.SignIn'});
      }
    }

    this.onHideFloatBar();
    store.appStore.isShowFromTemplate();
    // ! 这里增加一个逻辑：云收集等第三方网站跳转云编辑直接打开文档
    if (window.pdfui) {
      store.pageOnloadStore.pageOnload();
    }

    // import("./devUtil").then(util => {
    //   util.doAutoOpenLocalFile(this.pdfui)
    // });
    if (isCNDomain()) {
      this.doAutoOpenPaperCheckResult();
    }
  }
  delayDialog(name, fn, ...param) {
    const showDialog = () => {
      if (this[name].current) {
        return this[name].current[fn](...param);
      }

      setTimeout(() => {
        showDialog();
      }, 50);
    };
    showDialog();
  }
  showAddDigitalID(callback, keep) {
    this.setState({
      messageDlgCfg: {
        target: 'AddDigitalID',
        config: {
          close: (name) => {
            if (keep) {
              this.setState({
                messageDlgCfg: {
                  target: DigitalIDsDialog,
                  config: {
                    visible: true,
                    changeVisible: () => this.setState({ messageDlgCfg: {} }),
                    showAdd: this.showAddDigitalID,
                  },
                },
              });
            } else this.setState({ messageDlgCfg: {} });
            callback(name);
          },
        },
      },
    });
  }
  onShowViewerComponents(list) {
    if (!this.pdfui) return;
    list.forEach((item) => {
      this.pdfui.getAllComponentsByName(item).then((list) => {
        list && list.forEach((component) => component && component.show());
      });
    });
  }
  onHideViewerComponents(list) {
    if (!this.pdfui) return;
    list.forEach((item) => {
      this.pdfui.getAllComponentsByName(item).then((list) => {
        list && list.forEach((component) => component && component.hide());
      });
    });
  }

  // 由于用户数据和EditorContainer组件是调整为并发请求，所以需要响应完成初始化检测的事件
  // 后续当前组件需要处理用户未登录的业务逻辑，请在此函数处理
  onFinishCheckUser = () => {
    const isShowTermBegin = () => {
      const { isEdu } = store.userStore;
      const duringActivityTime = () => {
        const startDate = new Date('2022-09-01 18:00:00');
        const endDate = new Date('2022-09-30 18:00:00');
        const nowDate = new Date();

        if (nowDate >= startDate && nowDate <= endDate) {
          return true;
        }
      };

      if (isEdu && isCNDomain() && duringActivityTime()) {
        this.setState({
          messageDlgCfg: {
            target: TermBegin,
            config: {
              onCancel: this.onCloseTermBeginDlg,
            },
          },
        });
      }
    };

    store.appStore.addAppEventListener(GET_IS_EDU_SUCCESS, () => {
      isShowTermBegin();
    });

    if (!store.loginNewStore.isLogin) {
      // for teams
      if (store.teamsAppStore.inTeamsApp) {
        this.doShowSignInDialog();
      }
      // for other
      return;
    }
  };
  onUpdateViewerByUserStatus(/*emitter*/) {
    // !加入协作
    const fn = () => {
      this.joinShare();
      const trustConfig = store.userStore.getTrustConfig();
      fileController.setTrustConfig(trustConfig);
      //
      //formHighlightColor config
      fileController.getPDFViewer().then((viewer) => {
        const { FieldsHightLight, HighlightrRequiredFields, isHighlight, /* isRunFormRecognition */ isAutoComplete, isRememberNumerical } =
          store.docStore.formPreference;
        viewer.highlightForm(isHighlight);
        viewer.setFormHighlightColor(colorToAARRGGBB(FieldsHightLight, 0.5), colorToAARRGGBB(HighlightrRequiredFields, 0.5));
        viewer.setLayoutGridByStorageSettings();
        viewer.setSnapGridByStorageSettings();
        viewer.setAutoCompleteSetting({ level: isAutoComplete, rememberNumericalData: isRememberNumerical });
      });
      //
      const hasSignIn = store.loginNewStore.isLogin;
      if (!hasSignIn) {
        return;
      }
      const userName = store.userNewStore.userData.nickname;
      // const userName = store.userStore.userName;
      //!设置全局用户名
      fileController.setDocAuthor(userName);
      // for teams app
      // if (store.teamsAppStore.inTeamsApp /* && window.pdfui */) {
      //   store.teamsAppStore.openFileForTeamsApp();
      // }
      // check for share file
      this.checkPermissionForShareFile();

      const tk_er = window.localStorage.getItem('tk_er');
      if (tk_er === '1') {
        store.accountStore.getSubscribeStateNow();
        window.localStorage.removeItem('tk_er');
      }
    };

    if (!window.location.href.includes('/cloudShare/')) {
      console.log('showLogin 2');
      const fileName = getQueryVariable('fileName');
      store.shareCollaborationStore.setCloudShareType('showLogin');
      store.shareCollaborationStore.shareInfo.fileName = fileName;
      console.log('no FW_USER_LOGIN_IN_SUCCESS');
    }

    // TODO FOXIT 云编辑逻辑，未登入无token不可阅读;
    if (store.loginNewStore.isLogin) {
      console.log('is login');
      fn();
    }
    store.appStore.addAppEventListener(FW_USER_LOGIN_IN_SUCCESS, () => {
      console.log('FW_USER_LOGIN_IN_SUCCESS');
      // fn()
    });
  }

  onDynamicDisplayEduExclusiveBtn = () => {
    if (!isCNDomain()) {
      this.pdfui.getAllComponentsByName(EDU_EXCLUSIVE).then((list) => {
        list &&
          list.forEach((component) => {
            if (component) {
              component.hide();
              component.parent.hide();
            }
          });
      });
    }
  };
  onDynamicDisplayFoxitSignBtn = () => {
    this.onShowViewerComponents([REQUEST_SIGNATURE]);
  };
  onDynamicDisplayDriveBtn = (/* emitter */) => {
    const getDrivesConfig = () => {
      if (!isCNDomain()) {
        this.onHideViewerComponents([OPEN_FILE_FROM_URL]);
        store.userStore.setInvisibleOpenSaveBtn([OPEN_FILE_FROM_URL]);
      }

      const enterpriseId = store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
      if (enterpriseId) {
        store.userStore.getDrivesConfig({
          enterprise_id: enterpriseId,
          success: (result) => {
            const { cloudOnlineLogo, cloudOnlineStorage, cloudOnlineName } = result.message;
            store.appStore.setAppInfo(cloudOnlineLogo, cloudOnlineName);
            store.appStore.setCloudOnlineStorage(cloudOnlineStorage);

            if (!isCNDomain()) {
              // button list to filter
              const list = calcCloudOnlineStorage(cloudOnlineStorage);
              this.onHideViewerComponents(list);
              store.userStore.setInvisibleOpenSaveBtn(list);
            }
          },
          fail: (/*res*/) => {},
        });
      }
    };

    if (store.userStore.hasSignIn) {
      getDrivesConfig();
    } else {
      store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, () => {
        getDrivesConfig();
        this.onShowFirstBlankContent();
      });
    }

    function calcCloudOnlineStorage(cloudOnlineStorage) {
      let count = 0;
      let result = [];

      if ((0x00000001 & cloudOnlineStorage) === 0) {
        // obj.LocalFile = false;
        result.push(OPEN_FILE_LOCAL, SAVE_TO_LOCAL);

        count++;
        // result.push('')
      }
      if ((0x00000002 & cloudOnlineStorage) === 0) {
        // obj.URLFile = false;
        result.push(OPEN_FILE_FROM_URL);

        count++;
      }
      if ((0x00000004 & cloudOnlineStorage) === 0) {
        // obj.Dropbox = false;
        result.push(OPEN_FILE_FROM_GOOGLE_DRIVE, SAVE_TO_GOOGLE_DRIVE);

        count++;
      }
      if ((0x00000008 & cloudOnlineStorage) === 0) {
        // obj.GoogleDrive = false;
        result.push(OPEN_FILE_FROM_ONE_DRIVE, SAVE_TO_ONE_DRIVE);

        count++;
      }
      if ((0x00000010 & cloudOnlineStorage) === 0) {
        // obj.OneDrive = false;
        result.push(OPEN_FILE_FROM_BOX, SAVE_TO_BOX);

        count++;
      }
      if ((0x00000020 & cloudOnlineStorage) === 0) {
        // obj.Box = false;
        result.push(OPEN_FILE_FROM_DROPBOX, SAVE_TO_DROPBOX);

        count++;
      }
      if ((0x00000040 & cloudOnlineStorage) === 0 || cloudOnlineStorage === -1) {
        result.push(OPEN_FILE_FROM_RECENT, OPEN_FILE_FROM_DOCUMENTS, SAVE_TO_FOXIT_STORAGE);

        count++;
      }

      if ((0x00000080 & cloudOnlineStorage) === 0) {
        result.push(OPEN_FILE_FROM_IMANAGE, SAVE_TO_IMANAGE);

        count++;
      }

      if (count === 8) {
        result.push('open-file-button-list');
        result.push('download-file-button');
      }
      if (count === 7 && result.indexOf(OPEN_FILE_FROM_URL) < 0) {
        result.push('download-file-button');
      }

      return result;
    }
  };
  onDynamicDisplayPrivateDriveBtn(/* emitter */) {
    const getStorageConfig = () => {
      // if (!store.userStore.hasSignIn) return;
      if (!store.loginNewStore.isLogin) return;
      store.privateDriveStore.getStorageList(() => {
        this.onShowViewerComponents(PRIVATE_STORAGE_BTNS);
      });
    };
    store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, getStorageConfig);
    store.appStore.addAppEventListener(APP_CONSTANTS.SDK_FINISH_INIT, getStorageConfig);
  }
  /*onSaveFileSucceedCallback() {
    store.appStore.doUpdateDocModified(false);
  }*/
  onCancelDriveModal() {
    this.setState({
      showDrives: false,
    });
  }
  // 统一处理登录的各种情况；
  foxitLogin() {
    // this.getUserInfo()
    const uuid = getQueryVariable('uuid');
    if (uuid && !isFirefox) {
      // 客户端登录，因为cookie直接写在foxitreader域下，不会同步foxitcloud域需要触发login已同步登录token
      store.loginNewStore.login();
    } else {
      this.getUserInfo();
    }
  }
  async getUserInfo() {
    const accessToken = getQueryVariable('accessToken'); // 云文档携带Token进行登录
    let validateCookieAccessToken, cloudToken, getCloudCookies, getReaderCookies;
    try {
      validateCookieAccessToken = await getValidateCookieAccessToken();
      if (validateCookieAccessToken.code !== 0) {
        getReaderCookies = await getReaderCookie();
        if (getReaderCookies.accessToken) {
          store.loginNewStore.saveIamToken(getReaderCookies.accessToken);
        } else {
          getCloudCookies = await getCloudCookie();
          if (getCloudCookies.accessToken) {
            store.loginNewStore.saveIamToken(getCloudCookies.accessToken);
          }
        }
      }
      cloudToken = validateCookieAccessToken.code === 0 && validateCookieAccessToken.data ? window.cloudCookies.accessToken : null;
    } catch (error) {
      cloudToken = null;
    }
    // const cloudToken
    let IAMToken =
      store.loginNewStore.IAMToken ||
      window.readerCookies.accessToken ||
      cloudToken ||
      sessionStorage.getItem('iamToken') ||
      cookies.get('accessToken') ||
      accessToken;
    console.log(IAMToken);
    // store.loginNewStore.IAMToken = IAMToken;
    console.log(cookies.get('accessToken'));
    console.log('初始化的getUserInfo');
    // 是否登录，然后cookie被清除了
    // const isLoginAfterClearCookie = store.loginNewStore.IAMToken && store.loginNewStore.IAMToken !== cookies.get('iamToken');
    // store.loginNewStore.setIsLoginAfterClearCookie(isLoginAfterClearCookie);
    if (isMobile) {
      // 手机端登录存在问题，手机端需要从缓存中获取iamCode，换取token后执行
      let iamCode = localStorage.getItem('iamCode');
      if (iamCode) {
        store.loginNewStore.getIAMToken(iamCode).then(() => {
          store.userNewStore.getUserNew();
          localStorage.removeItem('iamCode');
        });
      } else if (IAMToken) {
        store.userNewStore.getUserNew();
      } else if (!IAMToken) {
        store.loginNewStore.login();
      }
      return;
    }
    // 不自動彈窗
    // if (!IAMToken) {
    //   store.loginNewStore.login();
    //   // store.userNewStore.userInfo();
    // }
    if (IAMToken) {
      store.loginNewStore.saveIamToken(IAMToken);
      store.userNewStore.getUserNew();
    }
    if (window.readerCookies && window.readerCookies.fid) {
      store.userNewStore.getUserNew();
    }
  }
  // TODO FOXIT 手机端操作页码
  async scrollPage() {
    // let pdfUiEle = document.getElementById("pdf-ui");
    // let pdfview = document.getElementsByClassName("fv__pdf-viewer")[0];
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    let pageCurrentIndex = fileController.getCurrentPageIndex() + 1;
    if (this.state.goMobilePageIndex) {
      pageCurrentIndex = this.state.goMobilePageIndex;
      this.setState({
        goMobilePageIndex: '',
      });
    }
    this.setState({
      pageCurrentIndex: pageCurrentIndex,
      pageAllIndex: pdfDoc.getPageCount(),
    });
    let ticking = false;
    let that = this;
    function onScroll() {
      if (!ticking) {
        that.setState({
          pageScroll: true,
          pageCurrentIndex: fileController.getCurrentPageIndex() + 1,
          // showMobileFooter: false
        });
        clearTimeout(setTime);
        window.requestAnimationFrame(realFunc);
        ticking = true;
      }
    }
    function setTime() {
      setTimeout(() => {
        that.setState({
          pageScroll: false,
          // showMobileFooter: true
        });
      }, 2500);
    }
    function realFunc() {
      setTimeout(() => {
        ticking = false;
        setTime();
      }, 500);
    }
    let view = document.getElementsByClassName('fv__ui-pdfviewer')[0];
    view.addEventListener('scroll', onScroll, false);
  }
  setStatePageCurrentIndex = (val) => {
    this.setState({
      pageCurrentIndex: val,
      goMobilePageIndex: val,
    });
  };
  onGoToHomePage = async () => {
    const floatBar = await pdfui.getComponentByName('float-bar');
    floatBar && floatBar.hide();

    const pageNumberBar = await pdfui.getComponentByName(FLOAT_PAGE_NUMBER);
    pageNumberBar && pageNumberBar.hide();

    const sidebar = await pdfui.getComponentByName('sidebar');
    sidebar && sidebar.collapse();
  };
  hideComponentsByDashboard = () => {
    const features = store.accountStore.getComponentsToHide();
    if (!features || !features[0]) {
      return;
    }

    this.onHideViewerComponents(features);
  };
  hasUserNotify = () => {
    const { isPopNotifyMessageDlg } = this.state;
    const isUS = isPdfOnlineDomain();
    const hasTermsChangeNotify = store.userStore.getTermsChangeNotify();
    const reviewSessionID = getQueryVariable('reviewSessionID');
    if (isUS && hasTermsChangeNotify == 1 && !reviewSessionID && !isPopNotifyMessageDlg) {
      this.onShowNotifyMessage(this.notifyMessageCallback, { message: 'Home.Sider.TermsUpdateNotice', title: 'PhantomPDF.Online', ok: 'Ok' }, true);
    } else {
      this.isFirstTrial();
    }
  };
  doEnableDeleteForSharePointOpenFile = async () => {
    const { isFromSharePoint, action } = store.appStore.sharePointInfo;

    if (isFromSharePoint === true && action === 'open') {
      const deleteBtnSidebar = await pdfui.getComponentByName('delete-comment-menu');
      const deleteBtnContextMenu = await pdfui.getComponentByName('fv--contextmenu-item-delete-annot');

      deleteBtnSidebar && deleteBtnSidebar.doEnable();
      deleteBtnContextMenu && deleteBtnContextMenu.doEnable();
    }
  };
  onShowNotifyMessage = (callback, { message, title, ok }, noClose) => {
    const privacyPolicyLink = getPrivacyPolicyUrl();
    const termsLink = getTermsOfServiceUrl();
    const notifyMessageDlgCfg = Object.assign({ visible: true }, this.state.notifyMessageDlgCfg, {
      msg: { id: message, title, ok, privacyPolicyLink, termsLink },
      onOk: () => {
        callback && callback();
        this.onCloseModalDlg();
        return true;
      },
      onClose: !noClose
        ? () => {
            callback && callback();
            this.onCloseModalDlg();
            return false;
          }
        : void 0,
    });

    this.setState({
      messageDlgCfg: {
        target: TermsChangeMessageDialog,
        config: notifyMessageDlgCfg,
      },
    });
  };

  notifyMessageCallback = () => {
    this.termsChangeNotify();
    this.isFirstTrial();
  };
  termsChangeNotify() {
    store.userStore.doUpdateUserNotify({ userNotifyType: 1, userNotifyStatus: 1 });
    this.setState({
      isPopNotifyMessageDlg: true,
    });
  }

  isFirstTrial = () => {
    const { isFirstTrial, isTrial, subscribeInfo, isDashboardTrial } = store.accountStore;
    const { isEnterpriseUser } = store.userStore;
    if (isDashboardTrial || isEnterpriseUser) {
      return;
    }
    if (isDTRuntime) return;
    if (!isCNDomain() && !isJPDomain()) return;
    if (isFirstTrial && isTrial) {
      let remain_days = isCNDomain() ? '30' : '5';
      if (subscribeInfo && subscribeInfo.remain_days) remain_days = subscribeInfo.remain_days;
      if (store.teamsAppStore.inTeamsApp) {
        this.onShowRobationMessage(
          this.messageCallback,
          {
            message: 'Home.Sider.trial5Day',
            messageParams: { dayNum: remain_days },
            title: 'PhantomPDF.Online.TitleWithOnline',
            ok: 'Home.Sider.Purchase',
            cancel: 'Close',
            subLink: true,
            noConfirm: true,
          },
          false,
        );
      } else {
        this.onShowRobationMessage(
          this.messageCallback,
          {
            message: 'Home.Sider.trial5Day',
            messageParams: { dayNum: remain_days },
            title: 'PhantomPDF.Online.TitleWithOnline',
            ok: 'Home.Sider.Purchase',
            cancel: 'Ok',
          },
          true,
        );
      }
    }
  };

  messageCallback = (isOk) => {
    if (isOk) {
      this.onSubscribe();
    } else {
    }
  };
  onSubscribe() {
    if (isJPDomain() || isCNDomain()) {
      store.userStore.setSubscribeVisible(true);
    } else {
      this.pdfui.eventEmitter.emit('need-pay-event');
    }
    store.userStore.doSendGAEventByUser({ eventKey: SUBSCRIBE, label: 'upper_right_area' });
  }
  onShowRobationMessage = (callback, { message, messageParams, title, ok, cancel, closable /* , checkbox */ }, noClose) => {
    const robationMessageDlgCfg = Object.assign({ visible: true }, this.state.robationMessageDlgCfg, {
      msg: { iconType: 'warning', id: message, messageParams, title, ok, cancel, closable },
      onOk: (state) => {
        callback && callback(true, state);
        this.onCloseModalDlg();
        return true;
      },
      onClose: !noClose
        ? () => {
            callback && callback(false);
            this.onCloseModalDlg();
            return false;
          }
        : void 0,
    });

    this.setState({
      messageDlgCfg: {
        target: MessageDialog,
        config: robationMessageDlgCfg,
      },
    });
  };
  checkPermissionForShareFile() {
    if (!isCollabURL()) return;

    pdfui.getComponentByName('collaboration-toolbar').then((toolbar) => {
      if (!toolbar) return;
      const undoRedoGroup = toolbar.getComponentByName('collaboration-toolbar-group-undo-redo');
      undoRedoGroup && undoRedoGroup.hide();
      toolbar.show();
    });

    const { isExpired } = store.accountStore;

    if (store.appStore.isDisableButton(OPEN_FILE_LOCAL)) {
      //验证权限
      return true;
    }
    if (isExpired) {
      this.showSubscirbeForExpired(isExpired);
      return true;
    }
  }
  // TODO FOXIT 用户通过链接打开协同文件
  async openShareFile(emitter) {
    console.log('多次触发？');
    const reviewSessionID = getQueryVariable('reviewSessionID');
    const fileLink = getQueryVariable('docUrl');
    const fileName = getQueryVariable('fileName');

    if (!(reviewSessionID && fileLink && fileName)) {
      return;
    }

    store.appStore.sendPerformanceInfo({ event: APP_CONSTANTS.COLLABORATION_OPEN_START, isEmit: false, lastEvent: true, fileName: true });

    store.appStore.updateProgressingInfo(true);

    // const fullyFeature=()=>{
    //   this.initFullRibbon(false)
    //   .then(()=>{
    //     store.appStore.backToHomeStart();
    //   })
    // }

    store.collaborationStore.setReviewSessionID(reviewSessionID);
    store.collaborationStore
      .getShareReview({ reviewSessionID, getMore: 1 })
      .then(async (res) => {
        do {
          if (res.ret === 0) {
            const docId = res.data[0].cDocID;
            const delFlag = res.data[0].delFlag;
            const shareState = res.data[0].shareState;
            const cUserID = res.data[0].cUserID;
            const sendData = {
              docId,
              docName: fileName,
              fileLink: fileLink,
              reviewSessionID: reviewSessionID,
            };
            if (store.userNewStore.userData.userId !== cUserID - 0) {
              console.log('别人分享的');
              store.shareCollaborationStore.setIsOpenOtherShare(true);
            } else {
              console.log('自己分享的');
              store.shareCollaborationStore.setIsOpenOtherShare(false);
            }
            if (docId) {
              store.collaborationStore.setThisCDocId(docId);
            }
            store.collaborationStore.setShareReviewData(res.data[0]);
            if (delFlag == 1) {
              // store.appStore.onShowWarningMessage(() => {
              //   window.history.pushState('', '', '/')
              //   store.appStore.backToHomeStart();
              // },
              //   { message: 'CollaborationOnline.Dlg.deleteShareFile', title: 'PhantomPDF.Online.TitleWithOnline' },
              //   true,
              // );
              store.appStore.updateShowShareErrorMask(true);
              break;
            } else if (shareState == 1) {
              // store.appStore.onShowWarningMessage(() => {
              //   window.history.pushState('', '', '/')
              //   fullyFeature()
              // }, { message: "collaboration.Dlg.stopShare", title: "PhantomPDF.Online.TitleWithOnline" }, true)
              // const { onShowToSaveBeforeOpen } = store.appStore;
              // onShowToSaveBeforeOpen((isToSave) => {
              //   if(!isToSave){
              //     fullyFeature()
              //   }
              // });
              store.appStore.updateShowShareErrorMask(true);
              break;
            } else {
              isShowGlobalSpin = true;

              if (!store.userStore.hasSignIn) {
                emitter.on(USER_SIGN_IN_SUCCESS, () => {
                  store.collaborationStore.confirmInvitation(reviewSessionID);
                });
              }
              console.log('触发分享打开');
              store.collaborationStore.openSharedFile(sendData);
            }
          } else if (res.ret === 110007) {
            //   store.appStore.onShowWarningMessage(() => {
            //     window.history.pushState('', '', '/')
            //     store.appStore.backToHomeStart();
            //     }, { message: 'CollaborationOnline.Dlg.deleteShareFile', title: 'PhantomPDF.Online.TitleWithOnline' },
            //     true,
            //   );
            store.appStore.updateShowShareErrorMask(true);
            break;
          }
        } while (false);
        if (!isShowGlobalSpin) {
          this.setState({
            isShowGlobalSpin: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          isShowGlobalSpin: false,
        });
      });
  }

  joinShare() {
    console.log('joinShare 多次？');
    const reviewSessionID = getQueryVariable('reviewSessionID');
    const fileLink = getQueryVariable('docUrl');
    const fileName = getQueryVariable('fileName');
    if (!(reviewSessionID && fileLink && fileName)) {
      return;
    }
    this.setState({
      isShowGlobalSpin: true,
    });
    store.collaborationStore.setReviewSessionID(reviewSessionID);
    store.collaborationStore
      .getShareReview({ reviewSessionID, getMore: 1 })
      .then((res) => {
        // let isShowGlobalSpin = false;
        do {
          if (res.ret === 0) {
            const docId = res.data[0].cDocID;
            const delFlag = res.data[0].delFlag;
            const shareState = res.data[0].shareState;
            const sendData = {
              docId,
              docName: fileName,
              fileLink: fileLink,
              reviewSessionID: reviewSessionID,
            };
            if (docId) {
              store.collaborationStore.setThisCDocId(docId);
            }
            if (delFlag == 1) {
              store.appStore.onShowWarningMessage(
                () => {
                  window.history.pushState('', '', '/');
                },
                { message: 'CollaborationOnline.Dlg.deleteShareFile', title: 'PhantomPDF.Online.TitleWithOnline' },
                true,
              );
              break;
            } else if (shareState == 1) {
              store.appStore.onShowWarningMessage(
                () => {
                  window.history.pushState('', '', '/');
                },
                { message: 'collaboration.Dlg.stopShare', title: 'PhantomPDF.Online.TitleWithOnline' },
                true,
              );
              const { onShowToSaveBeforeOpen } = store.appStore;
              onShowToSaveBeforeOpen((isToSave) => {
                !isToSave && store.appStore.backToHomeStart();
              });
              // window.pdfui.pdfViewer.close()
              break;
            } else {
              store.collaborationStore.openSharedFile(sendData);
            }
          } else if (res.ret === 110007) {
            store.appStore.onShowWarningMessage(
              () => {
                window.history.pushState('', '', '/');
                store.appStore.backToHomeStart();
              },
              { message: 'CollaborationOnline.Dlg.deleteShareFile', title: 'PhantomPDF.Online.TitleWithOnline' },
              true,
            );
            break;
          }
          this.setState({
            isShowGlobalSpin: false,
          });
        } while (false);
      })
      .catch(() => {
        store.appStore.updateProgressingInfo(false);
      });
  }
  onClosePluginCommonDialog(isCancel) {
    store.pluginStore.pluginCommonDialog.isShowPluginCommonDialog = !isCancel;
  }
  onCloseOpenFilePanel(isCancel) {
    const isDownloadingFileGoogleDrive = store.driveStore.isDownloadFilePending(GOOGLE_DRIVE);
    const isDownloadingFileOneDrive = store.driveStore.isDownloadFilePending(ONE_DRIVE);
    const isDownloadingFileBox = store.driveStore.isDownloadFilePending(BOX);
    const isDownloadingFileDropBox = store.driveStore.isDownloadFilePending(DROP_BOX);
    const openFilePending = intl.formatMessage({ id: 'OpenFilePending' });
    const abandonOpenFile = intl.formatMessage({ id: 'AbandonOpenFile' });

    if (isDownloadingFileGoogleDrive || isDownloadingFileOneDrive || isDownloadingFileBox || isDownloadingFileDropBox) {
      Modal.confirm({
        title: openFilePending,
        content: abandonOpenFile,
        okText: intl.formatMessage({ id: 'Yes' }),
        cancelText: intl.formatMessage({ id: 'No' }),
        onOk: () => {
          store.driveStore.doCancelOpenFileRequest(GOOGLE_DRIVE);
          store.driveStore.doCancelOpenFileRequest(ONE_DRIVE);
          store.driveStore.doCancelOpenFileRequest(BOX);
          store.driveStore.doCancelOpenFileRequest(DROP_BOX);
          store.appStore.hideOpenFileDlg();
          isCancel &&
            this.setState({
              isOpenFileForShare: false,
            });
        },
      });
    } else {
      store.appStore.hideOpenFileDlg();
      isCancel &&
        this.setState({
          isOpenFileForShare: false,
        });
    }
  }
  onCloseSaveFilePanel = () => {
    return this.fileTabRef.current.wrappedInstance.onCloseSaveFilePanel();
  };

  changeHomeSideTab = (tab) => {
    if (tab === 'share-list') {
      const hasSignIn = store.loginNewStore.isLogin;
      if (!hasSignIn) {
        store.loginNewStore.login();
        return false;
      }
    }
    store.homePageStore.setHomeSideTabActive(tab);
  };
  onDropFileOnViewer = (acceptedFiles) => {
    let file = acceptedFiles[0];

    if (!file) {
      return;
    }

    const mimeType = file.type;
    const { hasTask } = store.taskStore;

    store.docStore.setDocDriveName('');
    store.collaborationStore.resetCollaborationData();

    if (this.isDisableButton(OPEN_FILE_LOCAL) || hasTask || !file) {
      return;
    }

    const isPossiblePDF = mimeType == 'application/pdf' || mimeType == '';
    if (!isPossiblePDF) {
      if (this.isDisableButton(CONVERT_FILES_TO_PDF)) {
        return;
      }
    }

    const fn = () => {
      console.log('测试：转换5');
      if (isPossiblePDF) {
        // store.appStore.setCommonMode()
        store.viewer.doOpenFile(file, (isLoading) => {
          isLoading && this.doShowEditorLoading();
        });
      } else {
        //need Convert
        const params = {
          btnName: CONVERT_FILES_TO_PDF,
          result: file,
          tabName: 'getting_started',
          isFilterGaEvent: true,
        };
        this.onClickViewerBtn(params);
      }

      useIdleCallback(() => {
        store.appStore.showLoadingWithMsg({ show: true, msg: 'Loading.file' });
        store.appStore.setCommonMode(() => {
          store.appStore.showLoading(false);
        });
        store.userStore.doSendGAEvent({ eventKey: DRAG_FILE_TO_OPEN, label: 'getting_started' });
      });
    };
    let clickFunc = () => {
      if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
        fn();
        return;
      }
      this.onShowToSaveBeforeOpen((isToSave) => {
        !isToSave && store.appStore.doUpdateDocModified(false);
        // is true, do not open new file
        !isToSave && fn();
      });
    };
    if (!window.pdfui) {
      this.doInitializePDFViewerUI(window._UIExtension, clickFunc);
    } else {
      console.log('clickFunc begin');
      clickFunc();
    }
  };
  onDropFileOnViewerToH5AndroidWechatOrQQ = (acceptedFiles) => {
    let file = acceptedFiles[0];
    const { hasTask } = store.taskStore;
    if (this.isDisableButton(OPEN_FILE_LOCAL) || hasTask || !file) {
      return;
    }
    let fileName = file.name;
    let docType = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

    if (docType !== 'pdf') {
      if (this.isDisableButton(CONVERT_FILES_TO_PDF)) {
        return;
      }
      let bSupportSuffix = false;
      let docTypeStr = '.' + docType;
      let suffixArr = CONVERT_MAP.supportDocumentSuffixs.split(',');
      for (let i = 0; i < suffixArr.length; i++) {
        let curDocType = suffixArr[i];
        if (curDocType === docTypeStr) {
          bSupportSuffix = true;
          break;
        }
      }
      if (!bSupportSuffix) {
        store.taskStore.setTaskMessage({ info: 'NotSupportedFormat', type: 'error', failed: true }, 5000);
        return;
      }
    }

    const fn = () => {
      if (docType === 'pdf') {
        store.viewer.doOpenFile(file, (isLoading) => {
          isLoading && this.doShowEditorLoading();
        });
      } else {
        const params = {
          btnName: CONVERT_FILES_TO_PDF,
          result: file,
          tabName: 'getting_started',
          isFilterGaEvent: true,
        };
        this.onClickViewerBtn(params);
      }
      store.userStore.doSendGAEvent({ eventKey: DRAG_FILE_TO_OPEN, label: 'getting_started' });
    };
    if (store.appStore.docModified) {
      this.onShowToSaveBeforeOpen((isToSave) => {
        !isToSave && store.appStore.doUpdateDocModified(false);
        // is true, do not open new file
        !isToSave && fn();
      });
    } else {
      fn();
    }
  };
  //!是否禁用拖拽打开文件
  onIsDisabledDragFileOpenForGetStartGuid = () => {
    //return !store.userStore.hasSignIn && !isJPDomain();
    //TODO FOXIT 使用isLogin替换hasSignIn
    return !store.loginNewStore.isLogin && !isJPDomain();
  };
  //!福软业务
  onShowFirstBlankContent = () => {
    const from = getQueryVariable('source');
    const hasSignIn = store.loginNewStore.isLogin;
    if ((from === 'online' || from === 'phantompdf') && !hasSignIn) {
      store.userStore.doShowWelcomeDlg();

      return false;
    } else {
      store.userStore.doHideWelcomeDlg();

      return true;
    }
  };

  autoUploadFileForMSTeams = async (fileName) => {
    const currentPDFBlob = await this.getCurrentPDFBlob({ fileName });
    const siteId = getQueryVariable('siteId');
    const fileId = getQueryVariable('fileId');
    if (currentPDFBlob.size > 1024 * 1024 * TEAMS_UPLOAD_FILE_SIZE_LIMIT) {
      message.error(intl.formatMessage({ id: 'FileOverSize' }));

      return;
    }

    this.numberOfAjaxCAllPendingIncrease();

    await oneDriveApi.createFileWithUploadSessionForMSTeams(
      currentPDFBlob,
      fileId,
      siteId,
      () => {
        this.props.saveSucceedCallback && this.props.saveSucceedCallback();
        this.numberOfAjaxCAllPendingDecrease();
        store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'UploadingFile.success' }) });
      },
      (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
        store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'UploadingFile.fail' }) });
      },
    );
  };
  //! 打开远程文档
  openUrlFile = (url, fileName) => {
    let openUrl = url || this.state.openURL;
    // // TODO FOXIT 此处处理一个逻辑因为只有经过转换pdf接口后的文件才会携带url，fileName参数，home页打开远程文档的时候
    // if(!url && this.state.openURL) {

    // }
    let clickFunc = () => {
      store.openUrlFileStore.openUrlFile(openUrl, fileName);
      this.setState({
        showURLInputDialogLoading: false,
      });
    };
    if (!window.pdfui) {
      this.setState({
        showURLInputDialogLoading: true,
      });
      this.doInitializePDFViewerUI(window._UIExtension, clickFunc);
    } else {
      clickFunc();
    }
  };
  getUrl = (val) => {
    this.setState({ openURL: val.target.value });
  };
  showRecoginizeTextDialog = () => {
    // window.open('https://file.foxitreader.cn/file/Channel/foxityunbangongweb/ybgbyb4_FoxitCloud_Full.exe')
    this.onShowConvertDlg('ocr-pdf-to-pdf');
    // const isEditingDisable = store.appStore.isDisableButton(EDIT_TEXT);
    // !isEditingDisable && this.setState({messageDlgCfg:{
    //     target:RecoginizeText,
    //     config:{onCancel:this.onCloseModalDlg}
    // }});
  };
  closeClient = () => {
    //close client exe
    const fileUrl = getQueryVariable('fileurl');
    const serviceMode = getQueryVariable('service_mode');
    const filePath = getQueryVariable('filepath');
    if (serviceMode == 'client' && fileUrl.search('http://localhost') != -1) {
      window.history.pushState('', '', '/');
      if (!filePath) {
        //旧版本exe
        clientApi.close();
      }
    }
  };
  onCancelFoxitSign = () => {
    store.foxitSignStore.onCancelFoxitSign();
  };
  isShowSpinning = () => {
    const isInMobile = isMobile;
    const { isShowGlobalSpin } = this.state;
    console.log('isShowGlobalSpin');
    console.log(isShowGlobalSpin);
    return isShowGlobalSpin || (!!isInMobile && !this.pdfui);
  };
  getLoadingTip() {
    return intl.formatMessage({ id: 'Initialize' });
  }
  updateIsOpenFileForShare(value) {
    this.setState({
      isOpenFileForShare: value,
    });
  }
  render() {
    const hasSignIn = store.loginNewStore.isLogin;
    const { isShowMeeting } = store.common;
    const { isShowCollaborationSignIn } = store.collaborationStore;
    const { showURLInputDialog, showURLFailDialog } = store.openUrlFileStore;
    // const { foxitSignVisibleModal, foxitSignRemindDetail } = store.foxitSignStore
    const { isShowHomeStart, isShowCollaborationViewerDom, isShowShareErrorMask } = store.appStore;
    const { isEdu } = store.userStore;
    const { hasTask } = store.taskStore;
    const {
      messageDlgCfg,
      layer2Msg,
      // loadingSDK,
      showEsignChinaGalleryTool,
      isShowMessageCenter,
      messageCenterConfig,
      isInitSignatureListContainer,
      isShowSignatureListContainer,
      signatureListContainerDomInWebSdk,
      showColorPicker,
      isOpenFileForShare,
    } = this.state;
    let { hasOpenFile } = store.viewer;

    let viewerCls = !hasTask ? 'fo__viewer-container' : 'fo__viewer-container disable-convert';
    let height = `${window.innerHeight - getContainerHeight()}px`;

    let isInMobile = isMobile;
    const { inTeamsApp } = store.teamsAppStore;
    //1. isWaitSDK is true, will add 'disable' in Home
    const containerCallbacks = this;
    const fileTabProps = {
      ref: this.fileTabRef,
      containerCallbacks,
      onClickCallback: () => (this.driveName = ''),
      isOpenFileForShare,
      updateIsOpenFileForShare: this.updateIsOpenFileForShare,
    };

    // TODO FOXIT 云编辑相关参数
    const { showDialog, showSaveDialog, isShowFwDocsIframe, isShowFwDocs } = store.saveFileNewStore;
    const { abnormalAccount } = store.userNewStore;
    const { isShowOpenMember, isShowNoPdfDialog, isShowLoginLoseDialog, isLoginLoseDialog } = store.common;
    const { isShowFwConvertModal, isShowFwConvertImgType } = store.convert;
    //indicator={<Icon type="loading-3-quarters" style={{ fontSize: 32 }} spin />}
    let { pageScroll, showMobileFooter, pageCurrentIndex, pageAllIndex } = this.state;
    const { showUseEncryption, toolDisabled, pdfaEditable, handleActive } = store.fwMobileToolStore;
    const { showMobileDocs } = store.docsStore;
    const { cloudShareStart } = store.shareCollaborationStore;
    const { isShowGuide, isShowSaveSuccess } = store.office;
    const { advertDialog } = store.advertStore;
    const DialogCfg = dialogBuilder(this);
    let finalCfg = messageDlgCfg.target ? messageDlgCfg : DialogCfg;
    if (finalCfg) {
      finalCfg.spinning = false;
    }

    const { isShowCustomerServiceDlg } = this.state;

    return (
      // <Spin spinning={this.isShowSpinning()} tip={this.getLoadingTip()} size="large" wrapperClassName='in-center'>
      <Spin spinning={isShowMeeting || this.isShowSpinning()} tip={''} size="large">
        {/* {isShowTermBegin && wrapDialog(<TermBegin onCancel={this.onCloseTermBeginDlg}/>)} */}
        {isShowCollaborationViewerDom && <CollaborationViewerDom />}
        {/* <Spin spinning={isLoadingUserAccount|| isShowGlobalSpin || (isInMobile && !pdfui) || isShowMeeting} tip={''} size="large" ></Spin> */}
        <div className={viewerCls} style={{ height: `${isInMobile ? 'auto' : height}` }}>
          {/* TODO FOXIT 为mobile 格式重新构建主体 */}
          {isInMobile && (
            <Suspense fallback={<div className={!showMobileFooter ? 'notShowMobileFooter fwMobileEditorContainer' : 'fwMobileEditorContainer'}></div>}>
              <div className={!showMobileFooter ? 'notShowMobileFooter fwMobileEditorContainer' : 'fwMobileEditorContainer'}>
                <FwMobileHead showUseEncryption={showUseEncryption} handleActive={handleActive} />
                <section>
                  {!hasOpenFile && <FwMobileHomeBox openFile={this.doOpenFileFromGetStartGuid} />}
                  <div
                    ref={this.viewerRef}
                    id="pdf-ui"
                    onClick={(ev) => {
                      ev.stopPropagation();
                    }}></div>
                  {
                    <FwMobilePageDialog
                      pageScroll={pageScroll}
                      pageCurrentIndex={pageCurrentIndex}
                      pageAllIndex={pageAllIndex}
                      setStatePageCurrentIndex={this.setStatePageCurrentIndex}
                    />
                  }
                  {showMobileDocs && <FwMobileDocs popupVisible={showMobileDocs} />}
                </section>
                {
                  <FwMobileFooter
                    showMobileFooter={showMobileFooter}
                    toolDisabled={toolDisabled && !pdfaEditable}
                    openLocalFile={this.doOpenFileFromGetStartGuid}
                    openDocs={this.doOpenDocs}
                  />
                }
              </div>
            </Suspense>
          )}
          {!isInMobile && (
            <Dropzone
              onDrop={this.onDropFileOnViewer}
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              noKeyboard={true}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps({ multiple: false })} />
                    {/* !03.16 online将pdf-ui 改为 pdfUIContainer   */}
                    {/* <div ref={this.viewerRef} id="pdf-ui" onClick={(ev)=>{ev.stopPropagation()}} style={{height: isMobile ? '100vh' : `${window.innerHeight - getContainerHeight()}px`}}> */}
                    <div
                      className={isShowHomeStart ? 'homeStartpdfUI' : ''}
                      ref={this.viewerRef}
                      id="pdfUIContainer"
                      onClick={(ev) => {
                        ev.stopPropagation();
                      }}
                      style={{ height: isMobile ? '100vh' : `${window.innerHeight - getContainerHeight()}px` }}></div>
                  </div>
                </section>
              )}
            </Dropzone>
          )}

          <FileTab {...fileTabProps} />
          <ConvertTab ref={this.convertTabRef} containerCallbacks={containerCallbacks} />
          <OrganizeTab containerCallbacks={containerCallbacks} />
          <ProtectTab ref={this.protectTabRef} containerCallbacks={containerCallbacks} showAdd={this.showAddDigitalID} />
          <EditTab containerCallbacks={containerCallbacks} />
          {isCNDomain() && <PaperCheckContainer containerCallbacks={containerCallbacks} />}
          {<DialogContainer {...finalCfg} />}
          {<DialogContainer {...layer2Msg} />}

          {!!store.pluginStore.pluginCommonDialog.isShowPluginCommonDialog && (
            <PluginCommonDialog
              width={store.pluginStore.pluginCommonDialog.width}
              title={store.pluginStore.pluginCommonDialog.title}
              url={store.pluginStore.pluginCommonDialog.url}
              onCancel={this.onClosePluginCommonDialog.bind(this, true)}></PluginCommonDialog>
          )}
          {!!isInMobile && (!!isPdfOnlineDomain() || !!isCommonFeatureDomain()) && (
            <FloatBall onClick={this.onClickViewerBtn.bind(this, { btnName: FEEDBACK, tabName: 'help-tab' })} />
          )}
          <Welcome />
          {this.onIsShowBottomAd(isEdu) && <BottomAd onClose={this.onCloseBottomAd} />}
          {/* {!!isShowDownloadedTipsForChrome && wrapDialog(<DownloadedTipsForChrome onClose={this.onCloseDownloadedTipsForChrome}/>)}
                {isShowShareDialog && wrapDialog(<ShareDlg visible={isShowShareDialog} />)} */}
          {/* 云编辑的办公成员协同分享功能 */}
          {cloudShareStart && !isShowHomeStart && <CloudShare></CloudShare>}
          {/* 原登录 */}
          {!hasSignIn && isShowCollaborationSignIn && <CloudShare></CloudShare>}
          {advertDialog && !abnormalAccount && <AdvertDialog />}
          {isShowHomeStart && !cloudShareStart && !(!hasSignIn && isShowCollaborationSignIn) && (
            <HomePage
              height={`${isInMobile ? 'auto' : height}`}
              supportConvertDocumentSuffixs={CONVERT_MAP.supportDocumentSuffixs}
              onDrop={this.onDropFileOnViewer}
              changeHomeSideTab={this.changeHomeSideTab}
              openFile={this.doOpenFileFromGetStartGuid}
              hasSignIn={store.loginNewStore.isLogin}
              openDocs={this.doOpenDocs}
              isDisableButton={this.isDisableButton}
            />
          )}
          {isShowShareErrorMask && <ShareErrorMask />}
          {isShowFwDocsIframe && <FwDocsIframe closeDocs={this.doCloseDocs} doInitializePDFViewerUI={this.doInitializePDFViewerUI} />}
          {isShowFwDocs && <FwDocs />}
          {isShowSaveSuccess && <FwRegisterSaveSuccess />}
          {/* {isShowOpenMember && <FwOpenMemberModal/>} */}
          {!!isShowOpenMember && <SubscriptionMember iconType="warning" visible={isShowOpenMember} />}
          {isShowFwConvertModal && <FwConvertModal openUrl={this.openUrlFile} />}
          {isShowFwConvertImgType && <FwConvertImgType />}
          {/* {store.loginNewStore.isShowIframeSso && <FwLogin />} */}
          {/* {!!isShowNotifyMessageDlg && wrapDialog(<TermsChangeMessageDialog {...notifyMessageDlgCfg} visible={isShowNotifyMessageDlg} />)} */}
          {/* {ScannedDocumentSetting.visible &&wrapDialog(<ScannedEditingSetting visible={ScannedDocumentSetting.visible}/>)} */}
          {/* {isShowRecoginizeText && wrapDialog(<RecoginizeText onCancel={()=>this.setState({isShowRecoginizeText: false})}/>)} */}
          {/* {isShowFoxitPlugInsDlg && wrapDialog(<FoxitPlugIns onCancel={this.onCancelFoxitPlugInsDlg}/>)} */}
          {!!isShowMessageCenter &&
            wrapDialog(
              <MessageCenter
                {...messageCenterConfig}
                doNotShowAgainChange={this.doNotShowAgainChange}
                showMessageCenterDlgCallback={this.showMessageCenterDlgCallback}
              />,
            )}
          {/* {!!isShowCompareResult && wrapDialog(<CompareResult {...compareResultConfig } />)} */}
          {isShowGuide && !isShowHomeStart && (
            <div className="guide">
              <div className="mask"></div>
              <img src={require('../../assets/fw_office/guide.png')} onClick={this.closeGuide} alt="引导" />
            </div>
          )}
          {!isInMobile && !inTeamsApp && <NPSSurvey />}
          {showColorPicker && <ColorPicker />}
          {/* <AiRecommend /> */}
          {/* {showCompare && wrapDialog(<CompareDialog ref={this.compareDialogRef} />)} */}
          {/* {!hasSignIn && isShowCollaborationSignIn && wrapDialog(<CollaborationSignIn></CollaborationSignIn>)} */}
          {!!showDialog && <SubscriptionMember iconType="warning" visible={showDialog} />}
          {!!showSaveDialog && <FwSaveModal visible={showSaveDialog} />}
          {abnormalAccount && <AbnormalAccountDialog />}
          {
            // 打开pdf文件失败弹框
            isShowNoPdfDialog && (
              <NoPdfDialog
                showDialog={isShowNoPdfDialog}
                onCancel={() => {
                  store.common.setIsShowNoPdfDialog(false);
                }}
              />
            )
          }
          {
            // 打开登录信息失效弹框
            isShowLoginLoseDialog && (
              <LoginLoseDialog
                showDialog={isShowLoginLoseDialog}
                onCancel={() => {
                  store.loginNewStore.signOut();
                }}
              />
            )
          }
          {
            // 打开登录信息失效弹框
            isLoginLoseDialog && (
              <LoginLoseDialog
                showDialog={isLoginLoseDialog}
                onCancel={() => {
                  window.location.reload();
                }}
              />
            )
          }
          {
            /* 显示打开远程文档 */
            showURLInputDialog && (
              <Modal
                width={450}
                closable={true}
                title="打开远程文件"
                visible={showURLInputDialog}
                className="noPdf showURLInputDialog "
                footer={[
                  <Button key="submit" type="primary" onClick={() => this.openUrlFile()}>
                    确定
                  </Button>,
                  <Button
                    key="submitCancel"
                    onClick={() => {
                      store.openUrlFileStore.openURLInputDialog(false);
                    }}>
                    取消
                  </Button>,
                ]}
                onCancel={() => {
                  store.openUrlFileStore.openURLInputDialog(false);
                }}>
                <Spin spinning={this.state.showURLInputDialogLoading} tip={'正在加载文件，请稍候！'} size="large">
                  <p>输入PDF文件的URL地址 </p>
                  <Input
                    onChange={(e) => {
                      this.getUrl(e);
                    }}
                  />
                </Spin>
              </Modal>
            )
          }
          {
            /* mac端云文档 */
            store.docsStore.showMacDocs && (
              <Modal
                width={450}
                closable={true}
                title="福昕云编辑"
                visible={store.docsStore.showMacDocs}
                className="noPdf"
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      store.docStore.macToDocPage = true;
                      store.docsStore.showMacDocs = false;
                      window.open('https://docs.foxitcloud.cn/');
                    }}>
                    确定
                  </Button>,
                  <Button
                    key="submitCancel"
                    onClick={() => {
                      store.docsStore.showMacDocs = false;
                    }}>
                    取消
                  </Button>,
                ]}
                onCancel={() => {
                  store.docsStore.showMacDocs = false;
                }}>
                Mac下使用云文档相关功能需要在新开页面登录云文档，请确保你的云文档已登录,否则将影响程序正常使用。
              </Modal>
            )
          }
          {isShowCustomerServiceDlg && (
            <Modal
              width={566}
              closable={false}
              title=""
              visible={isShowCustomerServiceDlg}
              className="isShowCustomerServiceDlg"
              footer={null}
              onCancel={() => {
                this.hideCustomerService();
              }}>
              <div className="CustomerServiceDlgMain">
                <img
                  className="closeCustomerService"
                  src={require('@/assets/fw_cloud_editor/service/icon_close.png')}
                  onClick={() => {
                    this.hideCustomerService();
                  }}></img>
                <div className="CustomerServiceDlgLeft">
                  <p className="serviceTitle">
                    <img src={require('@/assets/fw_cloud_editor/service/icon_shaomiao.png')}></img>
                    <span className="font-blod">微信扫码联系我们</span>
                  </p>
                  <img src={require('@/assets/fw_cloud_editor/service/img-editWord.png')} />
                </div>
                <div className="CustomerServiceDlgRight">
                  <p className="serviceTitle">
                    <img src={require('@/assets/fw_cloud_editor/service/icon_qq.png')}></img>
                    <span>QQ咨询（点击进入）</span>
                  </p>
                  <h3>800802977</h3>
                  <p className="serviceTitle">
                    <img src={require('@/assets/fw_cloud_editor/service/icon_phone.png')}></img>
                    <span>咨询热线</span>
                  </p>
                  <h3>0591-28026998</h3>
                </div>
              </div>
            </Modal>
          )}
          {
            // 打开远程pdf文件失败弹框
            showURLFailDialog && (
              <NoPdfDialog
                showDialog={showURLFailDialog}
                onCancel={() => {
                  store.openUrlFileStore.isShowURLFailDialog(false);
                }}
              />
            )
          }

          {/* FOXIT 登录弹框注入cookie */}
          {!isMobile && (isMacSsoNoIos || isSafari) && (
            <img
              className="loginCookie"
              src="https://sso.foxitcloud.cn/setCookie?jsonpcallback=jQuery19105057941847274907_1633741696019&name=forIframe&value=yes&_=1633741696020"
            />
          )}
          {!isMobile && !isMacSsoNoIos && !isSafari && (
            <img
              className="loginCookie"
              src="https://sso.foxitreader.cn/setCookie?jsonpcallback=jQuery19105057941847274907_1633741696019&name=forIframe&value=yes&_=1633741696020"
            />
          )}

          {/* <AiRecommend /> */}
          {wrapDialog(<PageTransitionsDialog ref={this.pageTransitionsDialogRef} />)}
          {/* <CreateNewAction ref={this.createNewActionDialogRef} />
                <RunAction ref={this.runActionDialogRef} />
                <ManageActions ref={this.manageActionsDialogRef} createNewActionDialog={this.createNewActionDialogRef} /> */}
          {<PluginInstallDlg></PluginInstallDlg>}
          {/* {isShowPwaTips && wrapDialog(<PwaTipsDlg></PwaTipsDlg>)} */}
          {/* {showRecord&&wrapDialog(<RecordDialog ref={this.recordDialogRef} />)} */}
          {/* {showLegalNotice&&<ESignCNLegalNoticeDialog ref={this.eSignCNLegalNoticeDialogRef} />} */}
          {/* {showMobileWarning && <ESignCNMobileWarningDialog ref={this.eSignCNMobileWarningDialogRef} />} */}
          {/* {showSignType&&wrapDialog(<ESignCNChooseSignTypeDialog ref={this.eSignCNChooseSignTypeDialogRef} />)} */}
          {showEsignChinaGalleryTool && <EsginChinaGalleryTool webSdkParentDom={webSdkParentDom} ref={this.ESignChinaGalleryToolRef} />}
          {/* {showFieldConfirm&&<PasteFieldConfirmDialog ref={this.pasteFieldConfirmDialogRef} />} */}
          {/* {showBingPhone&&wrapDialog(<ESignCNBindPhoneDialog ref={this.ESignCNBindPhoneDialogRef}></ESignCNBindPhoneDialog>)} */}
          {/* {showStampManage&&wrapDialog(<ESignCNOutStampManageDialog ref={this.eSignCNOutStampManageDialogRef}/>)} */}
          {/* {showStampApply&&wrapDialog(<ESignCNOutStampApplyDialog ref={this.eSignCNOutStampApplyDialogRef}/>)} */}
          {isInitSignatureListContainer &&
            wrapDialog(
              <SignatureListContainer
                ref={this.signatureListContainerRef}
                visible={isShowSignatureListContainer}
                signatureListContainerDomInWebSdk={signatureListContainerDomInWebSdk}
                showPreferences={(activeKey) => {
                  this.fileTabRef.current.wrappedInstance.onShowPreferencesDlg(activeKey);
                }}
              />,
            )}

          {/* {store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage && wrapDialog(<StorageDuplicateFileDialog></StorageDuplicateFileDialog>,false)} */}
        </div>
      </Spin>
    );
  }
}
export default EditorContainer;
